export interface VersionChange {
  version: string;
  date: string;
  title: string;
  badge?: string;
  changes: string[];
}

export const CURRENT_VERSION = "4.21.0";
export const ADMIN_EMAIL = "salim.zarepour@gmail.com";

export const isUserAdmin = (email?: string | null): boolean => {
  if (!email) return false;
  return email.trim().toLowerCase() === ADMIN_EMAIL.toLowerCase();
};

export const VERSION_HISTORY: VersionChange[] = [
  {
    version: "4.21.0",
    date: "17 September 2026",
    title: "به‌روزرسانی ۴.۲۱.۰: برنامه‌ریز هوشمند یادگیری زبان و کاشف منابع معتبر وب",
    badge: "برنامه‌ریز و کاشف هوشمند منابع وب v4.21.0 🌍",
    changes: [
      "تبدیل Progress به برنامه‌ریز روزانه، کاشف منابع و مربی هوشمند یادگیری زبان بدون شبیه‌سازی محتوای بسته درون‌برنامه‌ای.",
      "تغییر آنی سطح تسلط (A1 تا C1 نظیر A2 به B1 یا B2) با بازتولید و کالیبراسیون خودکار برنامه بر اساس نیازمندی‌های سطح جدید.",
      "جستجو و معرفی هوشمند منابع معتبر روز دنیا برای هر ۴ مهارت (شنیداری، گفتاری، خوانداری، نوشتاری) همراه با لینک مستقیم به منبع اصلی، دستورالعمل دقیق تمرین و دلیل پداگوژیک انتخاب.",
      "تمرین گفتاری واقعی: تمرین مکالمه و تلفظ با تکیه بر منابع و سرویس‌های خارجی واقعی به جای تمرین متنی جعلی.",
      "سیستم ثبت اتمام تمرین و بازخورد هوشمند: ثبت زمان واقعی صرف‌شده، درجه دشواری (آسان، مناسب، سخت) و میزان مفید بودن منبع مستقیماً در Cloudflare D1.",
      "تمرکز هوشمند تطبیقی (Adaptive Focus): شناسایی خودکار مهارت دارای اولویت بر اساس آمار و تاریخچه عملکرد کاربر.",
      "بهینه‌سازی نمایش داشبورد: نمایش کارت آموزش زبان در داشبورد مشروط به وجود برنامه فعال روزانه (عدم اشغال فضای داشبورد در صورت نبود برنامه)."
    ]
  },
  {
    version: "4.20.0",
    date: "16 September 2026",
    title: "به‌روزرسانی ۴.۲۰.۰: راه‌اندازی سامانه جامع آموزش زبان (Language Learning)",
    badge: "سامانه آموزش زبان مبتنی بر مهارت‌های ۴گانه v4.20.0 🌐",
    changes: [
      "راه‌اندازی ماژول آموزش زبان مبتنی بر ۴ مهارت بنیادین: شنیداری (Listening)، گفتاری (Speaking)، خوانداری (Reading) و نوشتاری (Writing).",
      "تنظیمات زبان مبدأ (فارسی، انگلیسی، سوئدی) و پشتیبانی همزمان از چند زبان هدف با پروفایل، اهداف روزانه و سابقه مجزا.",
      "تولید و انطباق برنامه تمرینی روزانه در Cloudflare D1 با امکان تنظیم دستی دقایق اختصاصی به هر مهارت.",
      "اتاق تمرین تعاملی: تولید خودکار تمرینات تطبیقی با AI (تولید سوالات چندگزینه‌ای، متن، واژگان کلیدی) و امکان استفاده از میکروفون و پخش صوتی (TTS).",
      "سیستم تصحیح هوشمند، نمره‌دهی و ارائه نکات گرامری بر روی متون یا پاسخ‌های صوتی ثبت‌شده توسط کاربر.",
      "پایگاه منابع یادگیری معتبر (اخبار، رادیو، پادکست، مقالات) با قابلیت افزودن لینک‌های شخصی و فیلتر بر اساس مهارت.",
      "یکپارچه‌سازی کامل در داشبورد اصلی: نمایش کارت روزانه تمرین زبان با نوار پیشرفت و دسترسی سریع.",
      "ذخیره‌سازی ۱۰۰٪ پایدار در Cloudflare D1 بدون اتکا به حافظه موقت کلاینت، همراه با پشتیبانی کامل سه‌زبانه (فارسی، انگلیسی، سوئدی)."
    ]
  },
  {
    version: "4.19.0",
    date: "16 September 2026",
    title: "به‌روزرسانی ۴.۱۹.۰: یکپارچه‌سازی کامل حرکات فیزیوتراپی در داشبورد",
    badge: "داشبورد و فیزیوتراپی یکپارچه v4.19.0 🛡️",
    changes: [
      "نمایش کارت برنامه تمرینات فیزیوتراپی در داشبورد مشروط به وجود برنامه در برنامه‌ریزی هفتگی و روال روزانه (پنهان شدن خودکار در روزهای بدون تمرین).",
      "نمایش مستقیم تمام تمرینات و حرکات برنامه‌ریزی‌شده روز جاری در داشبورد بدون نیاز به خروج از صفحه.",
      "قابلیت باز و بسته کردن (Expand/Collapse) لیست کامل فعالیت‌های روز با طراحی ریسپانسیو و روان.",
      "امکان تیک زدن و ثبت وضعیت انجام تمرینات مستقیماً از داخل داشبورد با همگام‌سازی دوطرفه با ماژول فیزیوتراپی.",
      "نوار پیشرفت داینامیک و شفاف (نمایش تعداد و درصد حرکات انجام‌شده مانند ۳ از ۵ حرکت).",
      "امکان مشاهده جزئیات، نکات و ویدئوی آموزشی هر حرکت با کلیک مستقیم در داشبورد."
    ]
  },
  {
    version: "4.18.0",
    date: "16 September 2026",
    title: "به‌روزرسانی ۴.۱۸.۰: مدیریت برنامه‌های روزانه و رفع باگ‌های نمایشی",
    badge: "مدیریت برنامه و نمایش هوشمند v4.18.0 🎯",
    changes: [
      "اضافه شدن قابلیت تیک زدن (تکمیل) حرکات و فعالیت‌ها در بخش برنامه‌های روزانه فیزیوتراپی.",
      "امکان تغییر ترتیب و مرتب‌سازی حرکات (بالا/پایین) در برنامه هر روز بر اساس اولویت کاربر.",
      "رفع مشکل نمایشی متغیرها در صفحه دستیار یادگیری و نمایش صحیح نام سرفصل فعال."
    ]
  },
  {
    version: "4.17.0",
    date: "13 September 2026",
    title: "به‌روزرسانی ۴.۱۷.۰: امکان انتشار حرکات به بانک عمومی D1 برای ادمین، آمار واقعی دیتابیس و امنیت چندلایه‌ای",
    badge: "انتشار ابری D1 و امنیت v4.17.0 🚀",
    changes: [
      "قابلیت انتشار رسمی حرکات شخصی به بانک عمومی (Publish to Global Library) با دیتابیس Cloudflare D1 ویژه حساب کاربری مدیریت (salim.zarepour@gmail.com).",
      "محافظت چندلایه‌ای در سطح سرور و دیتابیس: جلوگیری از ویرایش یا حذف حرکات عمومی توسط کاربران عادی و اعتبارسنجی سمت سرور ایمیل ادمین.",
      "تطبیق و سینک ۱۰۰٪ داینامیک تعداد حرکات (همه، عمومی، شخصی) از داده‌های واقعی دیتابیس بدون ارقام هاردکد شده یا اطلاعات فیک.",
      "پشتیبانی کامل چندزبانه (فارسی، انگلیسی، سوئدی) برای تمام اکشن‌ها، دیالوگ‌های تاییدیه و پیام‌های وضعیت انتشار به بانک عمومی."
    ]
  },
  {
    version: "4.16.0",
    date: "13 September 2026",
    title: "به‌روزرسانی ۴.۱۶.۰: جزئیات کامل تمرینات در برنامه‌های چندروزه و تفکیک بانک حرکات عمومی و شخصی",
    badge: "ویژگی‌های جدید فیزیوتراپی v4.16.0 🌟",
    changes: [
      "نمایش ۱۰۰٪ کامل جزئیات تمرین در برنامه‌های چندروزه فیزیوتراپی (نام، دستورالعمل کامل، عضلات هدف، ست‌ها، تکرارها، زمان استراحت، درجه سختی، احتیاط‌ها، تجهیزات و پخش زنده فیلم/عکس مرتبط بدون ایجاد داده‌های تکراری).",
      "تفکیک شفاف بانک حرکات به دو دسته عمومی (Global) و شخصی (Personal) با نشان‌های گرافیکی متمایز و فیلترهای اختصاصی.",
      "امکان «افزودن به برنامه من» (Add to my program) از طریق مودال کاربردی برای تخصیص مستقیم تمرین به روزهای برنامه‌های چندروزه.",
      "امکان «ایجاد نسخه شخصی» (Create personal copy) برای شبیه‌سازی و شخصی‌سازی حرکات عمومی بدون دستکاری منابع عمومی مشترک.",
      "بهینه‌سازی پاسخ‌های API برای غنی‌سازی خودکار جزئیات تمرینات برنامه‌های چندروزه از جدول مرجع در Cloudflare D1."
    ]
  },
  {
    version: "4.15.0",
    date: "12 September 2026",
    title: "به‌روزرسانی ۴.۱۵.۰: پاکسازی جامع چندزبانه داشبورد و بازطراحی مدرن کارت فعالیت جاری (NOW)",
    badge: "بهینه‌سازی نهایی v4.15.0 🚀",
    changes: [
      "پاکسازی کامل تمام کلمات فارسی هاردکد شده از کل مسیر رندرینگ داشبورد و ماژول‌ها و پیاده‌سازی ۱۰۰٪ داینامیک i18n.",
      "بازطراحی کامل کارت زمان‌بندی زنده (NOW/NEXT Spotlight) به صورت شیشه‌ای و بسیار زیبا منطبق با حالت‌های روشن و تاریک همراه با نمایش انیمیشن وضعیت تکمیل.",
      "رفع موارد هاردکد شده نماد درصد فارسی (٪) و برچسب‌های سقف عددی کالری مصرفی متناسب با تغییرات داینامیک چند زبانه."
    ]
  },
  {
    version: "4.14.0",
    date: "12 September 2026",
    title: "به‌روزرسانی ۴.۱۴.۰: رفع قطعی بارگذاری داده‌های پلنر در داشبورد و پاکسازی جامع i18n پلنر هفتگی",
    badge: "بروزرسانی پایدار v4.14.0 ✨",
    changes: [
      "رفع کامل مشکل همگام‌سازی و بارگذاری داده‌های پلنر ابری (Cloudflare D1) در داشبورد روزانه و اطمینان از نمایش بی‌نقص رخدادهای زمان‌بندی‌شده.",
      "تکمیل جامع سیستم چندزبانه (i18n) در تمام عناوین، دکمه‌ها، فرم‌ها، پیام‌ها و انتخابگرهای روزهای هفته در پلنر هفتگی و پشتیبانی کامل از زبان‌های فارسی، انگلیسی و سوئدی بدون کلمات سخت‌افزار یا جاگانه.",
      "تایید انطباق تقویم میلادی در پلنر هفتگی و هدر ۳ تقویمه در داشبورد مطابق با قوانین سیستم.",
      "تست و تایید عملکرد همگام‌سازی لحظه‌ای وضعیت تکمیل فعالیت‌ها بین پلنر و داشبورد."
    ]
  },
  {
    version: "4.13.0",
    date: "12 September 2026",
    title: "به‌روزرسانی ۴.۱۳.۰: بازطراحی کامل مرکز فرماندهی داشبورد، هدر ۳ تقویمه و استانداردسازی میلادی",
    badge: "داشبورد مدرن v4.13.0 🚀",
    changes: [
      "نمایش همزمان ۳ سیستم تقویم (میلادی، هجری شمسی، هجری قمری) همراه با نام روز هفته در هدر اصلی داشبورد.",
      "تضمین استفاده انحصاری از تقویم میلادی (Gregorian/Miladi) در تمام سایر بخش‌ها و ماژول‌های برنامه از جمله پلنر هفتگی.",
      "بازطراحی کامل visual داشبورد به عنوان مرکز فرماندهی شخص با بنر زنده NOW/NEXT، کارت‌های سلامت یکپارچه و دسترسی سریع به تمام ماژول‌ها.",
      "حذف کامل بخش توضیحات فنی Cloudflare D1 از رابط کاربری پلنر هفتگی جهت ارتقای زیبایی و تمرکز بر کاربری.",
      "پشتیبانی کامل از چندزبانه (i18n) در تمام دکمه‌ها، برچسب‌ها و عناوین داشبورد و پلنر هفتگی."
    ]
  },
  {
    version: "4.12.0",
    date: "۱۲ شهریور ۱۴۰۵ (2026-09-02)",
    title: "به‌روزرسانی ۴.۱۲.۰: بازطراحی جامع و ارتقای کامل پلنر هفتگی (Weekly Planner Redesign) و عمومی‌سازی گزینه‌های فعالیت‌های آموزشی",
    badge: "پلنر هفتگی پیشرفته v4.12.0 📅",
    changes: [
      "بازطراحی کامل و مدرن ماژول برنامه‌ریزی هفتگی (Weekly Planner) با کارت‌های دیداری شکیل، تفکیک زمانی دقیق و نوار محاسباتی آمار و ساعات هفته.",
      "عمومی‌سازی کامل گزینه فعالیت‌های آموزشی در فرم ساخت و ویرایش فعالیت‌ها («این فعالیت آموزشی است (درس/دوره/SFI)») جهت پشتیبانی از دوره‌ها، آموزش زبان سوئدی، موسیقی، برنامه‌نویسی و سایر یادگیری‌ها بدون انحصار به SFI.",
      "افزودن قابلیت جستجو و فیلتر بر اساس دسته‌بندی موضوعی (کاری، فیزیوتراپی، ورزش، آموزشی، تغذیه، روتین شخصی) جهت مدیریت بهتر برنامه‌ها.",
      "تولید و پیش‌فرض‌های سریع زمان‌بندی (Quick Routine Presets) جهت تعریف آسان و یک‌کلیکه الگوهای متداول نظیر شیفت کاری، فیزیوتراپی و مطالعه.",
      "افزودن امکان کپی تک‌تک فعالیت‌ها با یک کلیک به روزهای مختلف هفته (+شنبه، +دوشنبه و...) علاوه بر کپی کامل روز به کل هفته.",
      "ارتقای کارت فعالیت‌ها با نمایش شفاف ساعت شروع و پایان، مدت زمان محاسبه‌شده، برچسب‌های الزامی/اختیاری، سوئیچ‌های تعاملی آلارم موبایل و تقویم گوگل.",
      "تضمین کامل همگام‌سازی ابری با دیتابیس Cloudflare D1، خروجی تقویم استاندارد (.ics)، ورودی صوتی هوشمند فارسی و واکنش‌گرایی برتر در موبایل."
    ]
  },
  {
    version: "4.11.14",
    date: "۱۲ شهریور ۱۴۰۵ (2026-09-02)",
    title: "به‌روزرسانی ۴.۱۱.۱۴: بازسازی کامل داشبورد به عنوان مرکز کنترل موبایل-محور (Mobile-First Command Center) و اتصال پایدار پلنر هفتگی به دیتابیس D1",
    badge: "مرکز فرماندهی پایدار v4.11.14 🚀",
    changes: [
      "طراحی مجدد و فوق‌العاده تمیز داشبورد به عنوان مرکز کنترل روزانه موبایل-محور (Mobile-First Daily Command Center) با خوانایی بالا و دسترسی مستقیم به فعالیت‌های جاری (NOW) و بعدی (NEXT).",
      "اتصال مستقیم و تضمین‌شده داشبورد به رخدادهای زمان‌بندی‌شده پلنر هفتگی در پایگاه داده Cloudflare D1 (scheduled_occurrences) با قابلیت تغییر وضعیت با یک لمس و همگام‌سازی لحظه‌ای.",
      "اصلاح کامل هویت بصری و عنوان ماژول برنامه‌ریزی هفتگی (Weekly Planner & Daily Routine) و رفع انحصار عنوانی کار/SFI به ماژول برنامه‌ریزی جامع زندگی و سلامت.",
      "بهبود کنتراست المان‌ها، دکمه‌های ناوبری روز قبل/بعد و نشانگرهای روزهای هفته در پلنر و داشبورد جهت تجربه کاربری بی‌نقص در محیط‌های تاریک و روشن.",
      "حذف کامل بخش‌ها، درصدها و امتیازهای اضافه و کارت‌های پیش‌بینی پیچیده، و جایگزینی با ردیف شاخص‌های سلامت فشرده (آب، کالری، خواب و وزن)."
    ]
  },
  {
    version: "4.11.13",
    date: "۱۱ شهریور ۱۴۰۵ (2026-09-01)",
    title: "به‌روزرسانی ۴.۱۱.۱۳: تبدیل داشبورد به مرکز کنترل روزانه (Daily Command Center) و حذف کامل امتیازات پیچیده و مصنوعی",
    badge: "مرکز فرماندهی روزانه v4.11.13 🎯",
    changes: [
      "تبدیل کامل داشبورد به مرکز کنترل روزانه (Daily Command Center) با تمرکز خالص بر آنچه باید امروز انجام شود، فعالیت جاری (Now) و فعالیت بعدی (Next Up).",
      "حذف کامل بخش‌ها و برچسب‌های امتیازدهی پیچیده و مصنوعی از داشبورد و گزارش‌ها و جایگزینی آن با وضعیت مستقیم تکمیل برنامه‌ها.",
      "افزودن کارت هوشمند و واکنش‌گرای فعالیت جاری با دکمه اقدام سریع و یک‌کلیکه جهت علامت‌گذاری بلادرنگ به عنوان انجام‌شده.",
      "نمایش کارت فعالیت بعدی بر اساس زمان‌بندی روزانه جهت ارتقای بهره‌وری و حفظ تمرکز کاربر.",
      "تغییر نام و ارتقای کامل ماژول WorkSfiModule به WeeklyRoutineModule جهت بازتاب دقیق مسئولیت‌های جامع‌تر برنامه‌ریزی، شیفت کاری، کلاس سوئدی، روتین‌های روزانه و هفتگی (Renamed WorkSfiModule to WeeklyRoutineModule to accurately reflect its broader weekly routine and scheduling responsibilities)."
    ]
  },
  {
    version: "4.11.12",
    date: "۱۱ شهریور ۱۴۰۵ (2026-09-01)",
    title: "به‌روزرسانی ۴.۱۱.۱۲: ارتقا به سیاست کانونیکال داشبورد v2.3 با شاخص عملکرد روزانه زمان‌محور (Time-Weighted Performance)",
    badge: "عملکرد زمان‌محور v4.11.12 ⏱️",
    changes: [
      "پیاده‌سازی شاخص عملکرد روزانه زمان‌محور (Time-Weighted Daily Performance) به عنوان KPI اصلی داشبورد: (دقایق انجام‌شده / دقایق برنامه‌ریزی‌شده) × ۱۰۰.",
      "جلوگیری هوشمندانه از محاسبه تکراری هم‌پوشانی زمانی وظایف با الگوریتم ادغام بازه‌ها (Interval Union Calculation).",
      "محاسبه و نمایش دقیق درصد وزن زمانی (Time Weight %) و زمان اختصاص‌یافته برای هر وظیفه اجباری در چک‌لیست با روش بزرگ‌ترین باقی‌مانده (Sum to 100%).",
      "تفکیک کامل شاخص درصد عملکرد از تعداد وظایف (Task Counts) و امتیاز عددی فعالیت‌ها (Task Scores 1-10) به عنوان سنجه‌های مکمل.",
      "پشتیبانی از نمایش مجزای دقایق پاداش زمان برای وظایف اختیاری و همگام‌سازی کامل محاسبات کلاینت و سرور."
    ]
  },
  {
    version: "4.11.11",
    date: "۱۱ شهریور ۱۴۰۵ (2026-09-01)",
    title: "به‌روزرسانی ۴.۱۱.۱۱: اتصال زنده پلنر به داشبورد، نمایش شفاف امتیاز فعالیت‌ها و امکان بازنویسی دستی امتیاز (User Override)",
    badge: "پلنر کانونیکال و امتیازدهی v4.11.11 ⭐",
    changes: [
      "یکپارچه‌سازی کامل و همگام‌سازی لحظه‌ای پلنر هفتگی (Weekly Planner) با داشبورد کانونیکال و رفع ناهماهنگی نمایش وظایف روزهای کاری.",
      "نمایش امتیاز خودکار سیستم (Automatic Score) در کارت‌های فعالیت پلنر هفتگی و چک‌لیست روزانه داشبورد بر مبنای مدت زمان و ماهیت وظیفه.",
      "پشتیبانی کامل از بازنویسی دستی امتیاز (User Score Override) در فرم ویرایش فعالیت‌ها با انتخاب امتیاز از ۱ تا ۱۰ و دکمه بازنشانی به خودکار.",
      "امکان تفکیک وظایف الزامی (Standard / Base Score) از وظایف اختیاری دارای امتیاز پاداش (Bonus Score) در تمامی بخش‌های سامانه.",
      "همگام‌سازی بی‌درنگ و خودکار میان weekly_routine_items و جدول کانونیکال planner_tasks و بازتولید لحظه‌ای رخدادهای زمان‌بندی‌شده (Scheduled Occurrences)."
    ]
  },
  {
    version: "4.11.10",
    date: "۱۱ شهریور ۱۴۰۵ (2026-09-01)",
    title: "به‌روزرسانی ۴.۱۱.۱۰: پیاده‌سازی کامل موتور محاسباتی کانونیکال داشبورد و یکپارچه‌سازی ماژول گزارش‌ها با پلنر هفتگی (Dashboard Policy v2.2)",
    badge: "داشبورد کانونیکال و گزارش‌ها v4.11.10 📊",
    changes: [
      "مبدل‌سازی کامل پلنر هفتگی (Weekly Planner) به تنها منبع حقیقت (Single Source of Truth) برای داشبورد و ماژول گزارش‌های تحلیلی.",
      "پیاده‌سازی موتور محاسباتی واحد کانونیکال (Canonical Scoring Engine) در src/lib/scoringEngine.ts جهت برقراری تضمین ۱۰۰ درصدی تطابق محاسبات بین کلاینت و سرور.",
      "حذف کامل فرمول‌های قدیمی و ایزوله‌شده getDailyScore و جایگزینی آن با رخدادهای زمان‌بندی‌شده (Scheduled Occurrences) و وزن‌دهی پویا در ReportsModule.",
      "استانداردسازی معنایی روزهای استراحت (Rest Day / N/A) با مقداردهی دقیق null برای dailyScore و امتیازدهی عادلانه بر اساس Available Points.",
      "افزودن اندپوینت گروهی /api/planner/occurrences/range در بک‌اند جهت دریافت سریع و دقیق متغیرهای تحلیلی بازه‌های زمانی در گزارش‌ها.",
      "پشتیبانی کامل از وظایف موظف، اختیاری با امتیاز پاداش، وظایف لغوشده و اعمال تضمین‌های یکپارچگی داده‌های تاریخی."
    ]
  },
  {
    version: "4.11.9",
    date: "۹ شهریور ۱۴۰۵ (2026-08-31)",
    title: "به‌روزرسانی ۴.۱۱.۹: سامانه مدیریت برنامه‌های تمرینی چندروزه فیزیوتراپی، زمان‌بندی روزها و پشتیبانی کامل از JSON Bulk Import",
    badge: "برنامه‌های چندروزه v4.11.9 🏋️‍♂️",
    changes: [
      "طراحی و پیاده‌سازی کامل سامانه برنامه‌های تمرینی چندروزه (Multi-Day Exercise Programs) در ماژول فیزیوتراپی همراه با تفکیک تب‌های برنامه‌های چندروزه و بانک حرکات تکی.",
      "پشتیبانی کامل از ایجاد، ویرایش، حذف، فعال‌سازی و کپی برنامه‌های تمرینی شامل تعریف روزهای تمرینی مجزا (Program Days) و اختصاص حرکات سفارشی.",
      "امکان اجرای مستقیم تمرینات هر روز در گوینده صوتی هوشمند (Guided Voice Workout Player) بر اساس توالی و تنظیمات همان روز.",
      "یکپارچه‌سازی کامل زمان‌بندی روزهای برنامه‌های تمرینی با برنامه‌ریزی هفتگی (Weekly Planner) از طریق ارجاع مستقیم program_id و program_day_id بدون همپوشانی یا کپی‌برداری داده‌ها.",
      "طراحی پنجره درون‌ریزی ساختاریافته برنامه‌ها با قالب کانونیکال JSON، اعتبارسنجی زنده ساختار داده‌ها و ذخیره‌سازی ابری در جداول exercise_programs و program_days دیتابیس Cloudflare D1.",
      "پشتیبانی کامل چندزبانه (i18n) به زبان‌های فارسی، انگلیسی و سوئدی برای تمامی عناوین، دکمه‌ها، پیام‌های راهنما، گزینه‌های منو و پنجره‌های این سامانه."
    ]
  },
  {
    version: "4.11.8",
    date: "۹ شهریور ۱۴۰۵ (2026-08-31)",
    title: "به‌روزرسانی ۴.۱۱.۸: توسعه سراسری ورودی صوتی و تبدیل گفتار به متن فارسی در ۱۳ بخش کلیدی سامانه",
    badge: "توسعه ورودی صوتی v4.11.8 🎙️",
    changes: [
      "گسترش کامل قابلیت ورودی صوتی و تبدیل گفتار به متن فارسی (Voice Input / Speech-to-Text) مبتنی بر مدل Whisper Large v3 Turbo در ۱۳ ماژول و فرم پرکاربرد برنامه.",
      "افزودن دکمه ضبط صوتی به چک‌لیست روزانه داشبورد، چت مشاور مالی هوشمند، توضیحات تکمیلی یادآورهای خانوادگی، عنوان دفترچه و افزودن کالای خرید.",
      "تجهیز پایشگر اخبار فناوری، مشاوره تخصصی پزشک هوش مصنوعی، شرح وعده و چت هوشمند تغذیه، دستیار تغذیه GLP-1، جزئیات برنامه هفتگی و فیلدهای بیماری، دارو، حساسیت و اهداف سلامتی در تنظیمات.",
      "افزودن ورودی صوتی به بخش طراحی تمرینات فیزیوتراپی (نام حرکت، عضلات هدف و توضیحات کامل حرکت در فرم‌های افزودن و ویرایش) و چت توانبخشی.",
      "تغییر نام تب «مدیریت فایل‌های اشتراکی و R2» به «مدیریت فایل‌های اشتراکی» در دستیار یادگیری و ترجمه‌های سیستم."
    ]
  },
  {
    version: "4.11.7",
    date: "۹ شهریور ۱۴۰۵ (2026-08-31)",
    title: "به‌روزرسانی ۴.۱۱.۷: پیاده‌سازی ورودی صوتی و تبدیل صدا به متن فارسی (Voice Input Version 1) در دستیار یادگیری",
    badge: "ورودی صوتی فارسی v4.11.7 🎙️",
    changes: [
      "پیاده‌سازی نسخه ۱ ورودی صوتی هوشمند (Speech-to-Text Version 1) با استفاده از ضبط استاندارد کلاینت (MediaRecorder API) و ارسال مستقیم باینری صدا به ورکر اختصاصی Cloudflare Whisper Large v3 Turbo.",
      "تعبیه دکمه‌های مجزا و مستقل ضبط صدا برای فیلدهای «عنوان مبحث / موضوع فرعی» و «مباحث و بخش‌های فرعی (یادداشت/توضیحات)» در ماژول دستیار یادگیری و مدیریت منابع.",
      "تشخیص خودکار و پشتیبانی از انواع پسوندهای صوتی مرورگر (audio/webm, audio/ogg, audio/mp4) بدون ذخیره‌سازی داده‌های صوتی روی سرور یا دیتابیس.",
      "مدیریت هوشمند الحاق متن به ورودی‌های حاوی متن قبلی و نمایش تایمر زنده ضبط، انیمیشن پردازش و هشدارهای خطا به زبان فارسی."
    ]
  },
  {
    version: "4.11.6",
    date: "۶ شهریور ۱۴۰۵ (2026-08-28)",
    title: "به‌روزرسانی ۴.۱۱.۶: پایدارسازی کامل تمرینات و فعالیت‌ها در دیتابیس Cloudflare D1 و سامانه درون‌ریزی دسته‌جمعی (JSON Bulk Import)",
    badge: "پایگاه داده D1 و درون‌ریزی v4.11.6 ⚡",
    changes: [
      "ذخیره‌سازی و پایداری ۱۰۰٪ فعالیت‌ها و تمرینات سفارشی در جداول ابری Cloudflare D1 و جلوگیری از پاک شدن داده‌ها با رفرش یا جابجایی بین صفحات.",
      "طراحی و پیاده‌سازی پنجره درون‌ریزی دسته‌جمعی (JSON Bulk Import) با پشتیبانی از استراتژی‌های مدیریت تکرار (Upsert، Skip، Always Insert) و اعتبارسنجی زنده ساختار JSON.",
      "پیاده‌سازی اندپوینت‌های کامل REST API برای دریافت، افزودن، ویرایش، حذف و درج دسته‌جمعی تمرینات (/api/rehab/exercises و /api/rehab/exercises/bulk).",
      "پشتیبانی جامع سه‌زبانه (فارسی، انگلیسی، سوئدی) برای کلیه پیام‌ها، ابزارها و زمان‌بندی پیشرفته یادآورها."
    ]
  },
  {
    version: "4.11.5",
    date: "۶ شهریور ۱۴۰۵ (2026-08-28)",
    title: "به‌روزرسانی ۴.۱۱.۵: امن‌سازی و احراز هویت ارتباط با ورکر هوش مصنوعی با کلید اختصاصی AI_WORKER_SECRET",
    badge: "امنیت ورکر هوش مصنوعی v4.11.5 🔒",
    changes: [
      "افزودن هدر احراز هویت سرور به سرور (Authorization: Bearer) با متغیر محیطی AI_WORKER_SECRET در کلیه فراخوانی‌های سرویس هوش مصنوعی به Cloudflare Worker.",
      "تثبیت و بستن کامل نقاط دسترسی آزاد، جلوگیری از مصرف غیرمجاز سهمیه‌ها و انسداد مسیرهای سواستفاده در ارتباطات هوش مصنوعی.",
      "تضمین حفظ و یکپارچگی کامل معماری نشست‌های امن کلاینت (Session Cookies) بدون افشای کلیدهای محرمانه به مرورگر.",
      "به‌روزرسانی متادیتا و شناسه نسخه سامانه به ۴.۱۱.۵."
    ]
  },
  {
    version: "4.11.4",
    date: "۴ شهریور ۱۴۰۵ (2026-08-26)",
    title: "به‌روزرسانی ۴.۱۱.۴: اعمال سخت‌گیرانه سقف ۶۰۰ کیلوبایت (614,400 بایت) در مرزهای کلاینت، سرور صدور بلیت و ورکر R2",
    badge: "تثبیت مرز ۶۰۰ کیلوبایت v4.11.4 🛡️",
    changes: [
      "اعمال مستقیم اعتبارسنجی ۶۰۰ کیلوبایت (614,400 بایت) در مرز نهایی ذخیره‌سازی R2 در Cloudflare File Worker با کد وضعیت HTTP 413 Payload Too Large.",
      "تطابق صددرصدی فایل ارسالی با فایل فشرده‌شده و بررسی‌شده در کلاینت و تضمین عدم آپلود تصاویر حجیم بالای ۶۰۰ کیلوبایت.",
      "حفظ کامل استقلال و سقف ۵۰ مگابایتی اسناد و فایل‌های ماژول دستیار یادگیری و سایر ماژول‌ها.",
      "جلوگیری قطعی از ساخت رکوردهای متادیتای D1 یا اشیای ابری R2 در صورت عدم تطابق سایز."
    ]
  },
  {
    version: "4.11.3",
    date: "۴ شهریور ۱۴۰۵ (2026-08-26)",
    title: "به‌روزرسانی ۴.۱۱.۳: رفع خطای HTTP 401 Unauthorized در آپلود مستقیم تصاویر پیشرفت وزن به Cloudflare Worker / R2",
    badge: "اصلاح احراز هویت ماژول وزن v4.11.3 🔐",
    changes: [
      "رفع ریشه‌ای خطای 401 Unauthorized در زمان ارسال فایل به POST /upload ورکر R2 از طریق تصحیح اعتبارسنجی نام ماژول در بلیت‌های آپلود امضاشده (isAllowedModule).",
      "افزودن ماژول‌های 'weight' و 'weight_photos' به لیست ماژول‌های مجاز Cloudflare File Worker (cloudflare-file-worker.js).",
      "تضمین سازگاری ۱۰۰٪ با نسخه‌های ورکر رانینگ در پروداکشن از طریق نگاشت شناسه ماژول در ادعاهای بلیت به فضای امن و معتبر سرور ابری.",
      "حفظ کامل محدودیت سخت‌گیرانه ۶۰۰ کیلوبایت (600 KB) و جریان استاندارد سه مرحله‌ای (بلیت امن -> آپلود مستقیم R2 -> نهایی‌سازی D1)."
    ]
  },
  {
    version: "4.11.2",
    date: "۴ شهریور ۱۴۰۵ (2026-08-26)",
    title: "به‌روزرسانی ۴.۱۱.۲: یکپارچه‌سازی و مهاجرت معماری آپلود تصاویر پیشرفت وزن و BMI به استاندارد دستیار یادگیری",
    badge: "معماری مستقیم ابری v4.11.2 🚀",
    changes: [
      "مهاجرت کامل پایپ‌لاین آپلود تصاویر پایش وزن به معماری استاندارد و تست‌شده دستیار یادگیری (Direct Worker Upload Ticket -> Cloudflare R2 -> Server Finalize).",
      "حذف کامل میدل‌ورهای چندبخشی multer و busboy از مسیر آپلود تصاویر وزن و جایگزینی با جریان بلیت معتبر با امضای امنیتی HMAC.",
      "اعمال محدودیت سخت‌گیرانه ۶۰۰ کیلوبایت (600 KB) در هر دو لایه کلاینت (فشرده‌سازی هوشمند) و سرور صدور بلیت آپلود R2.",
      "ثبت و همگام‌سازی بی‌درنگ متادیتا و ارتباط چند تصویر با هر رکورد وزن در پایگاه داده Cloudflare D1 (جدول‌های files و weight_photos).",
      "پشتیبانی یکپارچه از حذف همزمان تصویر از فضای ذخیره‌سازی ابری R2 و رکوردهای پایگاه داده D1."
    ]
  },
  {
    version: "4.11.1",
    date: "۴ شهریور ۱۴۰۵ (2026-08-26)",
    title: "به‌روزرسانی ۴.۱۱.۱: بهینه‌سازی استریم در پایپ‌لاین آزمایشی قبلی",
    badge: "به‌روزرسانی پیشین 🛠️",
    changes: [
      "تلاش‌های اولیه جهت بهینه‌سازی استریم در میدل‌ورهای سرور."
    ]
  },
  {
    version: "4.11.0",
    date: "۴ شهریور ۱۴۰۵ (2026-08-26)",
    title: "به‌روزرسانی ۴.۱۱.۰: ثبت و مقایسه تصویری پیشرفت اندام (Progress Photos & Side-by-Side Comparison)",
    badge: "تصاویر پیشرفت v4.11.0 📸",
    changes: [
      "قابلیت بارگذاری و مدیریت چندین عکس پیشرفت فیزیکی به ازای هر رکورد وزن، BMI و درصد چربی.",
      "فشرده‌سازی هوشمند سمت کلاینت و اعمال محدودیت دقیق ۶۰۰ کیلوبایت (600 KB) جهت بهینه‌سازی ذخیره‌سازی و پهنای باند.",
      "پشتیبانی از انواع زاویه تصویر شامل روبرو (Front)، نیم‌رخ (Side)، پشت (Back) و سایر زوایای اندام.",
      "امکان مقایسه تصویری و شاخصی دو تاریخ مختلف به صورت کنار هم (Side-by-Side Comparison) همراه با محاسبه خودکار تغییرات وزن، BMI و چربی.",
      "استفاده کامل از معماری ایمن و یکپارچه Cloudflare R2 و D1 همراه با لایتباکس پیشرفته برای نمایش بزرگ‌نمایی‌شده تصاویر."
    ]
  },
  {
    version: "4.10.6",
    date: "۴ شهریور ۱۴۰۵ (2026-08-26)",
    title: "به‌روزرسانی ۴.۱۰.۶: استانداردسازی تقویم میلادی در سراسر برنامه (Gregorian Date Audit & Standardization)",
    badge: "تقویم میلادی v4.10.6 📅",
    changes: [
      "استانداردسازی نمایش تاریخ‌ها بر اساس تقویم میلادی (Gregorian/Miladi) در تمامی صفحات و بخش‌های برنامه (به جز داشبورد).",
      "حفظ کامل تقویم‌های چندگانه (شمسی/قمری/میلادی) و فرمت‌های مختلف در داشبورد اصلی برنامه.",
      "ایجاد توابع متمرکز فرمت‌دهی میلادی (formatGregorianDate, formatGregorianDateTime, formatGregorianDateRange) با پشتیبانی زبان‌های فارسی، سوئدی و انگلیسی.",
      "حفظ کامل ساختار داده‌های داخلی، پایگاه داده D1 و پاسخ‌های API بدون دستکاری مقادیر اصلی تاریخ.",
      "اصلاح پارس کردن تاریخ‌های بدون منطقه زمانی (Timezone Safety) جهت جلوگیری از انحراف و تغییر روزها."
    ]
  },
  {
    version: "4.10.5",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۱۰.۵: نهایی‌سازی آپلود مستقیم و مهاجرت کامل دستیار یادگیری به جریان Direct R2 (Phase C + D)",
    badge: "آپلود مستقیم کانونیکال v4.10.5 🚀",
    changes: [
      "پیاده‌سازی اندپوینت نهایی‌سازی POST /api/files/finalize جهت تایید قطعی وجود شیء در Cloudflare R2 و تغییر وضعیت به active.",
      "مهاجرت کامل جریان آپلود پیوست‌های دستیار یادگیری به معماری مستقیم (Direct Upload): بلیت امن -> آپلود باینری مستقیم به File Worker -> نهایی‌سازی در سرور اپلیکیشن.",
      "حذف کامل عبور باینری از پراکسی‌های Cloudflare Pages و Cloud Run برای ماژول یادگیری جهت از بین بردن خطاهای سقط درخواست و قطعی سوکت.",
      "بهینه‌سازی استریم باینری در Cloudflare File Worker با file.stream() و پشتیبانی از متد HEAD و بازه‌های Range.",
      "پاکسازی خودکار رکوردهای نیمه‌کاره رها شده در وضعیت pending_upload بدون تاثیر روی فایل‌های فعال."
    ]
  },
  {
    version: "4.10.4",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۱۰.۴: زیرساخت آپلود مستقیم امن (Phase A + B Direct Upload Tickets & Worker Validation)",
    badge: "آپلود مستقیم امن v4.10.4 🔒",
    changes: [
      "پیاده‌سازی اندپوینت امن صدور بلیت آپلود POST /api/files/ticket با اعتبارسنجی مالکیت سشن و امضای رمزنگاری HMAC-SHA256.",
      "ثبت خودکار رکورد pending_upload در جدول کانونیکال files قبل از صدور بلیت با اعتبارسنجی سقف ۵۰ مگابایت.",
      "به‌روزرسانی File Worker جهت پشتیبانی دوگانه از توکن امن سرور (WORKER_SECRET_TOKEN) و بلیت‌های رمزنگاری‌شده کوتاه‌مدت.",
      "تایید امضا، انقضا، ماژول و انطباق کلید R2 در سطح Worker جهت جلوگیری از دستکاری یا آپلود غیرمجاز."
    ]
  },
  {
    version: "4.10.3",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۱۰.۳: مهاجرت پیوست‌های فایل دستیار یادگیری به سرویس فایل کانونیکال (Phase 3 Learning Assistant Migration)",
    badge: "مهاجرت یادگیری v4.10.3 📚",
    changes: [
      "انتقال آپلودهای باینری دستیار یادگیری به اندپوینت کانونیکال POST /api/files با پارامترهای module='learning' و parentId=sessionId.",
      "تایید امن مالکیت جلسه آموزشی در سطح سرور جهت جلوگیری از دسترسی یا آپلود غیرمجاز کاربران دیگر.",
      "پشتیبانی از خواندن دوگانه (Dual Read) از جدول کانونیکال files و جدول قدیمی learning_attachments جهت سازگاری کامل رو به عقب (Legacy Compatibility).",
      "استفاده از جریان دانلود امن GET /api/files/:fileId/download و حذف کانونیکال DELETE /api/files/:fileId بدون ایجاد آپلودهای تکراری در R2.",
      "مدیریت دقیق خطاهای کانونیکال نظیر FILE_TOO_LARGE، UNAUTHORIZED، FORBIDDEN و INVALID_PARENT."
    ]
  },
  {
    version: "4.10.2",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۱۰.۲: پیاده‌سازی سرویس فایل کانونیکال (Phase 2 Canonical File API + Metadata) با معماری امن D1 و محدودیت ۵۰ مگابایت",
    badge: "سرویس فایل کانونیکال v4.10.2 🗄️",
    changes: [
      "راه‌اندازی اندپوینت‌های کانونیکال POST /api/files، GET /api/files/:fileId، GET /api/files/:fileId/download و DELETE /api/files/:fileId.",
      "تعریف جدول و متادیتای پیشرفته files در دیتابیس Cloudflare D1 با ستون‌های ماژول، parent_id، نام ایمن (safe_name) و چرخه حیات وضعیت (active, pending_upload, marked_for_deletion).",
      "اعمال محدودیت اندازه فایل تا ۵۰ مگابایت در سطح سرور و R2 Worker همراه با پاسخ استاندارد 413 FILE_TOO_LARGE.",
      "تایید دقیق مالکیت کاربر (user_id) و اعتبارسنچی والد (Parent Ownership) برای ماژول‌هایی نظیر دستیار یادگیری و مالی.",
      "استفاده از کلیدهای کانونیکال R2 (users/{userId}/{module}/{fileId}-{safeName}) با پشتیبانی کامل از نام‌های فارسی (مانند جزوه_آموزشی.pdf)."
    ]
  },
  {
    version: "4.10.1",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۱۰.۱: حل قطعی خطای Request aborted مرورگرها و موازی‌سازی پردازش PDF با استریم آپلود",
    badge: "رفع ریشه‌ای Request aborted v4.10.1 ⚡",
    changes: [
      "تعویق زمان پاک‌سازی مقدار ورودی فایل (e.target.value = '') تا زمان اتمام استریم داده، جهت جلوگیری از بسته‌شدن دستگیره فایل مرورگر در طول آپلود.",
      "موازی‌سازی (Parallelization) ارسال آپلود به سرور و استخراج متن PDF با تایم‌اوت غیرمسدودکننده ۳ ثانیه‌ای.",
      "اصلاح سیستم Retry و تفکیک خطاهای واقعی پاسخ HTTP سرور از خطاهای سطح شبکه کلاینت."
    ]
  },
  {
    version: "4.10.0",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۱۰.۰: رفع ریشه‌ای خطای Request aborted و بهبود استریم استقرار فایل‌های PDF و پیوست‌ها",
    badge: "بهینه‌سازی استریم آپلود v4.10.0 ⚡",
    changes: [
      "اصلاح روش ارسال فایل در FormData با جایگزینی متد مستقیم formData.append(name, file, filename) به جای ساخت اشیاء مضاعف new File([file]).",
      "جلوگیری از لغو ناگهانی استریم (Request aborted) مرورگرها در زمان ارسال فایل‌های سنگین یا خواندن هم‌زمان متن PDF.",
      "افزودن قابلیت تلاش مجدد خودکار (Retry) در صورت نوسان لحظه‌ای شبکه در فرآیند ارسال داده‌ها.",
      "ارتقاء مدیریت پیام‌های خطای سرور برای تشخیص و راهنمایی شفاف کاربر هنگام قطع ارتباط."
    ]
  },
  {
    version: "4.9.9",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۹.۹: رفع خطای آدرس دانلود فایل‌ها و تثبیت کامل فرآیند آپلود و پیوست اسناد در دستیار یادگیری",
    badge: "تثبیت آپلود اسناد v4.9.9 📄",
    changes: [
      "رفع کامل خطای ۵۰۰ آپلود فایل‌های خاص (مانند 9281598504.pdf) از طریق کپسوله‌سازی مدیریت خطاهای Multer و تبدیل پاسخ‌های HTML سرور به JSON معتبر.",
      "استخراج هوشمند نام واقعی فایل و حذف پیشوندهای انکودشده (پیوست عمومی) قبل از ذخیره‌سازی نام فایل در دیتابیس D1.",
      "اصلاح تابع ساخت نشانی دانلود فایل‌ها (getWorkerFileUrl) جهت استخراج دقیق شناسه یکتای فایل (UUID) از کلیدهای ذخیره‌سازی R2 و جلوگیری از مسیرهای نامعتبر.",
      "تضمین ذخیره‌سازی و ارسال صریح کلید r2_key در دیتابیس ابری Cloudflare D1 به هنگام افزودن پیوست‌های جدید جلسات آموزشی.",
      "اجرای موفقیت‌آمیز تست‌های نهایی E2E شامل آپلود باینری، ذخیره‌سازی متادیتا در D1، فراخوانی لیست و دانلود کامل فایل با صحت ۱۰۰٪."
    ]
  },
  {
    version: "4.9.8",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۹.۸: پیاده‌سازی پخش‌کننده ویدیوی آنلاین در صفحه جلسه یادگیری و جداسازی کامل لینک‌ها از R2",
    badge: "پخش ویدیو و دستیار یادگیری v4.9.8 🎬",
    changes: [
      "پیاده‌سازی ماژول اختصاصی استخراج و اعتبارسنجی متادیتای ویدیو (YouTube, Aparat, Vimeo, Instagram, Direct Video) بدون آپلود در R2.",
      "تعبیه مستقیم پلیر و پخش‌کننده ویدیویی درون صفحه جلسات آموزشی دستیار یادگیری با پشتیبانی از Responsive Aspect Ratio و پخش روان.",
      "اصلاح اندپوینت‌های ایجاد و دریافت پیوست‌ها در سرور (/api/learning/sessions/:sessionId/attachments) جهت ذخیره‌سازی لینک‌های ویدیو و متادیتا مستقیماً در Cloudflare D1 بدون نیاز به کلید باکت R2.",
      "نمایش دقیق و شفاف متادیتای هوش مصنوعی واقعی (Provider، Model و Response Time برحسب میلی‌ثانیه) در تمامی پیام‌های دریافتی از هوش مصنوعی دستیار یادگیری.",
      "ارتقاء نسخه برنامه به v4.9.8."
    ]
  },
  {
    version: "4.9.7",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۹.۷: اصلاح استخراج لینک‌های یوتیوب و بازیابی متادیتای مدل هوش مصنوعی در دستیار یادگیری",
    badge: "دستیار یادگیری هوشمند v4.9.7 🎓",
    changes: [
      "اصلاح جامع الگوریتم و عبارات باقاعده (Regex) استخراج شناسه ۱۱ رقمی ویدیوهای یوتیوب برای پوشش تمامی فرمت‌ها نظیر youtu.be، واچ با پارامترهای پلی‌لیست (?list=...)، shorts و embed بدون تداخل با پارامترهای اضافی.",
      "بازیابی و برقراری ارتباط متادیتای پاسخ هوش مصنوعی (ارائه‌دهنده Provider، نام مدل Model، و زمان پاسخ‌دهی Response Time) در جلسات آموزشی و پیام‌های تعاملی دستیار یادگیری.",
      "تضمین ذخیره‌سازی و بازیابی صحیح کلید و نشانی اینترنتی فایل‌ها و ویدیوهای آموزشی متصل به جلسات در دیتابیس.",
      "ارتقاء نسخه برنامه به v4.9.7."
    ]
  },
  {
    version: "4.9.6",
    date: "۳ شهریور ۱۴۰۵ (2026-08-24)",
    title: "به‌روزرسانی ۴.۹.۶: بازنشستگی و ابطال کامل اندپوینت‌های ناامن و ترنزیشنال R2 و تقویت امنیت فایل‌ها",
    badge: "ارتقاء امنیت فایل‌ها v4.9.6 🔒",
    changes: [
      "ابطال و بازنشستگی کامل اندپوینت‌های ترنزیشنال و قدیمی /api/r2/upload، /api/r2/file و /api/r2/delete با پاسخ فوری 410 Gone.",
      "حذف کدهای پردازش مستقیم باکت R2، هدرهای باز Access-Control-Allow-Origin و مسیرهای بدون نیاز به احراز هویت در روت‌های قدیمی.",
      "تثبیت و تمرکز تمامی عملیات ذخیره‌سازی، دانلود و حذف فایل‌ها بر روی اندپوینت‌های کانونیکال و احرازشده /api/files/* همراه با بررسی دقیق مالکیت کاربر (Ownership check با user_id).",
      "ارتقاء نسخه برنامه به v4.9.6."
    ]
  },
  {
    version: "4.9.5",
    date: "۱ شهریور ۱۴۰۵ (2026-08-23)",
    title: "به‌روزرسانی ۴.۹.۵: معماری منبع یکتای حقیقت (Single Source of Truth) در Cloudflare D1 برای ماژول خرید و اشتراک‌گذاری همزمان",
    badge: "منبع یکتای حقیقت D1 v4.9.5 🛍️",
    changes: [
      "حذف کامل حافظه موقت و کش‌های محلی فرانت‌اند (in-memory state و singleton lists) و تبدیل Cloudflare D1 به تنها منبع موثق حقیقت.",
      "فراخوانی مستقیم و بلادرنگ کلیه داده‌های لیست خرید و اقلام از دیتابیس D1 هنگام ورود، بارگذاری صفحه، بازگشت از صفحات دیگر و شروع مجدد در iOS.",
      "همگام‌سازی دوطرفه خودکار و موازی متدهای ایجاد، ذخیره، ویرایش، حذف و اشتراک‌گذاری لیست‌ها با ارسال هدرهای ضد کش (Cache-Control: no-store).",
      "حل قطعی مشکل عدم نمایش لیست‌های اشتراکی در حساب همسر/هم‌خانه‌ای و تضمین دسترسی آنی و پایدار به لیست‌ها.",
      "افزودن دکمه بروزرسانی دستی زنده متصل به D1 با بازخورد تصویری آنی.",
      "ارتقاء نسخه برنامه به v4.9.5."
    ]
  },
  {
    version: "4.9.4",
    date: "۱ شهریور ۱۴۰۵ (2026-08-23)",
    title: "به‌روزرسانی ۴.۹.۴: حل کامل مشکل اشتراک‌گذاری لیست خرید و برطرف کردن خطای عدم شناسایی کاربر در Cloudflare D1",
    badge: "اصلاح اشتراک‌گذاری D1 v4.9.4 🛒",
    changes: [
      "اصلاح جامع کوئری کانونی جستجوی کاربر با SQL مستقیم در Cloudflare D1 بر پایه SELECT id, email FROM users WHERE lower(trim(email)) = lower(trim(?)).",
      "رفع خطای عدم شناسایی کاربر ناشی از فراخوانی اندپوینت مدیریتی /api/system/users و دسترسی 403 Forbidden.",
      "ایجاد اندپوینت جدید GET /api/shopping/users/check جهت اعتبارسنجی سریع و امن وجود کاربر در سامانه بدون نیاز به دسترسی ادمین.",
      "همگام‌سازی دوطرفه و هم‌زمان داده‌های اشتراک در هر دو ساختار جدول shopping_list_shares و آرایه JSON ستون shared_with در جدول shopping_lists.",
      "تضمین بقای داده‌های اشتراک‌گذاری پس از Refresh، Hard Refresh، Navigation، Logout و Login مجدد.",
      "تایید صحت عملکرد با اجرای تست واقعی D1 SQL بر روی کاربران موجود و سناریوهای کاربری بدون کاربر.",
      "ارتقاء نسخه برنامه به v4.9.4."
    ]
  },
  {
    version: "4.9.3",
    date: "۱ شهریور ۱۴۰۵ (2026-08-23)",
    title: "به‌روزرسانی ۴.۹.۳: ذخیره‌سازی و بازیابی همه‌جانبه (End-to-End) محاسبه‌گر قد، وزن و کالری هدف روزانه در D1",
    badge: "پایداری کامل D1 v4.9.3 💾",
    changes: [
      "تعریف و اضافه کردن کامل ۱۳ ستون جدید اسکیما به جدول user_settings در دیتابیس Cloudflare D1 (شامل قد، وزن فعلی، وزن هدف، چربی هدف، سن، جنسیت، سطح فعالیت، هدف وزنی، سوابق پزشکی، داروها، آلرژی‌ها، اهداف سلامتی و کالری هدف).",
      "اعمال خودکار مایگریشن ALTER TABLE در هندلر مایگریشن D1 برای به‌روزرسانی جدول‌های موجود بدون از دست رفتن داده‌ها.",
      "اصلاح جامع اندپوینتهای GET /api/settings و PUT /api/settings جهت خواندن، به‌روزرسانی جزئی (Partial Update) و همگام‌سازی کامل با کلیدهای کمل‌کیس و اسنک‌کیس.",
      "تضمین پایداری داده‌ها پس از Hard Refresh، Navigation، Logout و Login مجدد با اتصال کامل متدهای storage.ts و fetchD1Settings در SettingsModule.",
      "ارتقاء نسخه برنامه به v4.9.3."
    ]
  },
  {
    version: "4.9.2",
    date: "۱ شهریور ۱۴۰۵ (2026-08-23)",
    title: "به‌روزرسانی ۴.۹.۲: بازطراحی پاسخگوی ناوبری تاریخ در تغذیه و پشتیبانی کامل سه زبانه (i18n)",
    badge: "بازطراحی UI و i18n v4.9.2 🌐",
    changes: [
      "بازطراحی کامل کنترل‌های انتخاب و ناوبری تاریخ در ماژول مدیریت تغذیه: طراحی UI پاسخگو، مدرن و خوانا برای موبایل و دسکتاپ.",
      "پشتیبانی کامل و جهت‌دار از RTL و LTR در کلیدهای ناوبری روز قبل و بعد (Chevron های متناسب با جهت زبان).",
      "نمایش تاریخ فرمت‌شده و واضح بر اساس زبان انتخاب‌شده (فارسی، سوئدی و انگلیسی) به‌همراه تقویم انتخابی نیتیو و دکمه بازگشت سریع به «امروز».",
      "تکمیل دیکشنری ترجمه‌های بین‌المللی (i18n) در src/lib/i18n.ts و اعمال کامل تابع t() برای تمامی متون، برچسب‌ها و فیلدهای پایش وزن و تغذیه.",
      "تکمیل و به‌روزرسانی پرامپت‌های هوش مصنوعی (Worker AI) به زبان انتخابی کاربر (فارسی، سوئدی، انگلیسی)."
    ]
  },
  {
    version: "4.9.1",
    date: "۱ شهریور ۱۴۰۵ (2026-08-23)",
    title: "به‌روزرسانی ۴.۹.۱: اعتبارسنجی نهایی پایش وزن، درصد چربی و تحلیل هوشمند ترکیب بدن (Worker AI) - وضعیت PASS",
    badge: "تاییدیه نهایی v4.9.1 ✅",
    changes: [
      "تثبیت قطعی جدول weight_measurements به‌عنوان تنها Single Source of Truth برای وزن فعلی و سابقه وزن کاربر در Cloudflare D1.",
      "تضمین خواندن currentWeight فقط از آخرین رکورد واقعی D1 و جلوگیری از ایجاد رکوردهای تکراری یا جعلی در زمان ذخیره تنظیمات عمومی.",
      "تایید وجود ستون body_fat_pct REAL در اسکیما D1 و ذخیره‌سازی/بازیابی دقیق آن در POST /api/weight و PUT /api/weight/:id.",
      "تکمیل هوش مصنوعی ترکیبات بدنی (Worker AI) بر پایه داده‌های واقعی (وزن، قد، BMI، درصد چربی، درصد چربی هدف، روند سوابق) و پاسخگویی به زبان فارسی.",
      "اجرای تست ۱۰ مرحله‌ای اتوماتیک بر روی دیتابیس D1 واقعی و تایید ۱۰۰٪ نتایج و عدم ایجاد رکوردهای تکراری."
    ]
  },
  {
    version: "4.9.0",
    date: "۱ شهریور ۱۴۰۵ (2026-08-23)",
    title: "به‌روزرسانی ۴.۹.۰: تثبیت کامل همگام‌سازی وزن بین تنظیمات عمومی و پایش وزن + سیستم تحلیل هوشمند ترکیب بدن (Worker AI)",
    badge: "نسخه جدید v4.9.0 🧬",
    changes: [
      "تثبیت کانیکال منبع داده وزن (Current Weight): تمام صفحات اپلیکیشن (تنظیمات عمومی، پایش وزن، AI) اکنون وزن فعلی را به‌صورت یکپارچه و زنده از آخرین رکورد جدول weight_measurements دیتابیس Cloudflare D1 دریافت می‌کنند.",
      "همگام‌سازی زنده End-to-End بین «تنظیمات عمومی» و «پایش وزن»: ویرایش وزن در تنظیمات عمومی بلافاصله یک رکورد جدید با تاریخ امروز در weight_measurements ثبت کرده و منبع اصلی را به‌روزرسانی می‌کند.",
      "راه‌اندازی بخش «تحلیل هوشمند ترکیب بدن» (Body Composition AI): متصل به Cloudflare Worker AI جهت تحلیل زنده وزن، درصد چربی، BMI و روند تاریخی کاربر لاگین‌شده.",
      "ارائه خروجی تفکیک‌شده هوش مصنوعی شامل: ۱. تحلیل وزن فعلی، ۲. تحلیل درصد چربی واقعی (با هشدار صریح در صورت عدم ثبت)، ۳. راهکارهای علمی حفظ عضله، ۴. ۳ توصیه عملی اختصاصی.",
      "افزودن دکمه‌های زنده «تحلیل هوشمند وضعیت فعلی» و «چگونه عضله را حفظ کنم؟» با پاسخگویی کاملاً فارسی و پرامپت‌های User-Scoped بدون استفاده از داده‌های MOCK.",
      "اجرای تست‌های نهایی پایداری و همگام‌سازی در D1 و تایید سلامت کامل بیوانفورماتیک و ذخیره‌سازی ابری."
    ]
  },
  {
    version: "4.8.3",
    date: "۱ شهریور ۱۴۰۵ (2026-08-22)",
    title: "به‌روزرسانی ۴.۸.۳: اصلاح و تثبیت کامل صفحه پایش وزن، درصد چربی و شاخص BMI در Cloudflare D1",
    badge: "نسخه جدید v4.8.3 ⚖️",
    changes: [
      "انتقال کامل منبع حقیقت داده‌های وزن و درصد چربی به جدول weight_measurements در پایگاه داده ابری Cloudflare D1",
      "رفع مشکل عدم نمایش داده‌ها در بارگذاری اولیه (Initial Load) از طریق فراخوانی مستقیم API‌های D1 در زمان Mount کامپوننت و حذف کامل وابستگی به localStorage",
      "پشتیبانی کامل از ثبت همزمان وزن (kg)، درصد چربی بدن (٪) و محاسبه خودکار شاخص BMI با قابلیت Upsert بر اساس تاریخ در D1",
      "افزودن امکان مدیریت مشخصات فیزیکی مرجع (قد، وزن هدف و درصد چربی هدف) با ذخیره‌سازی مستقیم در جدول user_settings دیتابیس D1",
      "ارائه نمودار تحلیلی تعاملی (امکان سوییچ بین روند وزن و درصد چربی) و جدول زمانی کامل رکوردهای ثبت‌شده با امکان حذف مستقیم هر رکورد از D1",
      "تحلیل هوشمند علت استپ وزنی (Plateau Diagnostic) متصل به هوش مصنوعی Cloudflare Worker AI جهت ارائه راهکارهای علمی و کلینیکی"
    ]
  },
  {
    version: "4.8.2",
    date: "۱ شهریور ۱۴۰۵ (2026-08-22)",
    title: "به‌روزرسانی ۴.۸.۲: بازبینی و تثبیت کامل صفحه تنظیمات عمومی، پروفایل کاربر و اهداف سلامت در Cloudflare D1",
    badge: "نسخه جدید v4.8.2 ⚙️",
    changes: [
      "تفکیک و تشخیص هوشمند حساب کاربر: خواندن نام، تصویر و ایمیل حساب گوگل از جلسه احرازشده بدون ذخیره‌سازی محلی یا فایربیس",
      "امکان ویرایش و ذخیره‌سازی نام/نام مستعار حساب‌های غیرگوگل در جدول users پایگاه‌داده ابری Cloudflare D1 از طریق اندپوینت PUT /api/auth/profile",
      "ذخیره‌سازی و بازیابی ۱۰۰٪ مستقیم اهداف سلامت (target_calories و target_water) در جدول user_settings دیتابیس D1 بدون هیچ وابستگی به localStorage یا حافظه موقت",
      "تضمین ماندگاری داده‌ها و همگام‌سازی کامل پس از رفرش مرورگر، خروج/ورود مجدد و ورود از سایر دستگاه‌ها",
      "بررسی کامل مسیر UI -> API -> D1 -> GET -> UI برای کلیه فیلدهای عمومی، تقویم، زبان، تم و تنظیمات SMTP",
      "اجرای تست‌های اعتبارسنجی واقعی بر روی اندپوینت‌های REST و تایید ۱۰۰٪ پایداری پایگاه‌داده D1"
    ]
  },
  {
    version: "4.8.1",
    date: "۱ شهریور ۱۴۰۵ (2026-08-22)",
    title: "به‌روزرسانی ۴.۸.۱: تثبیت انحصاری و مستقل ماژول پایش سوئدی و تنظیمات عمومی در Cloudflare D1 و Worker AI",
    badge: "نسخه جدید v4.8.1 🇸🇪",
    changes: [
      "انتقال کامل «ماژول ۴ — پایش یادگیری زبان سوئدی» به Cloudflare D1 به عنوان تنها منبع حقیقت (D1 Tables: swedish_daily_progress & swedish_ai_tips_history)",
      "اتصال مستقیم سیستم تولید توصیه‌های روزانه زبان سوئدی به Cloudflare Worker AI پروژه با قابلیت تولید هوشمند نکات گرامری و واژگان تخصصی",
      "انتقال کامل «تنظیمات عمومی و ساعت یادآورها» به دیتابیس ابری Cloudflare D1 از طریق APIهای کاربرمحور /api/settings",
      "حذف کامل هرگونه ذخیره‌سازی محلی (localStorage / IndexedDB) در هر دو صفحه با حفظ تفکیک و استقلال کامل دو صفحه از یکدیگر",
      "تضمین ماندگاری ۱۰۰٪ داده‌ها پس از رفرش، ورود و خروج، تغییر دستگاه و ناوبری بین صفحات بر اساس Google UID کاربر احرازشده",
      "انجام اعتبارسنجی کامل E2E، تست‌های ایزولاسیون داده‌ها بین کاربران مختلف (Cross-user Isolation) و عدم تداخل اندپوینت‌ها"
    ]
  },
  {
    version: "4.8.0",
    date: "۱ شهریور ۱۴۰۵ (2026-08-22)",
    title: "به‌روزرسانی ۴.۸.۰: اعتبارسنجی جامع و تثبیت ۱۰۰٪ ماژول برنامه ریزی هفتگی، ساعت کاری و روال روزانه در Cloudflare D1",
    badge: "نسخه جدید v4.8.0 📅",
    changes: [
      "تثبیت پایگاه داده Cloudflare D1 به عنوان تنها منبع مرجع حقیقت (Single Source of Truth) برای جدول weekly_routine_items",
      "پشتیبانی کامل از کلیه اندپوینت‌های استاندارد REST API شامل GET /api/weekly-routine، GET /api/weekly-routine/:id، POST، PUT و DELETE با پشتیبانی از شناسه نسخه (version) و زمان‌های دقیق ثبت",
      "ذخیره‌سازی و پایش ۱۰۰٪ مستقیم فیلدهای جدید description، phone_notification_enabled، went_to_work_checked، attended_sfi_checked و version در D1",
      "تضمین امنیت ایزولاسیون کامل داده‌ها بین کاربران (Multi-tenant Security Isolation)، رد دسترسی و بازگرداندن 404 در صورت درخواست دسترسی غیرمجاز کاربر B به داده‌های کاربر A",
      "حذف کامل ذخیره‌سازی در localStorage، IndexedDB و شیءهای fallback محلی برای این ماژول جهت فراخوانی مستقیم و بی‌واسطه از D1 پس از هر Refresh و ناوبری",
      "انجام تست‌های خودکار کامل واقعی End-to-End شامل CRUD، اعتبارسنجی D1، امنیت Cross-user و پایداری داده‌ها"
    ]
  },
  {
    version: "4.7.9",
    date: "۱ شهریور ۱۴۰۵ (2026-08-22)",
    title: "به‌روزرسانی ۴.۷.۹: تثبیت کامل دیتابیس Cloudflare D1 و رفع خطای ۵۰۰ ماژول برنامه‌های غذایی فصلی GLP-1",
    badge: "نسخه قدیمی v4.7.9 🥑",
    changes: [
      "رفع ریشه‌ای خطای HTTP 500 در اندپوینت /api/meal-plans ناشی از عدم وجود جدول در پایگاه داده Cloudflare D1",
      "طراحی و پیاده‌سازی اسکیمای استاندارد و تمیز جداول meal_plans و meal_plan_items با ایندکس‌های اختصاصی و روابط کلید خارجی Cascading",
      "پشتیبانی کامل از تمامی ۱۰ اندپوینت CRUD برنامه‌های غذایی (GET/POST/PUT/DELETE برنامه‌ها و آیتم‌ها) با اعتبارسنجی دقیق داده‌ها",
      "تفکیک و ایزوله‌سازی شفاف برنامه‌های عمومی و پیش‌فرض سیستم (Templates) از برنامه‌های شخصی کاربران با حفظ محدودیت‌های دسترسی",
      "تضمین ۱۰۰٪ امنیت و تفکیک چندکاربره (Multi-tenant Isolation) بر اساس User ID / Google UID نشست احرازشده بدون امکان دسترسی غیرمجاز بین کاربران",
      "حذف کامل هرگونه وابستگی به حافظه محلی موقت (localStorage / IndexedDB) و تثبیت D1 به عنوان تنها منبع مرجع حقیقت (Single Source of Truth)",
      "ذخیره‌سازی و بازیابی خودکار و بلادرنگ تغییرات منوهای فصلی، عادات سلامتی سفارشی و وضعیت تیک عادات در D1 و تضمین پایداری پس از رفرش و ناوبری"
    ]
  },
  {
    version: "4.7.8",
    date: "۱ شهریور ۱۴۰۵ (2026-08-22)",
    title: "به‌روزرسانی ۴.۷.۸: اصلاح نهایی معماری Hydration و تثبیت انحصاری آب در Cloudflare D1",
    badge: "نسخه جدید v4.7.8 💧",
    changes: [
      "تبدیل Cloudflare D1 به عنوان تنها منبع مرجع حقیقت (Single Source of Truth) برای ثبت و پیگیری آب مصرفی روزانه",
      "استفاده انحصاری و مستقیم از ستون استاندارد daily_records.water_intake_ml و حذف کامل ستون قدیمی و کدهای موقت COALESCE/Fallback",
      "حذف هرگونه ذخیره‌سازی محلی دائمی (localStorage / IndexedDB / in-memory persistence) برای داده‌های آب مصرفی",
      "پیاده‌سازی ذخیره‌سازی مستقیم و بلادرنگ در D1 هنگام کلیک روی دکمه‌های ۱ لیوان (+۲۵۰ml) و کاهش آب (-۲۵۰ml) با کنترل حداقل صفر",
      "همگام‌سازی مستقیم مقدار targetWater از تنظیمات کاربر (user_settings.target_water) در Cloudflare D1 با مقدار پیش‌فرض ۲۰۰۰ میلی‌لیتر",
      "تضمین ۱۰۰٪ خواندن مقادیر به‌روز از D1 هنگام رفرش مرورگر، تعویض تب‌ها، جابجایی بین صفحات و ورود مجدد",
      "ساده‌سازی و یکنواخت‌سازی کامل کوئری‌های SQL پیرامون daily_records و حفظ کامل امنیت احراز هویت Google UID بدون وابستگی به فایربیس"
    ]
  },
  {
    version: "4.7.7",
    date: "۳۱ مرداد ۱۴۰۵ (2026-08-22)",
    title: "به‌روزرسانی ۴.۷.۷: تثبیت کامل سرتاسری مدیریت تغذیه، ثبت D1 و ماندگاری تاریخچه چت دستیار هوشمند",
    badge: "نسخه جدید v4.7.7 🥗",
    changes: [
      "تثبیت و راه‌اندازی کامل پایگاه‌داده Cloudflare D1 برای ماژول تغذیه با پشتیبانی کامل از عملیات‌های CRUD در اندپوینت‌های /api/nutrition",
      "حل ریشه‌ای مشکل پاک شدن اطلاعات تغذیه پس از رفرش و تعویض صفحه با همگام‌سازی دوطرفه رکوردهای روزانه و جدول nutrition_entries در D1",
      "ایجاد جدول جدید و استاندارد ai_chat_messages در Cloudflare D1 با ایندکس اختصاصی جهت ذخیره‌سازی دائمی تاریخچه گفتگوهای دستیار هوشمند تغذیه",
      "اتصال و کالیبراسیون مستقیم قابلیت تحلیل اتوماتیک هوش مصنوعی (AI Nutrition Estimation) و چت تغذیه با Cloudflare Worker AI",
      "فعال‌سازی قابلیت اعمال ۱-کلیکه وعده‌های پیشنهادی هوش مصنوعی در دفترچه و ذخیره‌سازی بلادرنگ در D1",
      "تضمین امنیت کامل ایزوله‌سازی چندکاربره (Multi-tenant Isolation) با اعتبارسنجی انحصاری نشست‌ها بر پایه Google UID / User ID"
    ]
  },
  {
    version: "4.7.6",
    date: "۳۰ مرداد ۱۴۰۵ (2026-08-21)",
    title: "به‌روزرسانی ۴.۷.۶: تثبیت کامل پایداری داده‌ها در Cloudflare D1، حل ریشه‌ای یادآورها، بهینه‌سازی هدرهای امنیتی COOP و پاکسازی فایربیس",
    badge: "نسخه جدید v4.7.6 🚀",
    changes: [
      "حل ریشه‌ای مشکل ذخیره‌سازی و بازیابی یادآورها (Reminders) با اضافه کردن فیلدهای جدید schema به دیتابیس D1 و پر کردن همزمان ستون‌های جدید و قدیمی جهت رفع خطای NOT NULL constraint",
      "اعمال COALESCE در تمام کوئری‌های SELECT یادآورها برای خروجی یکپارچه due_date، due_time و assigned_family_member_id",
      "اصلاح کامل ذخیره‌سازی مخاطبین خانوادگی (contactsStorage) و انتقال ۱۰۰٪ آن از LocalStorage به دیتابیس ابری Cloudflare D1 در مسیر /api/family-members",
      "حذف کامل و ۱۰۰٪ کتابخانه‌ها و ارجاعات فایربیس (Firebase) و تثبیت پلتفرم روی احراز هویت گوگل و پایگاه‌داده Cloudflare D1",
      "تنظیم هدرهای Cross-Origin-Opener-Policy (same-origin-allow-popups) و Content-Security-Policy برای ارتباط بی‌نقص پنجره‌های شناور Google OAuth postMessage",
      "ارزیابی و تست موفقیت‌آمیز ۱۶ ماژول اصلی برنامه (رکورد روزانه، فعالیت‌ها، وظایف، لیست خرید، یادآورها، رادار خبری، دستیار یادگیری، تمرینات توانبخشی، مخاطبین خانوادگی، تنظیمات، تغذیه، پایش وزن، برنامه هفتگی، فایل‌ها، مشاوره پزشکی، برنامه غذایی فصلی)"
    ]
  },
  {
    version: "4.7.5",
    date: "۳۰ مرداد ۱۴۰۵ (2026-08-21)",
    title: "به‌روزرسانی ۴.۷.۵: استحکام‌بخشی و اصلاح ریشه‌ای نشست‌های کاربری (Session) در Cloudflare Worker و D1",
    badge: "نسخه جدید v4.7.5 🔒",
    changes: [
      "اصلاح احراز هویت session در Cloudflare Worker و پشتیبانی دوگانه از فرمت‌های زمانی ISO 8601 و SQLite در اعتبارسنجی نشست‌ها",
      "جلوگیری از تبدیل خطاهای D1 احراز هویت به 401 گمراه‌کننده و بازگرداندن وضعیت صحیح 500 در زمان وقوع اختلالات پایگاه‌داده",
      "بهبود بازیابی progress_session با اصلاح تجزیه هدر Cookie و پشتیبانی از مقادیر محصور در کوتیشن",
      "اصلاح ناسازگاری ساختار پاسخ احراز هویت در فرانت‌اند (پشتیبانی یکپارچه از response.user و response.data?.user)",
      "بهبود سازگاری stream adapter و mock socket در Cloudflare Worker جهت ارسال بدون نقص جریان درخواست‌های بدنه (Body)",
      "حفظ احراز هویت مبتنی بر HttpOnly Cookie، امن‌سازی SameSite=Lax و Path=/",
      "حفظ هشینگ SHA-256 توکن‌های نشست و عدم ذخیره‌سازی هیچ‌گونه توکن خام در LocalStorage/SessionStorage",
      "حفظ کامل امنیت ایزوله‌سازی چندمستاجری (Tenant Isolation) و بررسی انقضا و ابطال نشست‌ها"
    ]
  },
  {
    version: "4.7.4",
    date: "۳۰ مرداد ۱۴۰۵ (2026-08-21)",
    title: "به‌روزرسانی ۴.۷.۴: رفع نهایی باگ کراش زمان اجرای ورکر کلودفلر پیجز با اصلاح تابع createRequire",
    badge: "اصلاحی حیاتی v4.7.4 🔥",
    changes: [
      "اصلاح اساسی تابع createRequire در هدر تولیدی ورکر و تغییر پارامتر import.meta.url به آدرس استاتیک استاندارد file:///index.js جهت جلوگیری از پرتاب خطای TypeError زمان راه‌اندازی ماژول کلودفلر",
      "تایید صحت و راه‌اندازی بی‌نقص اندپوینت‌های تشخیصی /__worker_test و /api/cloudflare-debug بر روی لوکال هاست ورکر",
      "تضمین هدایت صحیح درخواست‌های POST به سمت /api/* و بازگشت موفقیت‌آمیز داده‌های JSON در بستر پلتفرم ابری"
    ]
  },
  {
    version: "4.7.3",
    date: "۳۰ مرداد ۱۴۰۵ (2026-08-21)",
    title: "به‌روزرسانی ۴.۷.۳: رفع کامل باگ شبیه‌سازی ماژول‌ها و راه‌اندازی تست‌های تشخیصی مستقیم",
    badge: "اصلاحی حیاتی v4.7.3 🔥",
    changes: [
      "رفع مشکل کراش لود ماژول به کمک شبیه‌سازی نیتیو require در هدر ورکر مبتنی بر createRequire و رفع قطعی خطای Dynamic require of ... is not supported",
      "افزودن اندپوینت تشخیصی خام برای ورکر در مسیر /__worker_test مستقل از اکسپرس و D1 جهت آزمایش مسیریابی لایه کلودفلر پیجز",
      "انتقال مستقیم اندپوینت عیب‌یابی /api/cloudflare-debug و تست پست کلودفلر /api/auth/google-test به قبل از لایه پردازش اکسپرس جهت ایزوله‌سازی کامل جریان",
      "اطمینان از عملکرد خنثی و بای‌پاس کامل Service Worker در قبال تمام ریکوئست‌های تحت /api/* بدون اختلال در کش دارایی‌های استاتیک"
    ]
  },
  {
    version: "4.7.2",
    date: "۳۰ مرداد ۱۴۰۵ (2026-08-21)",
    title: "به‌روزرسانی ۴.۷.۲: رفع کامل تداخل مسیریابی ای‌پی‌آی و تکمیل مهاجرت ورکر کلودفلر",
    badge: "نسخه جدید v4.7.2 🚀",
    changes: [
      "حذف کامل فایل _redirects و جایگزینی با فایل پیکربندی _routes.json به منظور رفع تداخل مسیریابی و خطای 405 Method Not Allowed برای درخواست‌های POST",
      "تعریف صریح شامل بودن تمام درخواست‌ها (/*) در ورکر و استثنا کردن دارایی‌های استاتیک جهت استفاده حداکثری از CDN کلودفلر",
      "افزودن اندپوینت عیب‌یابی /api/cloudflare-debug جهت تایید لحظه‌ای صحت کارکرد و درستی هدایت ترافیک به ورکر",
      "افزودن و همگام‌سازی فایل‌های تنظیمات wrangler.jsonc و wrangler.toml در باندل توزیع جهت تضمین فعال‌سازی قابلیت nodejs_compat"
    ]
  },
  {
    version: "4.7.1",
    date: "۳۰ مرداد ۱۴۰۵ (2026-08-21)",
    title: "به‌روزرسانی ۴.۷.۱: رفع کامل عدم‌سازگاری‌های ورکر کلودفلر و بهینه‌سازی ایمپورت‌های نیتیو",
    badge: "نسخه جدید v4.7.1 🛠️",
    changes: [
      "افزودن فایل پیکربندی wrangler.jsonc در ریشه پروژه جهت فعال‌سازی قابلیت nodejs_compat",
      "اصلاح تمام ایمپورت‌های ماژول‌های داخلی نودجی‌اس (path, fs, crypto) به فرمت استاندارد کلودفلر (node:*)",
      "حفظ کامل سازگاری پلتفرم Express در لبه کلودفلر بدون تغییر در معماری دیتابیس ابری D1 و R2 و هوش مصنوعی"
    ]
  },
  {
    version: "4.7.0",
    date: "۳۰ مرداد ۱۴۰۵ (2026-08-21)",
    title: "به‌روزرسانی ۴.۷.۰: مهاجرت کامل به Cloudflare Pages Advanced Mode",
    badge: "نسخه جدید v4.7.0 ⚡",
    changes: [
      "پیاده‌سازی آداپتور سرورلس در src/worker.ts جهت ران کردن کامل Express روی لبه کلودفلر بدون نیاز به سرورهای Node.js",
      "بسته‌بندی یکپارچه فرانت‌اند و کدهای بک‌اند به عنوان تک‌ورکر _worker.js در ریشه خروجی صفحات کلودفلر",
      "حذف ریدایرکت‌های اضافه و پروکسی‌های معکوس جهت بهبود سرعت لودینگ و حل خطای 405 Method Not Allowed"
    ]
  },
  {
    version: "4.6.1",
    date: "۲۹ مرداد ۱۴۰۵ (2026-08-20)",
    title: "به‌روزرسانی ۴.۶.۱: پشتیبانی کامل چندزبانه مخاطبین و بازیابی پایدار برنامه‌ریزی هفتگی از دیتابیس",
    badge: "نسخه جدید v4.6.1 🌐",
    changes: [
      "پشتیبانی کامل چندزبانه (فارسی، انگلیسی و سوئدی) برای بخش مدیریت مخاطبین تاییدشده و پنجره اشتراک‌گذاری",
      "همگام‌سازی لحظه‌ای برنامه‌ریزی هفتگی، روال روزانه و ساعات کاری بر اساس شناسه کاربری مستقیم از دیتابیس ابری",
      "حل مشکل بازنشانی داده‌ها: همگام‌سازی مجدد داده‌ها پس از ورود کاربر و جلوگیری از اوررایت شدن داده‌های خالی با داده‌های کاربر",
      "اشتراک زنده (Subscription Engine) میان تغییرات تنظیمات در دیتابیس ابری و تمام کامپوننت‌های برنامه"
    ]
  },
  {
    version: "4.6.0",
    date: "۲۹ مرداد ۱۴۰۵ (2026-08-20)",
    title: "به‌روزرسانی ۴.۶.۰: اعتبارسنجی دقیق حساب کاربران و حریم خصوصی مخاطبین",
    badge: "نسخه جدید v4.6.0 🔒",
    changes: [
      "اعتبارسنجی زنده آدرس ایمیل: عدم امکان افزودن مخاطب یا اشتراک‌گذاری دفترچه با ایمیل‌های غیرفعال یا ثبت‌نشده در اپلیکیشن",
      "ارتقای حریم خصوصی: حذف کامل لیست عمومی تمامی کاربران اپلیکیشن و نمایش انحصاری مخاطبین تاییدشده و افزوده‌شده توسط خود کاربر",
      "جلوگیری از افزودن ایمیل شخصی خود کاربر به عنوان مخاطب یا گیرنده اشتراک",
      "نمایش پیام‌های راهنمای شفاف و امنیتی در صورت عدم یافتن آدرس ایمیل در سامانه پیشرفت"
    ]
  },
  {
    version: "4.5.9",
    date: "۲۹ مرداد ۱۴۰۵ (2026-08-20)",
    title: "به‌روزرسانی ۴.۵.۹: سیستم مدیریت مخاطبین تاییدشده و اشتراک‌گذاری ۱-کلیکه دفترچه‌ها",
    badge: "نسخه جدید v4.5.9 🚀",
    changes: [
      "امکان تعریف و ذخیره‌سازی مخاطبین تاییدشده (همسر، هم‌خانه‌ای، اعضای خانواده و همکاران) با نام، ایمیل و عنوان نسبت",
      "اشتراک‌گذاری ۱-کلیکه دفترچه‌های خرید و لیست‌های هوشمند با انتخاب مستقیم از لیست مخاطبین بدون نیاز به تایپ مجدد ایمیل",
      "پیشنهاد خودکار و ۱-کلیکه کاربران فعال اپلیکیشن جهت اشتراک‌گذاری سریع",
      "ذخیره خودکار ایمیل‌های جدید در مخاطبین تاییدشده هنگام ارسال اشتراک جهت استفاده‌های بعدی",
      "پنجره اختصاصی مدیریت مخاطبین (افزودن، حذف، جستجو و دسته‌بندی) همگام‌سازی‌شده با پایگاه داده ابری"
    ]
  },
  {
    version: "4.5.8",
    date: "۲۹ مرداد ۱۴۰۵ (2026-08-20)",
    title: "به‌روزرسانی ۴.۵.۸: بازیابی انحصاری داده‌ها از پایگاه داده ابری و حذف کامل LocalStorage",
    badge: "نسخه جدید v4.5.8 🚀",
    changes: [
      "حذف کامل ذخیره‌سازی و خواندن داده‌ها، تنظیمات و یادآورها از حافظه محلی مرورگر (LocalStorage) جهت انحصار ۱۰۰٪ پایگاه داده ابری (Cloud Database)",
      "افزودن سیستم تشخیص قطع اینترنت (Offline Shield) و مسدودسازی دسترسی برنامه در صورت عدم اتصال به شبکه",
      "نمایش صفحه اختصاصی «عدم اتصال به اینترنت» و الزام اتصال به اینترنت جهت بارگذاری مستقیم اطلاعات از دیتابیس ابری",
      "همگام‌سازی لحظه‌ای تمام تغییرات و تنظیمات مستقیماً با پایگاه داده ابری Cloudflare D1 بدون واسطه محلی"
    ]
  },
  {
    version: "4.5.7",
    date: "۲۹ مرداد ۱۴۰۵ (2026-08-20)",
    title: "به‌روزرسانی ۴.۵.۷: تنظیمات عمومی و همگام‌سازی ابری",
    badge: "نسخه v4.5.7",
    changes: [
      "ذخیره‌سازی و بازیابی دائمی تنظیمات عمومی و ساعت یادآورها در مرورگر (LocalStorage) جهت جلوگیری از بازنشانی (Reset) هنگام خروج، بازکردن مجدد یا ریفرش برنامه",
      "ذخیره‌سازی آنی (Auto-Save) به محض تغییر ساعت یادآورها یا فعال/غیرفعال کردن سوئیچ‌ها",
      "همگام‌سازی دوطرفه خودکار تنظیمات با پایگاه داده ابری (Cloudflare D1) در هنگام راه‌اندازی برنامه"
    ]
  },
  {
    version: "4.5.6",
    date: "۲۹ مرداد ۱۴۰۵ (2026-08-20)",
    title: "به‌روزرسانی ۴.۵.۶: بهینه‌سازی سرعت لودینگ اپلیکیشن و حذف کامل تاخیر اولیه بارگذاری (Instant Frame-1 Launch)",
    badge: "نسخه v4.5.6",
    changes: [
      "بهینه‌سازی مقداردهی اولیه حساب کاربری به صورت همزمان (Synchronous Initialization) برای رندر آنی برنامه روی اولین فریم (Frame-1)",
      "حذف تاخیر چرخه حالت احراز هویت (Auth Loading) جهت رندر بدون وقفه داشبورد و برنامه‌ها به محض لمس آیکون برنامه",
      "انتقال تمام همگام‌سازی‌های ابری به پردازش‌های پس‌زمینه (Background Microtasks) بدون مسدودسازی رابط کاربری"
    ]
  },
  {
    version: "4.5.5",
    date: "۲۹ مرداد ۱۴۰۵ (2026-08-20)",
    title: "به‌روزرسانی ۴.۵.۵: حل مشکل صفحه سفید هنگام اجرا روی دستگاه‌های iOS/Safari و افزودن اسپلاش‌اسکرین نیتیو فوری",
    badge: "نسخه v4.5.5",
    changes: [
      "افزودن اسکریپت تشخیص فوری تم (Pre-hydration Theme Detection) در HTML جهت هماهنگ‌سازی فوری پس‌زمینه در حالت‌های تاریک/روشن iOS پیش از اجرای جاوااسکریپت",
      "افزودن صفحه بارگذاری نیتیو و سبُک (Instant Native Splash Screen) حاوی لوگوی برنامه و انیمیشن لودر در فایل index.html برای حذف کامل فلاش صفحه سفید",
      "پشتیبانی کامل از متا تگ‌های سازگار با PWA و iOS Safari با رنگ‌های تطبیق‌پذیر `theme-color` برای نوار وضعیت و حالت‌های صفحه نمایش"
    ]
  },
  {
    version: "4.5.4",
    date: "۲۹ مرداد ۱۴۰۵ (2026-08-19)",
    title: "به‌روزرسانی ۴.۵.۴: محاسبه دقیق خالص موازنه کارت‌های اعتباری (- و +) و محدودسازی دسترسی بخش‌های مدیریتی",
    badge: "نسخه v4.5.4",
    changes: [
      "محاسبه کارکرد و موازنه کارت‌های اعتباری و بانکی به صورت خالص (مجموع هزینه‌ها (-) منهای دریافتی‌ها و واریزی‌ها (+)) در نمای کلی و تراکنش‌ها",
      "نمایش جزئیات هزینه‌کرد و دریافتی به تفکیک کارت‌ها (مانند کارت اعتباری Norwegian) جهت ارزیابی دقیق موازنه مالی",
      "انحصار دسترسی بخش‌های 'مرجع متغیرها و ترجمه‌ها' و 'مدیریت و پایش کاربران سیستم' صرفاً به مدیر سیستم (salim.zarepour@gmail.com)"
    ]
  },
  {
    version: "4.5.3",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۵.۳: حل ریشه‌ای استخراج خطاهای پارسر محلی در اسکن فاکتورها، ایجاد مرز صریح برای بخش جمع کل و حذف کامل فیلدهای متادیتا",
    badge: "نسخه جدید v4.5.3 🚀",
    changes: [
      "تعریف مرز پایان اقلام (Footer Boundary Regex) به محض رسیدن به واژه‌های Totalt، Total ex. moms، Paid amount و Auktoriseringskod جهت جلوگیری کامل از ورود اقلام اشتباه با شماره فاکتور یا کد پیگیری",
      "الگوی جدید پارس جداول فروشگاهی فاکتورهای B2C (مانند Elgiganten/Kivra) با شناسه کالا (Article Number Regex)، نام کالا، قیمت واحد و تخفیف",
      "عبور الزامی خروجی پارسر محلی از متد `normalizeInvoicePayload` جهت اعمال یکپارچه فیلترهای صحت اقلام و نرمال‌سازی مبالغ"
    ]
  },
  {
    version: "4.5.2",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۵.۲: پشتیبانی کامل از اعداد هزارگان اروپایی/سوئدی (فاصله بین ارقام) و فیلتر متادیتا و مبالغ نهایی فاکتورها (مانند Elgiganten)",
    badge: "نسخه v4.5.2",
    changes: [
      "افزودن تابع پارسر اعداد European & Swedish (`cleanAndParseFloat`) جهت تبدیل دقیق فرمت‌های مبالغ با فاصله هزارگان (مانند 8 990,00 -> 8990 و 9 489,00 -> 9489)",
      "افزودن فیلتر هوشمند متادیتا (`isRealLineItem`) جهت تفکیک دقیق کالاهای واقعی خرید (مانند Roborock Saros 20, Bosch Flexpannset, Parcel on door) از متون جمع کل، مالیات، شماره فاکتور و اطلاعات کارت",
      "ارتقاء پرامپت هوش مصنوعی Cloudflare Worker برای شناسایی دقیق فاکتورهای فروشگاهی و الکترونیکی (Elgiganten, Willys, ICA, IKEA) و استخراج تاریخ‌های فرمت DD.MM.YYYY"
    ]
  },
  {
    version: "4.5.1",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۵.۱: ارتقاء استخراج متنی لایه‌ای و جدولی اسناد PDF فاکتور، پشتیبانی مستقیم از شیء فایل و رندر Canvas OCR چند لایه",
    badge: "نسخه v4.5.1",
    changes: [
      "حفظ ساختار سطور و جداول فاکتورهای PDF با گروه‌بندی مختصاتی (Y-coordinate line sorting) جهت جداسازی دقیق ستون‌های اقلام، مقادیر و مبالغ",
      "پشتیبانی مستقیم از خواندن سریع فایل‌های PDF از حافظه مرورگر بدون نیاز به شبکه و حل مشکلات CORS در لودینگ ورکر PDF.js",
      "سیستم پشتیبان دوگانه رندر Canvas با کیفیت بالا (Scale 2.0) جهت اجرای OCR روی PDFهای اسکن‌شده و استخراج عبارات متنی با ریجکس بایت‌های PDF"
    ]
  },
  {
    version: "4.5.0",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "نسخه جدید ۴.۵.۰: ارتقاء موتور هوش مصنوعی اسکن فاکتورها، پشتیبانی کامل از فایل‌های PDF و تصاویر، و بهینه‌سازی فرم‌های مالی",
    badge: "نسخه v4.5.0",
    changes: [
      "موتور اسکن هوشمند متنی و استخراج PDF چند لایه (PDF.js + Tesseract OCR Canvas Rendering) برای استخراج بی‌نقص اطلاعات از فاکتورها و رسیدها",
      "حذف کامل تولید داده‌های فرضی، قیمت‌های غیرواقعی یا آیتم‌های حدسی در صورت عدم وجود متن صریح در رسید",
      "حذف بخش ویدیوی ضمیمه و بهینه‌سازی سرعت بارگذاری و ثبت تراکنش‌ها و فاکتورها در حافظه ابری Cloudflare R2",
      "تثبیت فونت ارقام فارسی Vazirmatn با ویژگی tabular-nums در تمامی بخش‌ها و لیست‌های مالی"
    ]
  },
  {
    version: "4.4.9",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۹: یکپارچه‌سازی کتابخانه pdfjs-dist جهت خواندن متنی دقیق اسناد PDF فاکتور، تبدیل صفحات اسکن‌شده به OCR و ممانعت کامل از تولید داده‌های فرضی",
    badge: "نسخه v4.4.9",
    changes: [
      "یکپارچه‌سازی موتور pdfjs-dist برای استخراج متنی لایه‌ای و دقیق اسناد PDF فاکتورها به همراه رندر خودکار صفحات اسکن‌شده روی بوم Canvas جهت اجرای OCR روی PDFهای تصویری",
      "جلوگیری کامل از تولید آیتم‌ها، قیمت‌ها یا مقادیر فرضی؛ هوش مصنوعی تنها متون واقعی استخراج‌شده را پردازش نموده و در صورت عدم وجود اقلام صریح، لیست اقلام را خالی نگه می‌دارد",
      "حذف ارجاع نام فایل به عنوان متن ورودی و توقف کامل روند اسکن در صورت عدم وجود متن خوانا در فایل پیوست"
    ]
  },
  {
    version: "4.4.8",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۸: تثبیت کامل اسکن هوشمند فاکتورها با Cloudflare Worker AI و پارسر چندلایه‌ای اقلام",
    badge: "نسخه v4.4.8",
    changes: [
      "بهینه‌سازی اسکن هوشمند فاکتورها با تبدیل ارقام فارسی و پارسر منعطف JSON و Regex",
      "استخراج نام فروشگاه، مبالغ، اقلام، تخفیف‌ها، تاریخ و شیوه پرداخت از روی تصاویر فاکتور",
      "حذف کامل بخش ویدیوی ضمیمه از فرم‌های مالی",
      "افزودن گارد زمان‌بندی (Timeout Guard) به موتور OCR"
    ]
  },
  {
    version: "4.4.7",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۷: ارتقاء اسکن هوشمند فاکتورها با هوش مصنوعی ابری Cloudflare Worker AI و موتور OCR",
    badge: "نسخه v4.4.7",
    changes: [
      "اتصال اسکن هوشمند فاکتورها به سرویس Cloudflare Worker AI جهت استخراج نام فروشگاه، تاریخ، جمع کل و اقلام",
      "یکپارچه‌سازی موتور OCR پردازش تصویر با Tesseract.js جهت تبدیل تصاویر رسید به متن",
      "حذف بخش ویدیوی ضمیمه در فرم ثبت و ویرایش تراکنش‌ها",
      "نمایش بنر راهنمای وضعیت زنده اسکن فاکتورها"
    ]
  },
  {
    version: "4.4.6",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۶: قابلیت ویرایش تراکنش‌ها و فاکتورها، پیوست تصویر و سند فاکتور با ذخیره‌سازی ابری در Cloudflare R2 و زیباسازی قلم ارقام",
    badge: "نسخه v4.4.6",
    changes: [
      "امکان ویرایش مستقیم تراکنش‌ها و فاکتورها در بخش فهرست تراکنش‌ها و فاکتورها (نمای کلی و تراکنش‌ها) همراه با بازخوانی کامل اقلام خرید، مبالغ، دسته‌بندی و پیوست‌ها",
      "سیستم پیوست مستقیم تصویر فاکتور فروشگاه و اسناد PDF به تراکنش‌ها با ذخیره‌سازی ابری و پایدار در Cloudflare R2 و D1 مشابه دستیار یادگیری و مدیریت منابع",
      "پیش‌نمایش سریع اسناد و تصاویر فاکتور با پنجره اختصاصی Lightbox و امکان اسکن خودکار فاکتور توسط هوش مصنوعی (AI Invoice Scanner)",
      "استانداردسازی فونت ارقام فارسی در تمامی فرم‌های ورودی، پیش‌نمایش‌های هوشمند و مودال‌های ثبت و ویرایش با استفاده از قلم هماهنگ با داشبورد (Vazirmatn و tabular-nums)"
    ]
  },
  {
    version: "4.4.5",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۵: زیباسازی و استانداردسازی قلم ارقام و اعداد فارسی در ماژول مدیریت هوشمند مالی و اهداف پس‌انداز",
    badge: "نسخه جدید v4.4.5 🚀",
    changes: [
      "بهینه‌سازی سراسری ظاهر و فونت ارقام فارسی در ماژول مدیریت هوشمند فاکتورها، بودجه و اهداف مالی به سبک زیبای داشبورد اصلی (استفاده از تایپوگرافی تمیز وزیرمتن و ویژگی tabular-nums به جای فونت مونو اسپیس)",
      "اعمال فونت یکدست و خوانا در تمامی کارت‌های متریک اجمالی، موجودی کل، درآمد خالص، مخارج ماهانه، سقف بودجه، و نمودارهای مالی",
      "زیباسازی ارقام در لیست تراکنش‌ها، جزئیات اقلام فاکتور، جدول سقف دسته‌بندی‌ها، رادار بودجه زنده، اهداف پس‌انداز (Savings Goals) و شاخص سلامت مالی",
      "تنظیم فونت Vazirmatn در استک قلم پیش‌فرض برنامه برای نمایش بی‌نقص و هماهنگ اعداد در تمامی دستگاه‌ها و اندازه‌های صفحه"
    ]
  },
  {
    version: "4.4.4",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۴: قابلیت ویرایش کامل اهداف مالی و پس‌انداز (Editable Savings Goals)، دسته‌بندی پیشرفته و مدیریت هوشمند سرمایه‌گذاری",
    badge: "نسخه v4.4.4",
    changes: [
      "قابلیت ویرایش کامل اهداف مالی (Editable Goals): امکان ویرایش عنوان هدف، مبلغ کل هدف، پس‌انداز فعلی، ارز، تاریخ هدف، دسته‌بندی و توضیحات به صورت مستقیم و بدون نیاز به حذف و بازتعریف",
      "طراحی دکمه ویرایش (Edit Goal) روی هر کارت پس‌انداز و درون پنجره مدیریت هدف به همراه دکمه افزایش پس‌انداز (Add Deposit)",
      "پشتیبانی کامل از محاسبه لحظه‌ای درصد پیشرفت، مبلغ باقی‌مانده و همگام‌سازی ابری با دیتابیس Cloudflare D1",
      "افزودن دسته‌بندی‌های بصری متنوع (مسکن، خودرو، سفر، صندوق اضطراری، سرمایه‌گذاری، متفرقه) با آیکون‌های رنگی اختصاصی"
    ]
  },
  {
    version: "4.4.3",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۳: اصلاح لیست انتخاب ارزهای پایه در ماژول مالی و بودجه، ترجمه چندزبانه نام ارزها و عناوین دسته‌بندی‌ها",
    badge: "نسخه جدید v4.4.3 🚀",
    changes: [
      "اصلاح و استانداردسازی لیست بازشوی تغییر سریع ارز پایه (Quick Currency Selector) در بخش مدیریت مالی و بودجه: جایگزینی کدهای متنی خام با نام‌های دقیق و خوانای ارزها نظیر کرون سوئد (SEK)، ریال (IRR)، تومان (Toman)، یورو (EUR) و دلار آمریکا (USD)",
      "افزودن ترجمه چندزبانه نام ارزها (fa / en / sv) در فایل بین‌المللی‌سازی i18n برای هماهنگی کامل هنگام تغییر زبان به انگلیسی یا سوئدی",
      "اعمال ترجمه استاندارد روی تمام فرم‌ها و مودال‌های مالی از جمله تنظیمات بودجه ماهانه، ثبت تراکنش جدید، و تعریف اهداف مالی (Savings Goals)",
      "اصلاح نمایش عناوین دسته‌بندی‌های هزینه‌کرد در نمودارها و جدول سقف بودجه بر اساس متادیتای محلی‌سازی‌شده"
    ]
  },
  {
    version: "4.4.2",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۲: نمایش زنده و موقت ترجمه اقلام خرید (Live Temporary Store Translation) با حفظ کامل داده‌های اصلی پایگاه داده و بدون رونویسی دیتابیس",
    badge: "نسخه v4.4.2",
    changes: [
      "تبدیل کامل عملکرد ترجمه هوشمند اقلام خرید به حالت نمایش موقت و زنده (Live Temporary Translation View): در این حالت هوش مصنوعی معادل‌های دقیق سوئدی (ICA/Coop/Willys) یا انگلیسی را برای کمک به خرید در فروشگاه روی صفحه نمایش می‌دهد بدون آنکه نام اصلی اقلام در دیتابیس تغییر یا بازنویسی شود",
      "طراحی بنر تعاملی ترجمه موقت فعال (Active Temporary Translation Banner) به همراه برچسب‌های رنگی سوئدی و انگلیسی در کنار هر آیتم، دکمه تغییر زبان، کپی کامل ترجمه‌ها و دکمه بازگشت به حالت عادی",
      "افزوده شدن جدول مقایسه‌ای و پیش‌نمایش دو زبانه (Side-by-Side Dictionary Table) درون پنجره ترجمه جهت مرور سریع و کپی آسان معادل‌های فروشگاهی",
      "پایبندی ۱۰۰٪ به اصل عدم تغییر داده‌های کاربر در پایگاه داده، حفظ یکپارچگی عناوین فارسی/اصلی و مدیریت حافظه نمایشی زنده در استیت کلاینت"
    ]
  },
  {
    version: "4.4.1",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۱: ترجمه هوشمند اقلام لیست خرید با هوش مصنوعی (AI Translation)، واکنش‌گرایی آنی حذف و مدیریت لیست‌ها، و اصلاح سراسری متن ذخیره‌سازی ابری Cloudflare D1",
    badge: "نسخه v4.4.1",
    changes: [
      "طراحی و پیاده‌سازی دکمه و مودال ترجمه هوشمند اقلام خرید (AI Shopping List Translation) برای تبدیل و ترجمه خودکار تمام اقلام دفترچه‌های ایجاد شده توسط کاربر به زبان‌های سوئدی (Svenska - مناسب خرید در فروشگاه‌های ICA, Willys, Coop, Lidl)، انگلیسی (English) و فارسی (Persian)",
      "رفع کامل تاخیر در حذف و ایجاد دفترچه‌های خرید (Instant UI Reactivity & Broadcast Subscription) به طوری که هنگام حذف یک لیست، بلافاصله از رابط کاربری بدون نیاز به جابجایی صفحه یا رفرش حذف می‌گردد",
      "اصلاح و بازنویسی سراسری متن اعلان ذخیره‌سازی داده‌ها (settingsLocalStorageNotice) در هر ۳ زبان (فارسی، انگلیسی و سوئدی) جهت تایید و شفاف‌سازی ذخیره‌سازی مستقیم و امن داده‌ها روی پایگاه داده ابری Cloudflare D1 بدون اتکا به حافظه محلی مرورگر",
      "بومی‌سازی کامل عناوین و پیش‌فرض‌های ساخت دفترچه خرید (خرید هفتگی خانه، کباب و پیک‌نیک، داروخانه و بهداشتی، خواربار و سوپرمارکت، خرید میوه و سبزی) و رفع کامل نمایش تگ‌های {{diff}} و {{val}} در نمودارهای تغییرات وزن و BMI"
    ]
  },
  {
    version: "4.4.0",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۴.۰: چندزبانه ساختن کامل مقادیر پیش‌فرض پرونده پزشکی، رفع متون هاردکد روند وزن، ماژول آنالیز هوشمند استپ وزنی (Plateau Diagnostic) و همگام‌سازی Cloudflare D1",
    badge: "نسخه v4.4.0",
    changes: [
      "بومی‌سازی و چندزبانه ساختن کامل مقادیر پیش‌فرض «بیماری‌ها و سوابق پزشکی» (Medicinska tillstånd) و «داروهای مصرفی» (Nuvarande mediciner) بر اساس زبان انتخابی (سوئدی: Inga / Inga mediciner، انگلیسی: None / No medications، فارسی: ندارم / مصرف نمی‌کنم)",
      "رفع متون هاردکد فارسی در کارت وضعیت روند وزن (وضعیت کلی روند وزن و روند وزن نزولی/صعودی/ثابت) در بخش پایش وزن و BMI با همگام‌سازی کامل Cloudflare D1",
      "طراحی و پیاده‌سازی سیستم جدید آنالیز هوشمند استپ وزنی (Weight Loss Plateau Diagnostic & Action Plan) جهت تحلیل علل استپ وزنی (کاهش متابولیسم، احتباس آب/کورتیزول، کالری‌های پنهان، عضله‌سازی همزمان و کاهش NEAT)",
      "افزوده شدن دکمه تحلیل اختصاصی استپ وزنی با هوش مصنوعی (AI Diagnostic Protocol) و ارائه راهکارهای عملی (Refeed Day / اندازه چشمی غذا / پایش دور کمر) کاملاً چندزبانه به ۳ زبان فارسی، انگلیسی و سوئدی"
    ]
  },
  {
    version: "4.3.29",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۳.۲۹: چندزبانه ساختن کامل بخش پروفایل شخصی، محاسبات قد/وزن/سن/جنسیت/فعالیت و پیش‌بینی زمان رسیدن به وزن هدف در تنظیمات سیستم",
    badge: "نسخه جدید v4.3.29",
    changes: [
      "ترجمه و بومی‌سازی کامل تمام کلیدهای پروفایل شخصی (پروفایل شخصی و اهداف سلامت)، عنوان‌ها، اهداف آب و کالری روزانه و هشدارهای ذخیره‌سازی محلی به سوئدی (sv) و انگلیسی (en)",
      "چندزبانه ساختن دقیق تمامی فرمول‌ها، عناوین، لیبل‌ها و گزینه‌های جنسیت، سطح فعالیت روزانه، و نوع هدف وزنی در محاسبه‌گر قد/وزن/کالری هدف (Mifflin-St Jeor)",
      "ترجمه کامل کارت پیش‌بینی هوشمند زمان رسیدن به وزن هدف (ETA)، نرخ تغییر وزن هفتگی، کسری/مازاد کالری روزانه و محاسبه TDEE به زبان انتخابی کاربر",
      "افزوده شدن تمام کلیدهای ترجمه مفقود به دیکشنری سیستم (i18n.ts) در هر ۳ زبان فارسی، انگلیسی و سوئدی"
    ]
  },
  {
    version: "4.3.28",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۳.۲۸: بومی‌سازی و چندزبانه ساختن کامل کارت‌های آلارم، راهنمای iOS، و ورودی‌های پزشکی در تنظیمات سیستم و پنل مدیریت",
    badge: "نسخه جدید v4.3.28",
    changes: [
      "ترجمه و بومی‌سازی کامل کارت‌های زمان‌بندی آلارم، خروجی تقویم جامع (.ics)، و راهنمای دو مرحله‌ای اعلان‌های آیفون (iOS) به زبان‌های سوئدی (sv) و انگلیسی (en)",
      "ترجمه و چندزبانه ساختن لیبل‌ها و نگه‌دارنده‌های (Placeholder) سوابق پزشکی، داروهای مصرفی، حساسیت‌ها و اهداف تغذیه‌ای در تنظیمات پروفایل",
      "اضافه‌شدن کلیدهای ترجمه اختصاصی برای پنل پایش و مدیریت کاربران (Användarhantering & Adminpanel) و رفع پیغام‌های خطای هاردکدشده",
      "تضمین نمایش ۱۰۰٪ زبان انتخابی (سوئدی / انگلیسی / فارسی) بدون باقی‌ماندن هیچ متن هاردکدشده فارسی در تمام تب‌های تنظیمات و مدیریت"
    ]
  },
  {
    version: "4.3.27",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۳.۲۷: چندزبانه ساختن کامل اسامی تمرینات فیزیوتراپی، کاردیو، مواد غذایی، کمیت‌ها و تاریخ‌ها در تمام گزارش‌ها و پنل‌های مدیریتی",
    badge: "نسخه جدید v4.3.27",
    changes: [
      "ترجمه و بومی‌سازی داینامیک نام و کمیت تمام مواد غذایی در گزارش جامع تغذیه (Omfattande närings- & matrapport) به زبان‌های سوئدی (sv) و انگلیسی (en)",
      "چندزبانه ساختن کامل اسامی تمام تمرینات فیزیوتراپی دیسک کمر و حرکات کاردیو (Rehab & Övningsrapport) به سوئدی و انگلیسی",
      "پشتیبانی چندزبانه کامل از فرمت تاریخ‌ها، زبان تقویم و برچسب‌های کاربری در پنل مدیریت کاربران (Användarhantering & Adminpanel)",
      "ترجمه و بومی‌سازی کامل تمام فرم‌ها، لیبل‌ها، گزینه‌ها و محاسبات هوش مصنوعی در تنظیمات عمومی (تنظیمات عمومی و ساعت یادآورها)",
      "تضمین عدم وجود رشته‌های هاردکدشده فارسی هنگام انتخاب زبان‌های سوئدی یا انگلیسی در سرتاسر اپلیکیشن"
    ]
  },
  {
    version: "4.3.26",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۳.۲۶: پشتیبانی چندزبانه کامل (fa/en/sv) برای تمام صفحات گزارش‌ها، تم و پوسته، دیکشنری متغیرها، یادآورها و مدیریت کاربران",
    badge: "نسخه جدید v4.3.26",
    changes: [
      "بومی‌سازی و چندزبانه کامل تب‌های ماژول گزارش‌ها (تغذیه، فیزیوتراپی، خواب و شیفت، خروجی هوش مصنوعی)",
      "چندزبانه ساختن کامل ماژول تنظیمات پوسته، رنگ‌ها و پیش‌نمایش زنده (Apptema, Färger & Anpassning)",
      "چندزبانه ساختن ماژول مرجع متغیرها، فیلترهای دسته‌بندی و دیکشنری (Variabelreferens & Lexikon)",
      "پشتیبانی چندزبانه در ماژول تنظیمات عمومی و یادآورهای خانوادگی (تنظیمات عمومی و ساعت یادآورها)",
      "بومی‌سازی کامل ماژول مدیریت و پایش کاربران سیستم (Användarhantering & Adminpanel)"
    ]
  },
  {
    version: "4.3.25",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۳.۲۵: افزودن دیکشنری کامل چندزبانه (سوئدی، انگلیسی، فارسی) برای حالت‌های روحی، کارت‌های شاخص عملکرد و نمودارهای تحلیلی",
    badge: "نسخه جدید v4.3.25",
    changes: [
      "تکمیل و ثبت تمام کلیدهای ترجمه حالات روحی (آرامش، پرانرژی، کوفته/گرفتگی، خسته، مضطرب) در فایل دیکشنری i18n برای هر ۳ زبان سوئدی، انگلیسی و فارسی",
      "ترجمه کامل تمامی متن‌های ثابت و عنوان کارت‌های شاخص KPI (امتیاز پایداری، میانگین کالری، فیزیوتراپی، شاخص درد، آب مصرفی، خواب و شیفت کاری) در زبان‌های sv و en",
      "بومی‌سازی عنوان و راهنمای تمامی ۵ نمودار تعاملی، عناوین جداول روزانه پایش خواب، هیدراتاسیون، مواد غذایی و دکمه‌های صادرات AI و پشتیبان‌گیری"
    ]
  },
  {
    version: "4.3.24",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۳.۲۴: بومی‌سازی ۱۰۰٪ و چندزبانه کامل ماژول‌های دفترچه یادداشت روزانه و گزارش‌های تحلیلی هوشمند",
    badge: "نسخه جدید v4.3.24",
    changes: [
      "بومی‌سازی کامل دفترچه یادداشت‌ها و ارزیابی حالات روزانه (Personlig Anteckningsbok & Måendedagbok) شامل اسلایدر درد کمر، انتخابگر خلق‌وخو، درجه انرژی و فرم‌های متنی به زبان‌های fa، en و sv",
      "بومی‌سازی ۱۰۰٪ ماژول گزارش‌های تحلیلی و AI (Omfattande Analys & AI-Rapporter) شامل تب‌های ناوبری، کارت‌های شاخص عملکرد (KPI)، نمودارهای پویا، جداول تغذیه، فیزیوتراپی، خواب و هیدراتاسیون",
      "جایگزینی متمرکز توابع عددنویسی با تابع استاندارد formatNumberByLang جهت نمایش بومی و دقیق اعداد در زبان‌های انگلیسی، سوئدی و فارسی",
      "بومی‌سازی بخش دانلود و پشتیبان‌گیری از داده‌ها (خروجی CSV، فایل JSON و کد ساختاریافته هوش مصنوعی)"
    ]
  },
  {
    version: "4.3.23",
    date: "۲۸ مرداد ۱۴۰۵ (2026-08-18)",
    title: "به‌روزرسانی ۴.۳.23: تکمیل دیتابیس ترجمه‌های تغذیه و مواد غذایی (foodTranslations)، رفع خطاهای کلیدهای تکراری و بهینه‌سازی کامپایل",
    badge: "نسخه جدید v4.3.23",
    changes: [
      "توسعه جامع بانک ترجمه غذایی (foodTranslations) به زبان‌های انگلیسی و سوئدی برای لبنیات، مغزها، غلات، سبزیجات، نوشیدنی‌ها و غذاهای سنتی",
      "افزایش مقادیر استاندارد و واحدهای اندازه‌گیری به ۳ زبان (فارسی، انگلیسی و سوئدی) برای انواع ظرفیت‌ها و سهم‌های مصرفی",
      "شناسایی و رفع کامل کلیدهای تکراری و تداخل شیءها در فایل foodTranslations جهت رفع خطاهای Linter و TypeScript",
      "ارتقا و تست کامپایل ۱۰۰٪ موفق پروژه همراه با تضمین پایداری نسخه تولید v4.3.23"
    ]
  },
  {
    version: "4.3.22",
    date: "۲۷ مرداد ۱۴۰۵ (2026-08-17)",
    title: "به‌روزرسانی ۴.۳.۲۲: بومی‌سازی جامع ماژول‌های یادگیری سوئدی، روتین هفتگی، لاگ فعالیت‌ها و ارتقای موتور ترجمه و ارزیابی",
    badge: "نسخه جدید v4.3.22",
    changes: [
      "بومی‌سازی ۱۰۰٪ و چندزبانه کامل ماژول ۴ (پایش یادگیری سوئدی) شامل سرفصل‌های خودآموز، توصیه‌های گرامری روزانه و کلیدواژه‌های منتخب برای زبان‌های fa، en و sv",
      "چندزبانه کردن جامع ماژول روتین و برنامه‌ریزی هفتگی (Work & Routine) به همراه عناوین روزها، همگام‌سازی تقویم گوگل و پشتیبانی دوطرفه از فایل‌های تقویم ICS",
      "بومی‌سازی کامل دفتر ثبت فعالیت‌های روزانه (Activity Log Module) با الگوهای سریع پیش‌فرض و فرم‌های ثبت دستی متناسب با زبان فعال",
      "بومی‌سازی شاخص‌ها و ارقام داشبورد اصلی با پشتیبانی متمرکز از تابع formatNumberByLang جهت یکدستی نمایش در کلیه زبان‌ها",
      "ارتقای فرم ارزیابی و ورودی‌های هوش مصنوعی ماژول توانبخشی (Rehab AI Intake) و همگام‌سازی خودکار مقادیر پیش‌فرض با تغییر زبان",
      "توسعه بانک واژگان ترجمه غذاها و مواد اولیه در foodTranslations و رفع موارد تکراری و نرمال‌سازی نشانه‌ها"
    ]
  },
  {
    version: "4.3.21",
    date: "۲۶ مرداد ۱۴۰۵ (2026-08-16)",
    title: "به‌روزرسانی ۴.۳.۲۱: بومی‌سازی کامل ماژول‌های تمرینی فیزیوتراپی و چربی‌سوزی، پشتیبانی صوتی چندزبانه و پایدارسازی پایش وزن",
    badge: "v4.3.21",
    changes: [
      "بومی‌سازی ۱۰۰٪ و چندزبانه کامل ماژول ۱ (فیزیوتراپی، تمرینات اصلاحی و کاهش درد) به زبان‌های فارسی، انگلیسی و سوئدی",
      "بومی‌سازی ۱۰۰٪ و چندزبانه کامل ماژول ۲ (تمرینات چربی‌سوزی و آب کردن شکم) شامل کلیه حرکات، عضلات هدف، تعداد ست، تکرار و استراحت",
      "سیستم هدایت صوتی چندزبانه (TTS) با لهجه‌های بومی (fa-IR، en-US، sv-SE) و متون ترجمه‌شده برای آغاز، تمرین، استراحت و پایان تمرین",
      "رفع کامل متون هاردکد شده در برنامه غذایی فصلی و ثبت میان‌وعده، قهوه سلامتی کولد برو و ترکیبات ماست یونانی و دانه چیا",
      "پایدارسازی و بازیابی دائمی داده‌های پایش وزن و BMI با همگام‌سازی دوطرفه localStorage و کلود D1 جهت جلوگیری از پاک شدن سوابق"
    ]
  },
  {
    version: "4.3.20",
    date: "۲۵ مرداد ۱۴۰۵ (2026-08-16)",
    title: "به‌روزرسانی ۴.۳.۲۰: بومی‌سازی جامع و چندزبانه کامل برنامه غذایی فصلی و سلامت متابولیک (Seasonal Meal Plan)",
    badge: "نسخه جدید v4.3.20",
    changes: [
      "بومی‌سازی ۱۰۰٪ و بی‌نقص ماژول برنامه غذایی فصلی (GLP-1) برای زبان‌های فارسی، انگلیسی و سوئدی",
      "ترجمه و بومی‌سازی نام وعده‌های غذایی، دورچین‌ها، مواد اولیه، سهم مصرفی، درجه سختی و روزهای هفته بر پایه زبان انتخابی کاربر",
      "چندزبانه کردن کامل ۵ قانون طلایی متابولیک، پروتکل قهوه سلامتی، عادات روزانه ترشح GLP-1 و لیست خرید ۴ هفته‌ای فصول",
      "بهبود یکپارچگی کدهای TypeScript، استانداردسازی کلیدهای دیکشنری متمرکز i18n و فرمت‌بندی بومی ارقام"
    ]
  },
  {
    version: "4.3.19",
    date: "۲۵ مرداد ۱۴۰۵ (2026-08-15)",
    title: "به‌روزرسانی ۴.۳.۱۹: پاکسازی و بومی‌سازی ۱۰۰٪ ماژول دستیار یادگیری و منابع آموزشی (Learning Module)",
    badge: "v4.3.19",
    changes: [
      "حذف و پاکسازی تمامی متون، عناوین، فرم‌ها، ورودی‌های مباحث و دیالوگ‌های ثبت جلسه در ماژول دستیار یادگیری هوشمند (Learning Module)",
      "جایگزینی کلیه متغیرها و ارقام هاردکد شده با تابع هوشمند formatNumberByLang جهت نمایش متناسب ارقام به زبان‌های فارسی، سوئدی و انگلیسی",
      "بومی‌سازی فرم ثبت جلسه جدید، مباحث فرعی، گالری فایل‌ها، پیش‌نمایش ویدیوها و ابزارهای آزمون‌ساز هوشمند",
      "یکپارچه‌سازی متون پیام‌های راهنما، بارگذاری، دکمه‌های انصراف/تایید و تاریخچه جلسات در فایل دیکشنری متمرکز i18n"
    ]
  },
  {
    version: "4.3.18",
    date: "۲۴ مرداد ۱۴۰۵ (2026-08-14)",
    title: "به‌روزرسانی ۴.۳.۱۸: بومی‌سازی ۱۰۰٪ و چندزبانه کامل ماژول‌های رادار هوشمند اخبار، یادگیری هوشمند و لیست خرید",
    badge: "v4.3.18",
    changes: [
      "بومی‌سازی کامل ماژول رادار هوشمند اخبار (News Radar) شامل کلیه دکمه‌ها، پیشنهادهای موضوعی، فرم‌ها، تنظیمات لحن و پیام‌های وضعیت به زبان‌های فارسی، انگلیسی و سوئدی",
      "بومی‌سازی و چندزبانه کردن جامع ماژول دستیار یادگیری و مدیریت منابع هوشمند (Learning Module) شامل برچسب پیام‌ها، دیالوگ‌های حذف، ورودی لینک ویدیو و مدیریت فایل‌ها",
      "حذف کامل کلیه متون، برچسب‌ها و دکمه‌های هاردکد شده در لیست خرید (Shopping Module) و جایگزینی با ساختار متمرکز i18n",
      "بروزرسانی دیکشنری‌های فارسی، انگلیسی و سوئدی با بیش از ۷۵ کلید جدید جهت استانداردسازی سراسری رابط کاربری"
    ]
  },
  {
    version: "4.3.17",
    date: "۲۴ مرداد ۱۴۰۵ (2026-08-14)",
    title: "به‌روزرسانی ۴.۳.۱۷: تفکیک ماژول مرجع متغیرها، اصلاح دکمه نمایش نسخه و بومی‌سازی ۱۰۰٪ ماژول مالی و بودجه‌بندی",
    badge: "v4.3.17",
    changes: [
      "تفکیک و انتقال کامل مرجع متغیرها و ترجمه‌ها (Dictionary Reference) به صفحه مستقل در بخش تنظیمات و حذف تب آن از ماژول مالی",
      "اصلاح دکمه نمایش نسخه زیر منوی اصلی و هدر و حل مشکل نمایش متغیر نسخه (v4.3.17)",
      "حذف و پاکسازی تمامی عناوین، پیام‌ها، واتر‌مارک‌ها و برچسب‌های هاردکد شده فارسی در تب‌های بودجه‌بندی، ورود دسته‌ای (Batch Import)، اسکنر AI و اهداف مالی",
      "بومی‌سازی کامل متون پرامپت‌های پیشنهادی هوش مصنوعی، خطاهای اسکن، پیام‌های تایید و فرمت‌بندی اعداد به ۳ زبان فارسی، انگلیسی و سوئدی"
    ]
  },
  {
    version: "4.3.16",
    date: "۲۴ مرداد ۱۴۰۵ (2026-08-14)",
    title: "به‌روزرسانی ۴.۳.۱۶: پاکسازی جامع کاراکترهای نیم‌فاصله (Unicode ZWNJ)، اصلاح لیست کارت‌های بانکی و بومی‌سازی کامل مدیریت حساب‌ها",
    badge: "v4.3.16",
    changes: [
      "اصلاح و پاکسازی ساختاری تمامی کاراکترهای نیم‌فاصله (ZWNJ) و کدهای Escape شده در سراسر عناوین و متغیرهای چندزبانه سامانه (i18n)",
      "پویاسازی کامل لیست انتخاب کارت‌ها و حساب‌های بانکی در تمام بخش‌های ماژول مالی بر اساس کارت‌های تعریف‌شده اختصاصی کاربر",
      "بومی‌سازی و ترجمه ۱۰۰٪ پنجره مدیریت کارت‌ها و حساب‌های شخصی بانکی (Hantera Bankkort & Konton) به ۳ زبان فارسی، انگلیسی و سوئدی",
      "تبدیل تمامی فرمت‌های عددی در ماژول مدیریت مالی به تابع تشخیص هوشمند زبان (formatNumberByLang) جهت تفکیک دقیق ارقام فارسی و لاتین"
    ]
  },
  {
    version: "4.3.14",
    date: "۲۳ مرداد ۱۴۰۵ (2026-08-13)",
    title: "به‌روزرسانی ۴.۳.۱۴: رفع کامل نمایش متغیرهای قالبی ({{count}}, {{amount}}, {{remaining}}, {{water}}, ...) در تمام ماژول‌ها و داشبورد",
    badge: "نسخه جدید v4.3.14",
    changes: [
      "اصلاح تابع توزیع متغیرها در LanguageContext Provider و ارسال کامل آرگومان پارامترها به تابع translate",
      "حل مشکل نمایش خام جایگاه‌های متغیر مانند {{target}}، {{remaining}}، {{amount}}، {{count}}، {{water}}، {{total}}، {{completed}}، {{date}} و {{score}} در داشبورد و تمام ۱۰ ماژول اصلی",
      "ارتقا و ایمن‌سازی موتور جایگزینی متغیرها به ساختار متد split/join جهت جلوگیری از خطاهای کاراکترهای رزروشده در Regex",
      "بررسی کامل تمام کامپوننت‌های برنامه و اطمینان از نمایش دقیق و واقعی مقادیر عددی و متنی به همراه اعداد فارسی/لاتین بر اساس زبان انتخاب‌شده"
    ]
  },
  {
    version: "4.3.13",
    date: "۲۳ مرداد ۱۴۰۵ (2026-08-13)",
    title: "به‌روزرسانی ۴.۳.۱۳: تثبیت کامل سیستم چندزبانه (i18n)، رفع تداخل‌های ترجمه و بهینه‌سازی ساختار کامپوننت‌ها",
    badge: "نسخه جدید v4.3.13",
    changes: [
      "پایش و پاکسازی کامل کلیدهای تکراری در دیکشنری‌های چندزبانه (فارسی، انگلیسی و سوئدی) در مرجع متمرکز i18n",
      "اتصال کامل هوک‌های ترجمه (useLanguage) به تمامی کامپوننت‌های فرعی و ماژول‌ها شامل برنامه غذایی فصلی، دستیار یادگیری، یادداشت‌ها، تغذیه، پایش وزن و یادآورها",
      "اصلاح خطاهای ساختاری JSX و تگ‌های بسته نشده در ماژول پایش وزن",
      "ارتقا و تست کامپایل ۱۰۰٪ موفق پروژه همراه با رفع کامل خطاهای Linter و تضمین پایداری نسخه تولید"
    ]
  },
  {
    version: "4.3.12",
    date: "۲۳ مرداد ۱۴۰۵ (2026-08-13)",
    title: "به‌روزرسانی ۴.۳.۱۲: یکپارچه‌سازی کامل تمام صفحات و ماژول‌های سامانه با سیستم متمرکز چندزبانه i18n (فارسی، انگلیسی، سوئدی)",
    badge: "نسخه جدید v4.3.12",
    changes: [
      "تعریف و اتصال تمام متون صفحات ورودی/لاگین (LoginScreen)، دستیار یادگیری (LearningModule)، مدیریت مالی، تنظیمات، یادآورها، اخبار، لیست خرید و غیره به دیکشنری متمرکز i18n",
      "امکان تغییر پویای زبان برنامه در تمام صفحات و همگام‌سازی لحظه‌ای چیدمان LTR/RTL و تمام عناوین، دکمه‌ها و فرم‌ها",
      "ذخیره‌سازی پایدار انتخاب زبان کاربر و قابلیت همگام‌سازی بین دستگاهی و حالت مهمان",
      "به‌روزرسانی و غنی‌سازی دیتابیس ترجمه‌ها و متغیرهای مرجع دیکشنری (Dictionary Reference) برای تمام بخش‌های سامانه"
    ]
  },
  {
    version: "4.3.11",
    date: "۲۳ مرداد ۱۴۰۵ (2026-08-13)",
    title: "به‌روزرسانی ۴.۳.۱۱: مرجع یکپارچه و سیستم جدید مدیریت متغیرها و متون چندزبانه (i18n Variable Dictionary) + ترجمه ۱۰۰٪ تمام ماژول‌ها",
    badge: "نسخه جدید v4.3.11",
    changes: [
      "ایجاد مرجع و کامپوننت متمرکز متغیرها و ترجمه‌های چندزبانه (Dictionary Reference Component) با قابلیت جستجو، فیلتر ماژول‌ها و مشاهده مقادیر به ۳ زبان فارسی، انگلیسی و سوئدی",
      "جایگزینی کامل تمام متون هدرها، بنرها، دکمه‌ها، عنوان کارت‌ها و فرم‌های ماژول مدیریت مالی (Finance) با متغیرهای متمرکز i18n",
      "امکان تغییر و تست زنده زبان اپلیکیشن همراه با همگام‌سازی لحظه‌ای تمام بخش‌ها و جهت چیدمان (RTL/LTR)",
      "ارتقا و غنی‌سازی دیکشنری ترجمه‌ها برای تمام ماژول‌های برنامه (داشبورد، مالی، پزشک AI، یادآورها، خرید، اخبار، تغذیه و تنظیمات)"
    ]
  },
  {
    version: "4.3.10",
    date: "۲۲ مرداد ۱۴۰۵ (2026-08-12)",
    title: "به‌روزرسانی ۴.۳.۱۰: پشتیبانی کامل از چندزبانی (فارسی، انگلیسی و سوئدی) در تمام بخش‌های سامانه + چیدمان هوشمند LTR/RTL",
    badge: "نسخه جدید v4.3.10",
    changes: [
      "افزوده شدن پشتیبانی کامل از ۳ زبان اصلی: فارسی (زبان پیش‌فرض)، انگلیسی (English) و سوئدی (Svenska)",
      "امکان تغییر زبان از طریق بخش تنظیمات برنامه (Settings) و هدرهای سریع دسترسی همراه با ذخیره‌سازی دائمی در پروفایل کاربر",
      "تنظیم هوشمند و خودکار جهت صفحه و چیدمان (RTL برای فارسی و LTR برای انگلیسی و سوئدی)",
      "ترجمه کامل عناوین منوها، دسته‌بندی‌ها، دکمه‌ها و فرم‌ها در سراسر اپلیکیشن"
    ]
  },
  {
    version: "4.3.9",
    date: "۲۱ مرداد ۱۴۰۵ (2026-08-11)",
    title: "به‌روزرسانی ۴.۳.۹: تشخیص دقیق مبالغ مثبت (+) و منفی (-) در صورت‌حساب‌های بانکی و تفکیک خودکار درآمد/ورودی از هزینه",
    badge: "نسخه جدید v4.3.9",
    changes: [
      "اصلاح و ارتقای الگوریتم پارسر صورت‌حساب‌های بانکی (CSV/متن): تشخیص مبالغ مثبت (مانند +2500.000 یا 2500.000) به عنوان درآمد/ورودی به حساب",
      "تشخیص مبالغ منفی (مانند -54.290 یا -750.000) به عنوان هزینه و پرداختی",
      "پشتیبانی کامل از فرمت‌های صورت‌حساب بانک‌های سوئدی و بین‌المللی (Booking date;Value date;Voucher number;Text;Amount;Balance)",
      "نمایش تفکیکی مجموع کل هزینه و مجموع کل درآمد/ورودی در نوار تأیید پایانی ورود دسته‌ای"
    ]
  },
  {
    version: "4.3.8",
    date: "۲۱ مرداد ۱۴۰۵ (2026-08-11)",
    title: "به‌روزرسانی ۴.۳.۸: گسترش و غنی‌سازی دسته‌بندی‌های مالی + تشخیص هوشمند و دقیق فروشگاه‌ها و برندهای سوئدی و بین‌المللی",
    badge: "نسخه جدید v4.3.8",
    changes: [
      "افزایش تنوع دسته‌بندی‌های مالی غنی شامل: کالای دیجیتال و الکترونیک، لوازم خانگی و دکوراسیون، تعمیرات خودرو و بیمه، اشتراک‌های دیجیتال و AI، حیوانات خانگی و پت‌شاپ، هدایا و خیریه",
      "ارتقای الگوریتم تشخیص خودکار دسته تراکنش بر اساس نام فروشگاه، برندهای سوئدی (ICA, Willys, Lidl, Elgiganten, Ikea, Mekonomen, Systembolaget) و کلیدواژه‌های فارسی/انگلیسی",
      "به‌روزرسانی تمام منوهای انتخاب دسته‌بندی در فیلترها، ورود دسته‌ای و اسکنر هوشمند فاکتور"
    ]
  },
  {
    version: "4.3.7",
    date: "۲۱ مرداد ۱۴۰۵ (2026-08-11)",
    title: "به‌روزرسانی ۴.۳.۷: مدیریت و پاکسازی دسته‌ای تراکنش‌ها (ماهیانه/سالانه/کل) + تفکیک هوشمند تسویه کارت اعتباری و انتقال بین‌حسابی",
    badge: "نسخه جدید v4.3.7",
    changes: [
      "اضافه شدن ابزار مدیریت و پاکسازی دسته‌ای تراکنش‌ها (امکان حذف تمام تراکنش‌های یک ماه خاص، یک سال خاص، تراکنش‌های فیلترشده یا پاکسازی کامل کل داده‌ها)",
      "شناسایی هوشمند تسویه‌حساب‌های کارت اعتباری (SEB Kort, Svea Bank, Klarna) و انتقال بین‌حسابی جهت جلوگیری از احتساب دوبرابری در هزینه‌های زندگی و اصلاح محاسبات پس‌انداز",
      "افزوده شدن پنل راهنمای شناور و بنر اصلاح سریع تراکنش‌های انتقال و کارت اعتباری"
    ]
  },
  {
    version: "4.3.6",
    date: "۲۱ مرداد ۱۴۰۵ (2026-08-11)",
    title: "به‌روزرسانی ۴.۳.۶: اصلاح هوشمند فیلتر تاریخ، تشخیص خودکار درآمد/Lön و انتقال فیلتر مقایسه ماهانه به جدول پایانی",
    badge: "نسخه جدید v4.3.6",
    changes: [
      "اصلاح کامل فیلتر تاریخ جهت پشتیبانی نرم از جابه‌جایی تاریخ از/تا (حتی در صورت جابه‌جا وارد کردن تاریخ) و اصلاح دکمه‌های سریع (امروز، این ماه، ۳ ماه اخیر)",
      "تشخیص و رتبه‌بندی هوشمند تراکنش‌های حقوق و درآمد (Lön / Salary) به عنوان درآمد (+) در استخراج صورت‌حساب‌ها و پشتیبانی از اصلاح خودکار داده‌های قبلی",
      "انتقال نمایش ریز هزینه‌های مقایسه ماهانه با اسکرول نرم و اعمال مستقیم فیلتر به جدول اصلی تراکنش‌ها در انتهای صفحه جهت خوانایی بهتر و جلوگیری از شلوغی"
    ]
  },
  {
    version: "4.3.5",
    date: "۲۱ مرداد ۱۴۰۵ (2026-08-11)",
    title: "به‌روزرسانی ۴.۳.۵: ساختاریافته‌سازی پاسخ‌های مشاور مالی، بهبود فیلتر تاریخ و کلیک روی ماه‌های مقایسه‌ای",
    badge: "نسخه جدید v4.3.5",
    changes: [
      "ساختاریافته‌سازی کامل پاسخ‌های مشاور مالی (AI Advisor) با رندر هوشمند Markdown، تیترهای تمایزیافته، کارت‌های هایلایت و جدول‌های شیک",
      "قابلیت کلیک روی هر ماه در بخش «مقایسه ماهانه هزینه‌ها و پس‌انداز» جهت نمایش آنی ریز هزینه‌های همان ماه و امکان اعمال مستقیم فیلتر",
      "ارتقا و به‌روزرسانی فیلتر تاریخ با باکس‌های استایل‌یافته از/تا، دکمه‌های سریع (امروز، این ماه، ۳ ماه اخیر) و هایلایت حالت فعال"
    ]
  },
  {
    version: "4.3.4",
    date: "۲۱ مرداد ۱۴۰۵ (2026-08-11)",
    title: "به‌روزرسانی ۴.۳.۴: همگام‌سازی کامل مشاور هوشمند مالی با موتور ورکر هوش مصنوعی و Gemini 3.5",
    badge: "نسخه جدید v4.3.4",
    changes: [
      "همگام‌سازی کامل سیستم مشاور هوشمند مالی (AI Advisor) با زیرساخت ورکر هوش مصنوعی (Worker AI) و مدل Gemini 3.5 Flash همانند ماژول‌های دستیار یادگیری و تغذیه",
      "پیاده‌سازی مکانیزم پشتیبان سه‌گانه (Triple Redundancy Fallback) جهت تضمین پاسخگویی ۱۰۰٪ لحظه‌ای مشاور مالی حتی در شرایط قطع اتصال یا محدودیت توکن",
      "بهینه‌سازی پردازش پرامپت‌ها و ارسال اطلاعات مالی کاربر (درآمد، هزینه‌ها، سقف بودجه و اهداف مالی) برای ارائه توصیه‌های مالی کاملاً تخصصی و شخصی‌سازی‌شده"
    ]
  },
  {
    version: "4.3.3",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۳.۳: حل مشکل مشاور مالی، به‌روزرسانی کارت‌های خلاصه با فیلتر تاریخ، پاکسازی نام‌های فنی و مقایسه روند ماهانه پس‌انداز",
    badge: "نسخه جدید v4.3.3",
    changes: [
      "طراحی و پیاده‌سازی نمودار کمانی دایره‌ای (Arc Gauge Graph) برای بخش سهم هزینه‌ها بر اساس دسته‌بندی با نمایش تفکیک رنگی درصدها و بزرگ‌ترین سهم مصرفی",
      "رفع مشکل صفحه سفید با اصلاح ترتیب فراخوانی داده‌های فیلترشده و متغیرهای محاسباتی در کامپوننت مدیریت مالی",
      "انتقال نوار فیلتر تاریخ به بالای کارت‌های خلاصه و به‌روزرسانی پویای مبالغ کارت‌ها بر اساس فیلترهای اعمال‌شده",
      "جایگزینی نمودار روزانه با «نمودار مقایسه ماهانه درآمد، هزینه و پس‌انداز در طول سال» جهت شناسایی ماه‌های پرمصرف و ماه‌های دارای بیشترین پس‌انداز",
      "رفع کامل مشکل ارتباط با مشاور هوشمند مالی و پاکسازی اسامی و برچسب‌های فنی غیرضروری از رابط کاربری"
    ]
  },
  {
    version: "4.3.2",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۳.۲: تکمیل فیلتر بازه زمانی تاریخ، مرتب‌سازی جدید به قدیم، نمودارهای تحلیلی ۳ گانه و دکمه مدیریت سوابق D1",
    badge: "نسخه جدید v4.3.2",
    changes: [
      "تکمیل فیلتر بازه زمانی تاریخ با انتخابگر تقویم و کلیدهای میانبر (این ماه، ۳ ماه اخیر) همراه با مرتب‌سازی جدیدترین به قدیمی‌ترین",
      "افزوده شدن ۳ نمودار تحلیلی تجسمی: ۱. سهم هزینه‌ها به تفکیک دسته‌بندی با نوار درصد، ۲. پایش زمان خرج‌کرد با میله‌های روزانه پرمصرف، ۳. رتبه‌بندی ۳ گانه ریزاقلام (گران‌ترین، پرمصرف‌ترین و ارزان‌ترین)",
      "ذخیره‌سازی و همگام‌سازی لحظه‌ای سوابق چت مشاور مالی هوشمند در Cloudflare D1 به همراه دکمه اختصاصی پاکسازی ۱۰۰٪ تاریخچه از دیتابیس ابری",
      "ارتقا و به‌روزرسانی زیرساختی نسخه اپلیکیشن به v4.3.2"
    ]
  },
  {
    version: "4.3.1",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۳.۱: ذخیره‌سازی ابری تاریخچه مشاور مالی در Cloudflare D1، فیلتر تاریخ و مرتب‌سازی جدید به قدیم، و نمودارهای پیشرفته تحلیل مصرف",
    badge: "نسخه جدید v4.3.1",
    changes: [
      "ذخیره‌سازی و همگام‌سازی ۱۰۰٪ تاریخچه گفتگوهای مشاور هوشمند مالی (AI Financial Advisor) در دیتابیس ابری Cloudflare D1 بدون استفاده از LocalStorage یا کش محلی",
      "اضافه شدن فیلتر بازه زمانی تاریخ (از تاریخ تا تاریخ) و مرتب‌سازی تضمینی جدیدترین به قدیمی‌ترین تراکنش‌ها (New to Old)",
      "ارتقای بخش گزارش‌ها با نمودارهای بصری تفکیک هزینه‌ها بر اساس دسته‌بندی، نمودار خطی/میله‌ای زمانی مصرف (پایش زمان خرج‌کرد)، و رتبه‌بندی گران‌ترین و پرمصرف‌ترین کالاها",
      "بهینه‌سازی کامل رابط کاربری موبایل (Mobile UI) برای تمامی بخش‌های ماژول مدیریت مالی با ناوبری لمسی رووان و کارت‌های فشرده استاندارد"
    ]
  },
  {
    version: "4.3.0",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۳.۰: اضافه شدن «مشاور هوشمند مالی و استراتژیست ثروت (AI Financial Advisor)» به مدیریت هوشمند فاکتورها و بودجه",
    badge: "نسخه جدید v4.3.0",
    changes: [
      "راه‌اندازی تب جدید «مشاور هوشمند مالی» (AI Financial Advisor) مجهز به هوش مصنوعی متخصص در بازارهای مالی، بودجه‌بندی و سرمایه‌گذاری",
      "تحلیل لحظه‌ای و آگاهی کامل هوش مصنوعی از وضعیت درآمد خالص، هزینه‌های ماهانه، سقف بودجه، دسته‌بندی‌ها و اهداف مالی فعال کاربر",
      "ارائه پیشنهادات تخصصی فارسی جهت افزایش نسبت پس‌انداز، ساخت صندوق اضطراری، بهینه‌سازی سبد سرمایه‌گذاری و مدیریت ریسک",
      "دارای پیشنهادات هوشمند سریع (Quick Prompts)، نمایش شاخص سلامت مالی (Financial Health Score)، و امکان مکالمه متقابل و تحلیل عمیق مالی"
    ]
  },
  {
    version: "4.2.6",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۲.۶: پشتیبانی کامل فاکتورهای چندخطی و فروشگاه‌های سوئدی (ICA، Rusta، Willys و...) با موتور Gemini 2.5 Flash",
    badge: "نسخه جدید v4.2.6",
    changes: [
      "به‌روزرسانی موتور هوش مصنوعی پردازش فاکتور به مدل Gemini 2.5 Flash با دستورالعمل‌های اختصاصی فاکتورهای چندخطی اروپایی",
      "شناسایی دقیق کالاها و قیمت‌های تفکیک‌شده در خطوط مجزا (مانند Mikrofiberduk 8-pack و ۲۹.۹۰ SEK در خط بعدی)",
      "پشتیبانی کامل از علامت منفی یونیکد (Unicode Minus −) و تخفیف‌های پروموشن چندخطی (مانند Baguette 2f25kr و −12,76 kr)",
      "ارتقای الگوریتم ماشین حالت محلی (Local State Machine Parser) برای استخراج ۱۰۰٪ دقیق ریزاقلام در صورت عدم دسترسی به API"
    ]
  },
  {
    version: "4.2.5",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۲.۵: انتقال ۱۰۰٪ کارت‌های اعتباری به Cloudflare D1 و بازطراحی مدرن کارت تراکنش‌ها برای iOS/Android",
    badge: "نسخه جدید v4.2.5",
    changes: [
      "حذف کامل حافظه محلی (localStorage) برای کارت‌های پرداختی سفارشی و ذخیره‌سازی و همگام‌سازی مستقیم ۱۰۰٪ داده‌ها در دیتابیس ابری Cloudflare D1",
      "بازطراحی مدرن و بهینه‌سازی کامل تراکنش‌ها و فاکتورها برای نمایش در اپلیکیشن موبایل (iOS و Android)",
      "درشت‌سازی، پررنگ‌سازی و افزایش خوانایی تاریخ ثبت (۲۰۲۶-۰۸-۰۶) و یادداشت‌ها (ثبت شده از ورود دستی / اسکنر AI) با بج‌های استاندارد و آیکون‌های اختصاصی"
    ]
  },
  {
    version: "4.2.4",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۲.۴: حل ریشه‌ای باگ کسر تخفیف‌های پلاس (Willys Plus / MAX3 -13,54 SEK) و اصلاح دقیق استخراج مبالغ منفی",
    badge: "نسخه جدید v4.2.4",
    changes: [
      "رفع باگ مطابقت الگوی عبارت با قاعده (Regex) که به دلیل وجود عبارت‌هایی مانند MAX3 -13,54 بجای ۱۳.۵۴ کرون، عدد ۳ را به اشتباه کسر می‌کرد",
      "اولویت‌دهی دقیق به اعداد دارای علامت منفی منفی‌آغازین (-13,54) و استخراج صحیح مقدار دقیق تخفیف اعضا",
      "کسر دقیق مبالغ تخفیف (۱۳.۵۴ SEK، ۱۳.۱۴ SEK، ۱۲.۷۲ SEK و ۵.۳۸ SEK) از قیمت کالای مربوطه و محاسبه مجدد قیمت واحد و مجموع فاکتور"
    ]
  },
  {
    version: "4.2.3",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۲.۳: پردازش هوشمند تخفیف‌های عضویت و پلاس (Willys Plus / Medlemsrabatt / Klubb) و کسر دقیق مبالغ منفی از قیمت کالاها",
    badge: "نسخه جدید v4.2.3",
    changes: [
      "اصلاح و حذف فیلتر اشتباه کلمات Willys Plus و تخفیف‌های عضویت از موتور پارسر فاکتورها",
      "شناسایی دقیق سطرهای تخفیف اعضا مانند Willys Plus (-13,54 SEK یا -5,38 SEK) و کسر مستقیم مبلغ از کالای بالایی",
      "محاسبه مجدد قیمت خالص هر کالا (net price) و قیمت واحد پس از اعمال تمامی تخفیف‌های فروشگاهی و باشگاه مشتریان",
      "ارتقای راهنمای prompt در هوش مصنوعی Gemini جهت اعمال خودکار تخفیف‌های پلاس و منفی روی totalPrice کالای مربوطه"
    ]
  },
  {
    version: "4.2.2",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۲.۲: دسته‌بندی غنی و هوشمند تراکنش‌های بانکی (Rich Categories) و جایگزینی/هم‌پوشانی خودکار فاکتورهای اسکن‌شده با تراکنش خام بانک",
    badge: "نسخه جدید v4.2.2",
    changes: [
      "موتور تشخیص دسته‌بندی بسیار گسترده و غنی (Rich Category Mapping) شامل بیش از ۱۰۰ فروشگاه و برند سوئدی و بین‌المللی (خواربار، رستوران، پوشاک، حمل‌ونقل، مسکن، قبوض، درمان، آموزش، سرگرمی، حقوق و پس‌انداز)",
      "سیستم هم‌پوشانی و جلوگیری از ثبت تکراری: هنگام ثبت فاکتور اسکن‌شده، تراکنش‌های هم‌پوشان خام بانک (مانند Willys یا ICA) بر اساس تاریخ (±۲ روز) و مبلغ به صورت خودکار شناسایی و با جزئیات کامل فاکتور جایگزین می‌شوند",
      "نمایش بنر هوشمند هشدار هم‌پوشانی در پیش‌نمایش فاکتور جهت اطمینان خاطر کاربر قبل از تایید نهایی"
    ]
  },
  {
    version: "4.2.1",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۲.۱: اولویت‌دهی دقیق به TransactionDate در فایل‌های CSV، ویرایش کامل پیش‌نمایش فاکتورهای AI، محاسبه دقیق مبلغ کل از اقلام و شناسایی تخفیف‌ها (Rabatt)",
    badge: "نسخه جدید v4.2.1",
    changes: [
      "اولویت‌دهی مطلق به ستون تاریخ تراکنش اصلی (TransactionDate / Transaktionsdatum) در خروجی‌های CSV بانک‌ها و جلوگیری از انتخاب اشتباه BookDate/ValueDate",
      "امکان انتخاب آنلاین روش پرداخت (کارت، سوئیش Swish، نقدی، انتقال) و کارت/حساب بانکی هدف در پیش‌نمایش استخراج فاکتور AI",
      "امکان ویرایش آنلاین تمامی اقلام فاکتور (نام کالا، دسته‌بندی، تعداد، قیمت واحد، قیمت کل) همراه با قابلیت افزودن ردیف جدید یا حذف کالا",
      "محاسبه زنده و دقیق مبلغ کل فاکتور مستقیم از مجموع قیمت صافی اقلام (بعد تخفیف) و بروزرسانی لحظه‌ای با تغییر اعداد",
      "شناسایی هوشمند سطر تخفیف‌های فروشگاهی (Rabatt) در اسکنر فاکتور (مانند Willys/ICA) و کسر مستقیم مبلغ تخفیف از قیمت نهایی کالا"
    ]
  },
  {
    version: "4.2.0",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۲.۰: ارتقای ورود دسته‌ای هوشمند صورت‌حساب‌های بانکی (Batch CSV Import) و انتساب مستقیم کارت",
    badge: "نسخه جدید v4.2.0",
    changes: [
      "پشتیبانی کامل از فرمت‌های متنوع خروجی CSV بانک‌های سوئدی و بین‌المللی با پردازش رشته‌های کوتیشن‌دار (مانند Merchant Category و Merchant Area)",
      "استخراج هوشمند و دقیق تاریخ (مانند M/D/YYYY و YYYY-MM-DD)، عنوان تراکنش، مبالغ منفی/مثبت و دسته‌بندی خودکار",
      "انتساب یکپارچه و مستقیم تمامی تراکنش‌های صورت‌حساب به کارت/حساب انتخابی کاربر و به‌روزرسانی آنی تمامی سطرها با تغییر کارت در بالای فرم",
      "ساده‌سازی جدول پیش‌نمایش و حذف کادرهای تکراری انتساب کارت در هر سطر جهت خلوت‌تر شدن رابط کاربری",
      "افزودن نمونه پیش‌فرض واقعی از خروجی‌های استاندارد بانکی جهت تست سریع"
    ]
  },
  {
    version: "4.1.9",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۱.۹: اصلاح کامل اسکنر هوشمند فاکتورها، استخراج دقیق اقلام واقعی Willys/بانک و حذف داده‌های نمونه فرضی",
    badge: "نسخه جدید v4.1.9",
    changes: [
      "رفع کامل ناهماهنگی پارامترهای ارتباطی بین فرانت‌اند و بک‌اند در پردازش هوشمند فاکتورها (/api/parse-invoice)",
      "استخراج دقیق و واقعی تمام اقلام فاکتورهای فروشگاهی (مانند Willys Bromma، قیمت‌ها، تخفیف‌ها، تاریخ و کارت بانکی متصل)",
      "پیاده‌سازی موتور بومی استخراج خط به خط فاکتور به عنوان پشتیبان (Fallback) جهت تضمین عدم نمایش داده‌های فرضی در صورت قطعی اینترنت یا هوش مصنوعی",
      "تنظیم کارت‌های پیش‌فرض اولیه به Swish, Debit Card, Credit Card, Cash همراه با امکان ویرایش نام و بازنشانی سریع"
    ]
  },
  {
    version: "4.1.8",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۱.۸: تنظیم کارت‌های پیش‌فرض دقیق به Swish, Debit Card, Credit Card, Cash و افزودن قابلیت ویرایش مستقیم نام کارت‌ها",
    badge: "نسخه جدید v4.1.8",
    changes: [
      "به‌روزرسانی کارت‌های پیش‌فرض اولیه دقیقاً به چهار گزینه: Swish، Debit Card، Credit Card، Cash (بدون نام‌های اختصاصی بانک‌ها یا فروشگاه‌ها)",
      "افزودن امکان ویرایش در-لحظه (In-line Edit) نام کارت‌ها با دکمه مداد ✏️ در مودال مدیریت کارت‌ها",
      "افزودن دکمه «بازنشانی به ۴ کارت پیش‌فرض» جهت بازگرداندن سریع لیست اولیه در صورت نیاز",
      "امکان افزودن کارت جدید، ویرایش نام کارت‌های موجود و یا حذف کامل آن‌ها"
    ]
  },
  {
    version: "4.1.7",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۱.۷: رفع مشکل مودال مدیریت کارت‌ها، کاهش کارت‌های پیش‌فرض و شفاف‌سازی ورود ۱۰۰٪ متنی CSV",
    badge: "نسخه جدید v4.1.7",
    changes: [
      "رفع کامل باگ سفید شدن صفحه هنگام کلیک روی دکمه «کارت‌ها و حساب‌های من» و اصلاح متغیرهای مودال",
      "کاهش فهرست کارت‌های اولیه به ۴ کارت اصلی و امکان پاکسازی یک‌باره («حذف همه») یا افزودن نام‌های دلخواه",
      "شفاف‌سازی رابط کپی و پیست متنی (Batch Import) و تغییر دکمه نمونه به «درج نمونه متن CSV جهت تست» جهت رفع سوءتفاهم آپلود فایل"
    ]
  },
  {
    version: "4.1.6",
    date: "۲۰ مرداد ۱۴۰۵ (2026-08-10)",
    title: "به‌روزرسانی ۴.۱.۶: مدیریت اختصاصی کارت‌های شخصی، نمایش میلادی ماه‌های بودجه و تشخیص و تطبیق هوشمند تراکنش‌های تکراری بانکی/فروشگاهی",
    badge: "نسخه جدید v4.1.6",
    changes: [
      "مدیریت، افزودن و ویرایش کارت‌ها و حساب‌های پرداختی شخصی (حذف فهرست ثابت بانک‌ها و امکان تعریف سفارشی کارت‌ها مانند SEB Debit, ICA Card, Handelsbanken)",
      "نمایش دقیق نام ماه‌ها به صورت میلادی (مانند Aug 2026, Sep 2026) در بخش تحلیل و تاریخچه بودجه‌بندی ماهانه",
      "ساده‌سازی ورود دسته‌ای تراکنش‌ها (Batch Import): تمرکز ۱۰۰٪ روی کپی و پیست متنی صورت‌حساب‌های CSV و حذف آپلود فایل",
      "سیستم هوشمند تشخیص و تطبیق تراکنش‌های تکراری (Smart Deduplication & Matching) بین خریدهای فروشگاهی (مانند ICA, Hemköp) و صورت‌حساب‌های بانکی (SEB, Handelsbanken)",
      "جلوگیری خودکار از دوبار ثبت شدن تراکنش‌ها و جایگزینی/ترکیب تراکنش‌های عمومی بانک با فاکتورهای دقیق فروشگاهی"
    ]
  },
  {
    version: "4.1.5",
    date: "۱۹ مرداد ۱۴۰۵ (2026-08-09)",
    title: "به‌روزرسانی ۴.۱.۵: تفکیک و مدیریت کارت‌های پرداختی و ورود دسته‌ای هوشمند تراکنش‌ها با پیش‌نمایش و تأیید نهایی",
    badge: "نسخه جدید v4.1.5",
    changes: [
      "مدیریت و انتخاب کارت/حساب پرداختی برای هر تراکنش (مانند کارت‌های هاندلزبنکن، نوردیا، اس‌ای‌بی، سوئدبانک، سوئیش، کارت‌های فروشگاهی همخوپ، ویلیس، ایکا، ریولوت، کلارنا و کارت‌های سفارشی)",
      "امکان فیلتر و مشاهده مجموع هزینه‌ها و تراکنش‌ها به تفکیک کارت‌ها و حساب‌های مختلف پرداختی",
      "سیستم ثبت دسته‌ای و هوشمند تراکنش‌ها (Batch Import) از فاکتورها، فایل‌های CSV یا اکسپورت بانک‌ها و فروشگاه‌ها (Handelsbanken, Hemköp, Swish, Nordea)",
      "جدول هوشمند پیش‌نمایش و ویرایش تمام تراکنش‌های دسته‌ای شناسایی‌شده قبل از ثبت، با قابلیت انتخاب/لغو همه و اعمال دسته‌ای کارت یا دسته‌بندی",
      "دکمه صریح و ایمن «تأیید و ثبت نهایی» برای درج دقیق تراکنش‌های انتخابی در پایگاه داده"
    ]
  },
  {
    version: "4.1.4",
    date: "۱۹ مرداد ۱۴۰۵ (2026-08-09)",
    title: "به‌روزرسانی ۴.۱.۴: انتخابگر هوشمند ماه و خلاصه تاریخچه بودجه‌بندی ماه‌های مختلف",
    badge: "نسخه جدید v4.1.4",
    changes: [
      "امکان انتخاب و تحلیل انحراف بودجه برای ماه‌های مختلف (ماه جاری، ماه‌های گذشته و آینده) با اعمال الگوی ثابت بودجه",
      "طراحی نوار ناوبری ماه‌ها با دکمه‌های پیمایش قبلی/بعدی، بازگشت سریع به ماه جاری و نام‌گذاری هجری شمسی و میلادی",
      "ایجاد بخش جامع «تاریخچه و خلاصه عملکرد بودجه‌بندی ماه‌های مختلف» همراه با نمایش سقف، هزینه‌کرد واقعی، انحراف/مانده و درصد مصرف",
      "امکان ارجاع و بارگذاری مستقیم جزئیات هر ماه تنها با یک کلیک از جدول خلاصه تاریخچه"
    ]
  },
  {
    version: "4.1.3",
    date: "۱۹ مرداد ۱۴۰۵ (2026-08-09)",
    title: "به‌روزرسانی ۴.۱.۳: حذف مقادیر پیش‌فرض درآمد، محاسبه لحظه‌ای مانده تخصیص نیافته بودجه و گیج‌های هوشمند دسته‌بندی‌ها",
    badge: "نسخه جدید v4.1.3",
    changes: [
      "حذف مقادیر عددی پیش‌فرض و غیرواقعی در فرم تنظیم درآمد و سقف هزینه‌ها جهت تجربه کاربری شفاف و سفارشی",
      "محاسبه و نمایش زنده مجموع بودجه تخصیص‌یافته به دسته‌بندی‌ها در برابر سقف کل هزینه‌ها با هشدار مازاد بودجه و نمایش مانده تخصیص‌نیافته",
      "امکان صفر کردن یا حذف بودجه دسته‌بندی‌های بدون هزینه و به‌روزرسانی آنی محاسبات",
      "طراحی گیج‌های دیداری پیشرفته (Progress Gauges) با درصد مصرف، وضعیت مانده مجاز و رنگ‌های هشداری هوشمند برای تمامی دسته‌بندی دارای بودجه"
    ]
  },
  {
    version: "4.1.2",
    date: "۱۹ مرداد ۱۴۰۵ (2026-08-09)",
    title: "به‌روزرسانی ۴.۱.۲: سیستم یکپارچه انتخاب ارز پایه (Base Currency) با همگام‌سازی لحظه‌ای در تمام تب‌های مالی",
    badge: "نسخه جدید v4.1.2",
    changes: [
      "افزودن نوار کنترل سریع ارز پایه (Base Currency) در هدر ماژول مدیریت مالی با دسترسی مستقیم و آسان جهت تغییر ارز سیستم",
      "همگام‌سازی آنی و لحظه‌ای ارز انتخابی در تمامی بخش‌ها: ثبت فاکتور جدید، اسکنر هوشمند AI، اهداف پس‌انداز، بودجه‌بندی ماهانه و کارت‌های شاخص مالی",
      "امکان تغییر سریع بین ارزهای ریال ایران (پیش‌فرض)، تومان، کرون سوئد (SEK)، یورو (EUR) و دلار (USD) با به‌روزرسانی خودکار فرم‌ها"
    ]
  },
  {
    version: "4.1.1",
    date: "۱۹ مرداد ۱۴۰۵ (2026-08-09)",
    title: "به‌روزرسانی ۴.۱.۱: بودجه‌بندی تخصصی بر اساس دسته‌بندی‌های غنی (مسکن، خواربار، قبوض و...) و پشتیبانی از ارز پایه ریال ایران",
    badge: "نسخه جدید v4.1.1",
    changes: [
      "تعیین سقف بودجه مجاز برای هر یک از دسته‌بندی‌های غنی مالی (اجاره و مسکن، خواربار و سوپرمارکت، قبوض و انرژی، حمل‌ونقل، رستوران، سلامت و...) به صورت مبلغی و درصدی",
      "تحلیل بصری و هشدار هوشمند مصرف بودجه به تفکیک دسته‌بندی با گیج‌های رنگی و محاسبه درصد استفاده و مانده بودجه مجاز هر بخش",
      "پشتیبانی کامل از ارزهای متنوع (ریال ایران - ارز پیش‌فرض سیستم، تومان، کرون سوئد SEK، یورو EUR، دلار USD) و امکان تغییر آسان ارز پیش‌فرض کاربری",
      "امکان تخصیص هوشمند و خودکار سقف بودجه دسته‌بندی‌ها بر اساس سقف کل هزینه‌ها"
    ]
  },
  {
    version: "4.1.0",
    date: "۱۹ مرداد ۱۴۰۵ (2026-08-09)",
    title: "ارتقاء به نسخه ۴.۱.۰: راه‌اندازی سیستم بودجه‌بندی هوشمند درآمد خالص، تخمین زمان تحقق اهداف مالی و غنی‌سازی دسته‌بندی‌ها",
    badge: "نسخه جدید v4.1.0",
    changes: [
      "پیاده‌سازی سیستم بودجه‌بندی هوشمند بر اساس درآمد خالص ماهانه پس از مالیات (Net Income) با امکان تعیین درصدی و مبلغی سقف هزینه‌ها و سهم پس‌انداز",
      "گراف و گیج پیشرفته بصری وضعیت بودجه ماه جاری: نمایش میزان هزینه‌شده، مانده بودجه مجاز، درصد استفاده و هشدارهای هوشمند رنگی در صورت تخطی از بودجه",
      "تحلیل و تخمین هوشمند زمان تحقق اهداف مالی: محاسبه خودکار زمان مورد نیاز برای رسیدن به اهداف پس‌انداز بر اساس بودجه تخصیصی ماهانه",
      "نمایش زنده و تعاملی مانده بودجه در زمان ثبت فاکتور یا تراکنش جدید جهت پیش‌بینی دقیق مانده بودجه پس از خرید",
      "توسعه دسته‌بندی‌های غنی و جامع مالی (۱۳ دسته‌بندی با آیکون‌های مدرن): سوپرمارکت، مسکن، قبوض/انرژی، حمل‌ونقل/سوخت، رستوران/کافه، سلامت/دارو، پوشاک/زیبایی، آموزش، تفریح/سفر، فرزندان/خانواده، حقوق، پس‌انداز/سرمایه‌گذاری و خدمات متفرقه"
    ]
  },
  {
    version: "4.0.1",
    date: "۱۹ مرداد ۱۴۰۵ (2026-08-09)",
    title: "به‌روزرسانی ۴.۰.۱: بهینه‌سازی محاسبات فاکتور و پاک‌سازی عناوین فنی سیستم",
    badge: "اصلاحیه v4.0.1",
    changes: [
      "اصلاح فرمول و منطق محاسبه مبلغ کل فاکتور هنگام افزودن اقلام به صورت تفکیکی (محاسبه دقیق مجموع اقلام و غیرفعال‌سازی ورودی دستی جهت جلوگیری از دوبار احتساب)",
      "پاک‌سازی و ساده‌سازی تمامی متون دکمه‌ها و نشانگرهای UI جهت حذف اصطلاحات فنی پایگاه داده (مانند D1) و ارتقاء زیبایی بصری"
    ]
  },
  {
    version: "4.0.0",
    date: "۱۹ مرداد ۱۴۰۵ (2026-08-09)",
    title: "ارتقاء به نسخه ۴.۰.۰: پیاده‌سازی مرکز مدیریت مالی شخصی و استخراج AI فاکتورها + زیباسازی ورود گوگل",
    badge: "نسخه جدید v4.0.0",
    changes: [
      "زیباسازی کامل دکمه و کارت ورود گوگل (Google Identity Services) با حاشیه گرادیان رنگی گوگل، گردی استاندارد Pill و استایل‌های بهینه‌شده Vazirmatn",
      "طراحی و پیاده‌سازی ماژول جدید مدیریت مالی شخصی (Personal Finance) جهت ثبت پرداختی‌های سوئیش (Swish)، نقد، کارت و انتقال حساب",
      "افزودن اسکنر و تحلیل‌گر هوشمند فاکتورها با هوش مصنوعی (AI Invoice Scanner): استخراج خودکار فروشگاه، مبلغ کل، روش پرداخت و جدول دقیق اقلام خریداری شده با Gemini",
      "گزارش‌گیری پیشرفته از مصرف کالاها (Product Consumption Analytics): جستجوی کالاها (مانند شیر، نان...)، محاسبه تعداد خریدهای ماهانه، کل هزینه و رتبه‌بندی پرخریدترین اقلام",
      "بخش اهداف مالی و برنامه‌ریزی پس‌انداز (Financial Goals): تعریف اهداف خرید مسکن، خودرو یا سفر، ثبت پس‌انداز موجود، محاسبه مبلغ باقی‌مانده و درصد پیشرفت"
    ]
  },
  {
    version: "3.9.0",
    date: "۱۸ مرداد ۱۴۰۵ (2026-08-08)",
    title: "ارتقاء به نسخه ۳.۹.۰: غنی‌سازی کامل مرکز یادآورهای خانوادگی و رفع مشکل به‌روزرسانی زنده UI",
    badge: "نسخه جدید v3.9.0",
    changes: [
      "افزودن دسته‌بندی‌های جامع جدید به مرکز یادآورهای خانوادگی (تولد و سالگردها، قبوض و مالی، مدرسه و آموزش، رویداد و قرار ملاقات، پزشکی، خرید، شخصی و خانواده)",
      "رفع کامل مشکل به‌روزرسانی رابط کاربری (Instant UI Re-render): اعمال فوری ایجاد، ویرایش، حذف و تغییر وضعیت یادآورها بدون نیاز به رفرش یا تعویض تب",
      "افزودن پلتفرم پیشنهادهای سریع (Quick Presets) جهت ثبت ۱کلیکی یادآورهای تولد، قبوض ماهانه، جلسات مدرسه و چکاپ پزشکی",
      "تنظیم خودکار تکرار سالانه برای یادآورهای تولد و همگام‌سازی لحظه‌ای با دیتابیس ابری Cloudflare D1 و تقویم گوگل (Google Calendar)"
    ]
  },
  {
    version: "3.8.2",
    date: "۱۸ مرداد ۱۴۰۵ (2026-08-08)",
    title: "ارتقاء به نسخه ۳.۸.۲: بروزرسانی فرمت هجری قمری استاندارد (السبت ، ۲۴ صفر ۱۴۴۸)",
    badge: "نسخه جدید v3.8.2",
    changes: [
      "اصلاح فرمت تاریخ هجری قمری مطابق ساختار دقیق قمری: «السبت ، ۲۴ صفر ۱۴۴۸ (۲۴ - ۲ - ۱۴۴۸)»",
      "نمایش همزمان روز هفته عربی/قمری، نام ماه قمری، سال قمری و ساختار عددی روز - ماه - سال",
      "تثبیت عملکرد تبدیل تقویم و نمایش دقیق مناسبت‌های سوئد و ایران در تمام مرورگرها"
    ]
  },
  {
    version: "3.8.1",
    date: "۱۸ مرداد ۱۴۰۵ (2026-08-08)",
    title: "ارتقاء به نسخه ۳.۸.۱: اصلاح دقیق چیدمان تاریخ شمسی، نمایش تاریخ قمری، مناسبت‌های سوئد و ایران و حذف برچسب‌های آفلاین",
    badge: "نسخه جدید v3.8.1",
    changes: [
      "اصلاح دقیق ترتیب نمایش تاریخ شمسی به صورت استاندارد «روز هفته، روز ماه سال» (مثال: شنبه، ۱۸ مرداد ۱۴۰۵)",
      "افزودن نمایش خودکار تاریخ هجری قمری (مثال: ۲۴ صفر ۱۴۴۸ قمری) و تاریخ میلادی در سربرگ تقویم برنامه‌ریزی",
      "افزودن کارت مناسبت‌های روز برای سوئد (نام‌گذاری‌ها، روزهای پرچم رسمی و اعیاد ملی سوئد مانند Drottning Silvias namnsdag) و ایران",
      "حذف کامل برچسب‌های گمراه‌کننده «آفلاین» از تمام منوها، هدرها و فوترها و شفاف‌سازی همگام‌سازی ابری دیتابیس D1"
    ]
  },
  {
    version: "3.8.0",
    date: "۱۸ مرداد ۱۴۰۵ (2026-08-08)",
    title: "ارتقاء به نسخه ۳.۸.۰: همگام‌سازی زنده داده‌های هیدراتاسیون و خواب بین دستگاه‌ها و تثبیت کامل سوابق پزشک در D1",
    badge: "نسخه جدید v3.8.0",
    changes: [
      "افزودن قابلیت همگام‌سازی آنی (Real-Time Multi-Device Sync) برای داده‌های پایش روزانه (آب، خواب، رژیم و غیره) بین موبایل و دسکتاپ بدون نیاز به Ctrl+F5 یا رفرش دستی",
      "فعال‌سازی سیستم پایش زنده تغییرات (Polling) و همگام‌سازی خودکار در زمان فوکوس یا بازگشت به تب در مرورگرهای مختلف",
      "اصلاح کامل ذخیره‌سازی و بازخوانی سوابق مشاوره‌های پزشکی (Personal Doctor) به صورت مستقیم در Cloudflare D1 و حل مشکل پاک شدن داده‌ها بعد از رفرش",
      "پشتیبانی کامل از حذف و افزودن مشاوره‌های جدید با به‌روزرسانی آنی حافظه و دیتابیس ابری"
    ]
  },
  {
    version: "3.7.0",
    date: "۱۸ مرداد ۱۴۰۵ (2026-08-08)",
    title: "ارتقاء به نسخه ۳.۷.۰ و تثبیت کامل ۱۰۰٪ همگام‌سازی مستقیم داده‌های دفترچه خرید خانوادگی با Cloudflare D1",
    badge: "نسخه جدید v3.7.0",
    changes: [
      "اصلاح کامل فرآیند ذخیره‌سازی و دریافت لیست‌های خرید خانوادگی (Shared Shopping Lists) به صورت مستقیم در Cloudflare D1 با افزودن ستون raw_data و پشتیبانی از فیلترهای ایمیل/شناسه کاربران اشتراکی",
      "حذف کامل هرگونه حافظه محلی (localStorage) از بخش‌های مشاوره پزشکی و تضمین فراخوانی بی‌واسطه از Cloudflare D1",
      "پایبندی ۱۰۰٪ به قانون اول برنامه: ذخیره‌سازی و بازیابی تمامی داده‌ها (کاربران، یادآورها، لیست خرید، پرونده‌های سلامت، وعده‌های غذایی و فایل‌ها) صرفاً از طریق Cloudflare D1 REST API",
      "بهبود تطبیق هوشمند نام و تصویر پروفایل گوگل کاربران در زمان ذخیره در دیتابیس D1"
    ]
  },
  {
    version: "3.6.0",
    date: "۱۷ مرداد ۱۴۰۵ (2026-08-07)",
    title: "بهینه‌سازی کامل پروفایل کاربران گوگل، حذف دیتابیس محلی و ارتقاء به نسخه ۳.۶.۰",
    badge: "نسخه جدید v3.6.0",
    changes: [
      "بهبود دریافت نام کامل و تصویر آواتار گوگل (Gmail) هنگام ورود و جایگزینی عناوین پیش‌فرض نظیر «پیشرفت» و «کاربر پیشرفت»",
      "اصلاح فرمت‌دهی هوشمند اسامی کاربران در ماژول «مدیریت و پایش کاربران» با استفاده از ایمیل و داده‌های معتبر کاربر",
      "حذف پایگاه داده محلی SQLite و تنظیم gitignore جهت اطمینان از عدم وجود دیتابیس محلی و اتصال مستقیم و همیشگی به Cloudflare D1",
      "بهبود نمایش آواتار کاربران با سیستم لایه‌بندی رزرو (Fallback Initials) در صورت عدم بارگیری تصویر گوگل"
    ]
  },
  {
    version: "3.5.0",
    date: "۱۷ مرداد ۱۴۰۵ (2026-08-07)",
    title: "ارتقاء به ورود مستقیم گوگل (GIS) و رفع مشکلات بارگیری کاربران و سوابق پزشک",
    badge: "نسخه جدید v3.5.0",
    changes: [
      "مهاجرت معماری ورود گوگل به احراز هویت پاپ‌آپ مستقیم (Google Identity Services) با ارسال توکن شناسه به Cloudflare Worker",
      "رفع کامل مشکل بارگیری داده‌ها در بخش «مدیریت و پایش کاربران» با دریافت مستقیم لیست کاربران و لوگ‌های فعالیت از D1",
      "رفع مشکل ناپدید شدن داده‌های «دستیار فوق‌تخصص پزشکی» و سوابق مشاوره پس از رفرش صفحه با ذخیره درست created_at و افزودن کش محلی زنده",
      "اصلاح تبدیل اعداد فارسی به انگلیسی در فرم پرونده سلامت (قد، وزن، سن) جهت جلوگیری از ایجاد مقادیر NaN و پاک شدن اطلاعات"
    ]
  },
  {
    version: "3.4.0",
    date: "۱۵ مرداد ۱۴۰۵ (2026-08-06)",
    title: "پاکسازی ۱۰۰٪ و کامل تمام وابستگی‌ها، فایل‌ها و مراجع پایگاه داده قبلی",
    badge: "نسخه جدید v3.4.0",
    changes: [
      "حذف کامل اسکریپت‌های مهاجرت، گزارش‌ها و فایل‌های کانفیگ مربوطه",
      "جایگزینی کلیه مراجع متنی و توابع باقیمانده با پایگاه داده Cloudflare D1",
      "اصلاح و تقویت تابع بررسی ثبت رکوردهای قبلی (hasRecord) در دیتابیس سرویس جهت جلوگیری از خطاهای احتمالی insert/update",
      "تضمین ذخیره‌سازی و بارگیری ۱۰۰٪ مستقیم تمامی داده‌ها از طریق Cloudflare Worker REST API"
    ]
  },
  {
    version: "3.3.0",
    date: "۱۵ مرداد ۱۴۰۵ (2026-08-06)",
    title: "حذف کامل کدهای فایربیس و اصلاح ۱۰۰٪ ماندگاری داده‌های روزانه در دیتابیس D1",
    badge: "نسخه جدید v3.3.0",
    changes: [
      "رفع مشکل عدم ماندگاری وعده‌های غذایی و داده‌های روزانه پس از بروزرسانی صفحه با یکپارچه‌سازی شناسه کاربر (user.id / user.uid)",
      "پاکسازی کامل پکیج و کدهای باقیمانده فایربیس و استفاده انحصاری و مستقیم از Cloudflare D1 برای تمامی ذخیره‌سازی‌ها و بازیابی‌ها",
      "تنظیم متغیرهای محیطی کامل و دقیق ورکر Cloudflare Worker و گوگل کنسول",
      "همگام‌سازی زنده و خودکار تمامی سوابق روزانه با پایگاه داده Cloudflare D1"
    ]
  },
  {
    version: "3.2.0",
    date: "۱۵ مرداد ۱۴۰۵ (2026-08-06)",
    title: "مستندسازی و تنظیم متغیرهای محیطی Cloudflare Worker و Google OAuth",
    badge: "v3.2.0",
    changes: [
      "افزوده شدن متغیرهای محیطی ورکر (GOOGLE_CLIENT_ID, GOOGLE_CLIENT_SECRET, GOOGLE_REDIRECT_URI, FRONTEND_URL, API_KEY)",
      "مستندسازی کامل راهنمای تنظیمات ورکر Cloudflare Worker و D1 Binding"
    ]
  },
  {
    version: "3.1.0",
    date: "۱۴ مرداد ۱۴۰۵ (2026-08-05)",
    title: "مهاجرت کامل و ۱۰۰٪ به پایگاه داده ابری Cloudflare D1",
    badge: "نسخه جدید v3.1.0",
    changes: [
      "مهاجرت کامل ۱۰۰٪ داده‌ها، دستیار آموزشی، رادار اخبار، لیست خرید، یادآورها، پزشک هوش مصنوعی، برنامه‌های غذایی، سوابق روزانه و پرونده سلامت به Cloudflare D1",
      "حذف کامل کتابخانه و کدهای مربوط به دیتابیس قبلی از تمامی ماژول‌ها",
      "انتقال تمامی درخواست‌های پایگاه داده از طریق انpoint امن Cloudflare Worker همراه با توکن شناسه کاربر",
      "حذف تمام حافظه‌های محلی غیرضروری مرورگر و تضمین ذخیره‌سازی مستقیم و ابری تمامی داده‌های کاربر در D1",
      "بهینه‌سازی کامل کارایی و زمان پاسخ‌دهی لایو برنامه در تمامی دستگاه‌ها"
    ]
  },
  {
    version: "3.0.0",
    date: "۱۴ مرداد ۱۴۰۵ (2026-08-05)",
    title: "ارتقاء بزرگ معماری دیتابیس به Cloudflare D1 با لایه سرویس یکپارچه و قابلیت سوئیچ آنی",
    badge: "نسخه جدید v3.0.0",
    changes: [
      "انتقال کامل معماری دیتابیس به Cloudflare D1 به عنوان پایگاه داده ابری اصلی و پیش‌فرض برنامه",
      "طراحی و پیاده‌سازی لایه سرویس جامع DatabaseService برای برقراری ارتباط با دیتابیس SQL بر پایه‌ SQLite/D1",
      "ارتقاء ۱۰۰٪ سرویس‌های ذخیره‌سازی برنامه (تنظیمات، یادآورها، پرونده سلامت، لیست خرید، رادار اخبار، داده‌های آموزشی AI و فایل‌های ابری) جهت پشتیبانی کامل از D1",
      "افزوده شدن ماژول مدیریت دیتابیس در بخش تنظیمات/مدیریت برای مشاهده وضعیت دیتابیس",
      "تضمین پایداری، عملکرد بالا، زمان پاسخ‌دهی لایو و یکپارچگی داده‌ها در تمامی بخش‌های برنامه"
    ]
  },
  {
    version: "2.4.0",
    date: "۱۴ مرداد ۱۴۰۵ (2026-08-04)",
    title: "ارتقاء موتور هوش مصنوعی پزشک (AI Doctor) و رندرینگ جداول و پاسخ‌های ساختاریافته",
    badge: "بروزرسانی جدید",
    changes: [
      "یکپارچه‌سازی کامل پرونده سلامت کاربر (قد، وزن، سن، بیماری‌ها، داروها و اهداف) در تمام بخش‌های برنامه در یک محل واحد با همگام‌سازی ابری زنده",
      "ارتقاء پرامپت بالینی هوش مصنوعی جهت جلوگیری کامل از پاسخ‌های عمومی، متون ناخواسته یا کاراکترهای نامفهوم و تمرکز ۱۰۰٪ روی پاسخ پزشکی تخصصی به سوالات بیمار",
      "افزوده شدن رندرینگ پیشرفته مارک‌داون (ReactMarkdown & Remark-GFM) برای نمایش شکیل جداول بالینی، هشدارها، لیست دمنوش‌ها و مکمل‌ها با تایپوگرافی زیبا و RTL",
      "نمایش مدل هوش مصنوعی پاسخ‌دهنده و زمان پاسخ‌گویی به میلی‌ثانیه برای هر مشاوره ثبت‌شده"
    ]
  },
  {
    version: "2.3.0",
    date: "۱۴ مرداد ۱۴۰۵ (2026-08-04)",
    title: "ماژول جدید پزشک اختصاصی (AI Doctor) و مدیریت تاریخ خرید دفترچه‌ها",
    badge: "نسخه جدید",
    changes: [
      "طراحی و پیاده‌سازی ماژول جدید «پزشک اختصاصی (AI Doctor)» جهت تحلیل هوشمند سوالات پزشکی، بیماری‌های خاص، داروها، سن، وزن و کالری مصرفی امروز کاربر با خروجی‌های شکیل و ساختاریافته",
      "افزوده شدن قابلیت تعیین و پیگیری تاریخ خرید / انجام برنامه‌ریزی (Purchase Date) برای هر دفترچه خرید خانوادگی با نشانگر زنده و تقویم فارسی",
      "امکان ثبت پرونده سلامت شخصی شامل سن، وزن، قد، بیماری‌های خاص (کبد چرب، فشار خون، دیسک کمر) و داروهای مصرفی و ذخیره‌سازی ابری زنده در پایگاه داده ابری Cloudflare D1",
      "همگام‌سازی ۱۰۰٪ مشاوره‌های پزشکی و دفترچه‌ها در پایگاه داده ابری Cloudflare D1 بدون ذخیره‌سازی محلی در مرورگر (Local Storage)"
    ]
  },
  {
    version: "2.2.0",
    date: "۱۰ مرداد ۱۴۰۵ (2026-07-31)",
    title: "بخش اختصاصی عادات روزانه (قهوه سلامتی)، میان‌وعده‌های فصلی و همگام‌سازی ابری D1",
    badge: "نسخه جدید",
    changes: [
      "طراحی و پیاده‌سازی بخش اختصاصی «عادات و پروتکل‌های سلامت روزانه» با تاکید بر قهوه سلامتی تحریک‌کننده هورمون GLP-1 (کولد برو / اسپرسو + گردو + چیا)، فواید کامل، نحوه تهیه و چک‌لیست تعاملی روزانه",
      "پشتیبانی کامل از «میان‌وعده‌ها (Snacks)» در کنار وعده ناهار در تمام ۳۰ روز فصل‌های ۴گانه با قابلیت فیلتر وعده (همه / ناهار / میان‌وعده) و ثبت مجزا در دفترچه تغذیه",
      "حذف کامل متن‌های خاص و جایگزینی با عبارات استاندارد و جامع علمی تغذیه و سلامت متابولیک (GLP-1)",
      "ذخیره‌سازی ۱۰۰٪ مستقیم داده‌ها و عادات در پایگاه داده ابری Cloudflare D1 بدون اتکا به localStorage"
    ]
  },
  {
    version: "2.1.1",
    date: "۱۰ مرداد ۱۴۰۵ (2026-07-31)",
    title: "بهینه‌سازی کامل فرمت خروجی دستیار هوش مصنوعی و پالایش کلمات فارسی",
    badge: "به‌روزرسانی",
    changes: [
      "پیاده‌سازی رندرینگ پیشرفته و شکیل پاسخ‌های دستیار هوش مصنوعی (رندر جداول مارک‌داون به جداول اختصاصی، عناوین رنگی و بولت‌های مرتب)",
      "پاکسازی ۱۰۰٪ کلمات ناخواسته غیرفارسی و اصلاح ترجمه‌ها به فارسی روان، سلیس و کاملاً قابل فهم",
      "اضافه شدن قابلیت کپی یک‌کلیکی متن تحلیل هوش مصنوعی با دکمه اختصاصی"
    ]
  },
  {
    version: "2.1.0",
    date: "۱۰ مرداد ۱۴۰۵ (2026-07-31)",
    title: "ماژول جدید برنامه غذایی فصلی و ۳۰ روزه تحریک هورمون GLP-1 (آمپول‌های طبیعی اوزمپیک و منجارو)",
    badge: "ویژگی جدید",
    changes: [
      "طراحی و پیاده‌سازی کامل ماژول جدید «برنامه غذایی فصلی و ۳۰ روزه (GLP-1)» بر اساس اصول علمی ویدئوی دکتر بابک جمالیان",
      "برنامه ۳۰ روزه ناهار ۴ فصل (بهار، تابستان، پاییز، زمستان) شامل غذاهای اصیل، سنتی و آشنای ایرانی (خورش‌ها، پلوها، کباب‌ها، آش‌ها و سوپ‌ها)",
      "تشخیص خودکار فصل جاری با امکان سوئیچ بین ۴ فصل و مشاهده غذاها به تفکیک هفته (هفته ۱ و ۳ / هفته ۲ و ۴)",
      "ارائه لیست خرید هفتگی، خلاصه مواد مصرفی ماهانه، آنالیز تغذیه‌ای کل ماه و ترفندهای صرفه‌جویی در زمان برای هر فصل",
      "امکان ویرایش مستقیم غذاها و ذخیره‌سازی اختصاصی در پایگاه داده ابری Cloudflare D1",
      "ادغام با دستیار هوش مصنوعی برنامه جهت جایگزینی، شخصی‌سازی و بهینه‌سازی وعده‌ها و ارائه دستور پخت",
      "قابلیت ثبت سریع وعده‌های غذایی پیشنهادی به‌طور مستقیم در دفترچه تغذیه امروز"
    ]
  },
  {
    version: "2.0.0",
    date: "۹ مرداد ۱۴۰۵ (2026-07-30)",
    title: "پاکسازی ۱۰۰٪ و مطلق تمام کدهای برنامه از LocalStorage و انتقال کامل به Cloudflare D1",
    badge: "نسخه جدید",
    changes: [
      "پاکسازی و حذف کامل کلیه کُدها، توابع و فراخوانی‌های مربوط به LocalStorage در سراسر فایل‌های پروژه (یادآورها، لیست خرید، یادگیری، تغذیه و همگام‌سازی اولیه)",
      "تضمین ذخیره‌سازی و دریافت مستقیم ۱۰۰٪ کلیه داده‌ها، تنظیمات، یادآورها و اعضای خانواده در دیتابیس ابری Cloudflare D1",
      "پشتیبانی کامل از همگام‌سازی لحظه‌ای بدون اتکا به هیچ حافظه داخلی یا محلی در مرورگر",
      "امکان شروع کاملاً پاک و تمیز داده‌ها در دیتابیس ابری Cloudflare D1 بدون باقی‌مانده‌های ذخیره محلی"
    ]
  },
  {
    version: "1.9.0",
    date: "۹ مرداد ۱۴۰۵ (2026-07-30)",
    title: "انتقال کامل ۱۰۰٪ داده‌ها به دیتابیس ابری D1 و حذف مطلق حافظه محلی (localStorage)",
    changes: [
      "حذف کامل و ۱۰۰ درصدی وابسته به LocalStorage و حافظه محلی در کلیه یادآورها و اعضای خانواده",
      "ذخیره‌سازی و بارگیری مستقیم و مستقیم کلیه اعضا و یادآورها از پایگاه داده ابری Cloudflare D1",
      "اجرای سیستم پاکسازی خودکار و قطعی تمامی یادآورهای نمونه قدیمی از ابلاغیه‌های دیتابیس ابری و مرورگر",
      "حذف تمامی نام‌های پیش‌فرض خانواده و نگه داشتن تنها «من» به عنوان پیش‌فرض اولیه و واگذاری تعریف بقیه اعضا به کاربر"
    ]
  },
  {
    version: "1.8.0",
    date: "۹ مرداد ۱۴۰۵ (2026-07-30)",
    title: "حذف کامل اعضای پیش‌فرض، شروع کاملاً خالی و ذخیره قطعی اعضا و یادآورها در دیتابیس D1",
    changes: [
      "حذف کامل تمام افراد پیش‌فرض (همسر/خانواده، فرزند ۱، فرزند ۲، بنیتا) و تنها باقی ماندن «من» به عنوان پیش‌فرض اولیه",
      "الزام تعریف و مدیریت تمامی اعضای خانواده به‌طور مستقیم توسط خود کاربر از طریق بخش «مدیریت اعضا»",
      "ذخیره‌سازی و همگام‌سازی لحظه‌ای تمامی اعضای تعریف‌شده خانواده در دیتابیس ابری Cloudflare D1",
      "مکانیسم پاکسازی قطعی تمام یادآورهای قدیمی ثبت‌شده در دیتابیس و مرورگر جهت شروع کاملاً واقعی و تمیز",
      "تضمین ذخیره تمام یادآورهای جدید ایجاد شده به تفکیک اعضای سفارشی کاربر در دیتابیس D1"
    ]
  },
  {
    version: "1.7.0",
    date: "۹ مرداد ۱۴۰۵ (2026-07-30)",
    title: "منوی آکاردئونی تاشو و پاکسازی کامل داده‌های مرکز یادآورها",
    changes: [
      "پاکسازی کامل تمامی داده‌های موجود در «مرکز یادآورهای خانوادگی» و شروع کاملاً تمیز و واقعی",
      "افزودن دکمه «پاکسازی همه» در هدر یادآورها جهت حذف یکباره تمام یادآورها با تأیید کاربر",
      "سیستم جدید پاکسازی خودکار کلیدهای حافظه محلی متناسب با نسخه جدید 1.7.0",
      "تبدیل منوی اصلی برنامه در سایدبار دسکتاپ و کشوی موبایل به منوی آکاردئونی تاشو (Collapsible Sections)",
      "باز و بسته شدن هوشمند هر بخش با کلیک بر روی عنوان گروه و باز شدن خودکار بخش فعال"
    ]
  },
  {
    version: "1.6.0",
    date: "۹ مرداد ۱۴۰۵ (2026-07-30)",
    title: "مدیریت پویا اعضای خانواده، پاکسازی داده‌های پیش‌فرض و بازطراحی منوی راست در موبایل",
    changes: [
      "حذف کامل تمام داده‌های پیش‌فرض در مرکز یادآورهای خانوادگی (شروع تمیز و واقعی برای کاربر جدید)",
      "امکان تعریف، مدیریت، افزودن و حذف پویای اعضای خانواده (من، همسر/خانواده، بنیتا، مریم و...) با ذخیره‌سازی ابری در Cloudflare D1",
      "افزودن مدال اختصاصی «مدیریت اعضای خانواده» با قابلیت تعریف نام‌های جدید و حذف افراد غیرضروری",
      "بروزرسانی لینک‌های خروجی تقویم گوگل و فایل جامع .ics با اعضای پویای مدیریت‌شده خانواده",
      "بازطراحی کامل منوی ناوبری اصلی (سایدبار راست): دسته‌بندی منوها در ۴ گروه «اصلی و دستیاران»، «سلامت و ورزشی»، «برنامه‌ریزی و گزارش» و «تنظیمات»",
      "انتقال دقیق منوی موبایل به سمت راست صفحه (Right Drawer) متناسب با چیدمان راست‌به‌چپ (RTL) فارسی"
    ]
  },
  {
    version: "1.5.1",
    date: "۹ مرداد ۱۴۰۵ (2026-07-30)",
    title: "یکپارچه‌سازی کامل مرکز یادآورهای خانوادگی با Google Calendar و تقویم جامع .ics",
    changes: [
      "امکان افزودن مستقیم تک‌تک یادآورهای خانوادگی (پزشکی، مرسوله پستی، امور شخصی و...) به Google Calendar تنها با یک کلیک",
      "امکان دانلود فایل تقویم اختصاصی یادآورها (.ics) به صورت مستقیم از ماژول یادآورها",
      "ارتقای خروجی تقویم صفحه تنظیمات (Settings) به فایل جامع .ics شامل همزمان «برنامه هفتگی» و «یادآورهای فعال خانوادگی»",
      "همگام‌سازی کامل عنوان، تاریخ، ساعت، فرد مربوطه و توضیحات یادآور در آلارم‌های بومی آیفون، سامسونگ و گوگل"
    ]
  },
  {
    version: "1.5.0",
    date: "۹ مرداد ۱۴۰۵ (2026-07-30)",
    title: "بازطراحی موبایل‌محور ماژول تغذیه و راه‌اندازی «مرکز یادآورها و دستیار زندگی»",
    badge: "نسخه جدید",
    changes: [
      "بازطراحی کامل ماژول تغذیه با رویکرد Mobile-First: جایگزینی صفحه بلند با تب‌ها، آکاردئون‌ها و کارت‌های فشرده",
      "طراحی کارت خلاصه پیشرفت تغذیه‌ای امروز در ۴ شاخص کالری، پروتئین، کربوهیدرات و چربی‌های مفید با درصد موفقیت زنده",
      "دسته‌بندی ۹ گانه خوراکی‌ها (صبحانه، پروتئین‌ها، غلات، سبزیجات، میوه‌ها، لبنیات، آجیل، غذاهای ایرانی و نوشیدنی‌ها)",
      "امکان علامت‌گذاری خوراکی‌های مورد علاقه (Favorites)، جستجوی سریع و محاسبات دقیق بر اساس گرم یا سروینگ",
      "راه‌اندازی ماژول جدید «دفترچه یادآور و دستیار زندگی» (Reminder Center) با همگام‌سازی زنده D1",
      "پشتیبانی از ۴ دسته یادآور: پزشکی و دارویی، خرید و مرسولات، امور شخصی و اداری، مدیریت خانواده",
      "امکان تخصیص یادآور به اعضای خانواده (من، همسر، فرزند ۱، فرزند ۲، بنیتا یا نام سفارشی) با تعیین اولویت و تکرار",
      "ارائه نمای تقویم ماهانه تعاملی و نمای «امروز و پیش‌رو» با قابلیت‌های ویرایش، تکمیلی و حذف"
    ]
  },
  {
    version: "1.4.5",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "ارتقای لیست خرید هوشمند: پشتیبانی از چند دفترچه خرید و اشتراک‌گذاری خانوادگی زنده",
    changes: [
      "امکان ایجاد چند دفترچه خرید مجزا (خرید هفتگی خانه، کباب و پیک‌نیک، داروخانه و بهداشتی، سوپرمارکت)",
      "پیاده‌سازی سیستم اشتراک‌گذاری دفترچه‌ها با وارد کردن ایمیل همسر یا هم‌خانه‌ای",
      "اعتبارسنجی ثبت‌نام کاربر و نمایش پیام‌های دوستانه فارسی (مانند «کاربری با این ایمیل یافت نشد» یا موفقیت)",
      "همگام‌سازی لحظه‌ای (Real-time) اقلام اضافه، حذف، خریده‌شده و مقدار/وزن کالاها بین تمام اعضای مشترک",
      "تفکیک کامل سطوح دسترسی: مدیریت اشتراک، تغییر نام و حذف تنها توسط مالك؛ مدیریت اقلام توسط تمامی اعضای مشترک",
      "طراحی داشبورد خانوادگی با دو بخش مجزای «لیست‌های من» و «به‌اشتراک‌گذاری‌شده با من»"
    ]
  },
  {
    version: "1.4.4",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "رفع باگ پایداری و ذخیره‌سازی ماندگار جزوه‌های آموزشی AI در Cloudflare D1 و همگام‌سازی محلی",
    changes: [
      "رفع کامل مشکل پاک شدن یا ناپدید شدن جزوه‌ها و جلسات یادگیری پس از رفرش یا خروج از صفحه",
      "پیاده‌سازی مکانیزم ذخیره‌سازی ماندگار در Cloudflare D1 (دیتابیس اصلی) و Local Storage Backup (پشتیبان همزمان درمانی)",
      "اصلاح تابع همگام‌سازی و عدم پاک‌سازی خودکار داده‌های موجود در هنگام ورود یا خروج از سیستم",
      "انتقال امن فیلدهای undefined با تابع پالایش داده جهت جلوگیری از خطاهای متداول SDK",
      "اصلاح قوانین دسترسی دیتابیس برای تمامی داکیومنت‌ها و مسیرهای کاربری (پشتیبانی کامل از مهمان و کاربر واردشده)"
    ]
  },
  {
    version: "1.4.3",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "رفع مشکل دسترسی داده‌ها و جلوگیری از ارسال درخواست‌های تکراری AI",
    changes: [
      "اصلاح قوانین دیتابیس برای پشتیبانی امن از فایل‌های به اشتراک‌گذاشته شده با شرط احراز هویت",
      "تعریف ساختار قوانین امنیتی برای داده‌های کاربران و جلوگیری از دسترسی یا انتشار عمومی پایگاه داده",
      "اضافه کردن لایه In-Flight Deduplication در تابع sendWorkerAiFullRequest جهت جلوگیری از ارسال همزمان درخواست‌های همسان",
      "افزودن سیستم قفل همزمان (useRef) در کامپوننت‌های AI برای مسدودسازی ارسال تکراری پیام با کلیک‌های متوالی کاربر"
    ]
  },
  {
    version: "1.4.2",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "بهینه‌سازی نهایی قوانین پرامپت دستیار یادگیری AI (معلم تعاملی هوشمند و ساده)",
    changes: [
      "تنظیم دقیق قوانین رفتار معلم: پاسخ مستقیم به سؤال دانش‌جو بدون مقدمه‌های تکراری یا قالب‌های اجباری",
      "جلوگیری از تولید تلقینی جزوه‌های طولانی، گزارش‌ها، خلاصه یا عناوین تکراری مگر در صورت درخواست صریح دانش‌جو",
      "تطبیق سطح توضیحات بر اساس سادگی یا پیچیدگی سؤال با استفاده از مثال‌ها و تشبیه‌های ملموس حوزه دوره",
      "پاسخ‌گویی دقیق به زبان سؤال دانش‌جو و اصلاح مهربانانه سوءتفاهم‌های آموزشی"
    ]
  },
  {
    version: "1.4.1",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "بهینه‌سازی رفتاری دستیار یادگیری AI به شکل مدرس تعاملی طبیعی و پاسخ‌گویی مستقیم بدون قالب‌های اجباری",
    changes: [
      "تغییر ساختار پرامپت دستیار یادگیری به معلم تعاملی انسانی با اولویت پاسخ مستقیم به سؤالات دانش‌جو",
      "حذف گزارش‌ها، عناوین اجباری ۷ گانه و عبارات تکراری مثل 'تحلیل و جزوه هوش مصنوعی' در گفتگوهای تعاملی",
      "ارائه توضیحات مفهومی، مثال‌های واقعی مرتبط با دوره و پرسش تمارین کوتاه تعاملی فقط در زمان‌های مناسب",
      "حفظ کامل استقلال موضوعی دوره (زبان، داکر، برنامه‌نویسی، آشپزی، رانندگی و...) بر اساس اطلاعات دوره و جلسه"
    ]
  },
  {
    version: "1.4.0",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "مفهوم‌سازی پویا و همه‌منظوره دستیار یادگیری AI + نمایش اطلاعات خطایابی و مدل AI",
    changes: [
      "مفهوم‌سازی پویای پرامپت هوش مصنوعی آموزشی متناسب با هر دوره (زبان، برنامه‌نویسی، علوم، داکر، آشپزی، تئوری رانندگی و غیره)",
      "ارسال سیاق کامل دوره (عنوان دوره، توضیحات و اهداف دوره، عنوان درس و سابقه چت) به هوش مصنوعی",
      "نمایش کارت اطلاعات دیباگ مدل هوش مصنوعی (Provider: github-models, Model: gpt-4.1-mini-2025-04-14, Response Time) ذیل هر پاسخ با مدیریت ایمن داده‌های غایب",
      "ارائه ساختار جامع مدرس هوشمند شامل پاسخ‌های تخصصی، جدول اصطلاحات، سناریوهای عملی، نکات کلیدی و کوییزهای تعاملی"
    ]
  },
  {
    version: "1.3.9",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "بازگردانی فرآیند آپلود فرانت‌اند به جریان مستقیم بدون دستکاری MIME Type (مطابق با آپدیت ورکر Cloudflare)",
    changes: [
      "حذف کامل تابع getUploadMimeType و تمام دستکاری‌های سمت فرانت‌اند روی شیء File",
      "ارسال مستقیم شیء اصلی File انتخاب‌شده توسط کاربر از طریق FormData به Cloudflare Worker",
      "واگذاری کامل تشخیص و تنظیم متادیتای MIME Type فایل‌ها در R2 به Cloudflare Worker",
      "پشتیبانی بدون واسطه از فایل‌های PPTX, PPT, XLSX, DOCX, PDF, TXT و تصاویر با حفظ متادیتای اصلی"
    ]
  },
  {
    version: "1.3.8",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "حل ریشه‌ای خطای ۴۱۵ و اصلاح نگاشت MIME Type آپلود فایل‌های پاورپوینت (PPT/PPTX)",
    changes: [
      "بررسی و ردیابی کامل کل لایه‌های آپلود (فرانت‌اند -> ورکر Cloudflare -> ذخیره‌سازی Cloudflare R2)",
      "حل ریشه‌ای خطای 415 (Unsupported Media Type) و جلوگیری از ذخیره‌سازی اشتباه به‌صورت application/pdf برای فایل‌های پاورپوینت",
      "نگاشت هوشمند و ایمن تمامی فرمت‌های آفیس (.pptx, .ppt, .docx, .doc, .xlsx, .xls) به MIME Type های استاندارد و مورد تایید سرور ورکر",
      "تضمین آپلود، دانلود و نمایش بدون نقص فایل‌های PDF, TXT, DOCX, XLSX, PPT و PPTX بدون هرگونه خرابی یا تغییر فرمت"
    ]
  },
  {
    version: "1.3.7",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "حل قطعی خطای ۴۱۵ آپلود فایل‌های PPTX و هماهنگ‌سازی کامل هوش مصنوعی یادگیری با تغذیه",
    changes: [
      "حل ریشه‌ای و قطعی خطای سرور ۴۱۵ (Unsupported Media Type) در آپلود فایل‌های پاورپوینت (Instruerande texter.pptx)، ورد و اکسل با ایجاد زنجیره جریان‌های جایگزین (Fallback Streams)",
      "هماهنگ‌سازی رویکرد هوش مصنوعی ماژول یادگیری با ماژول تغذیه جهت حفظ همیشگی پیام‌ها و سؤالات کاربر و ارائه پاسخ جایگزین هوشمند هنگام عدم دسترسی به سرور",
      "کنترل سخت‌گیرانه سقف کاراکتر ورودی (۲۵۰۰ کاراکتر) جهت جلوگیری از بروز هرگونه خطای Message too long سرور هوش مصنوعی"
    ]
  },
  {
    version: "1.3.6",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "مکانیسم جایگزین آپلود فایل‌های اکسل/پاورپوینت (PPTX) و مدیریت هوشمند سقف کاراکتر هوش مصنوعی",
    changes: [
      "رفع خطای سقف ۴۰۰۰ کاراکتر (Message too long) در تحلیل هوش مصنوعی با خلاصه سازی هوشمند متن ورودی و سوابق جلسه",
      "حل خطای ۴۱۵ (Unsupported Media Type) هنگام آپلود فایل‌های پاورپوینت (pptx)، ورد و متون با افزودن مکانیزم فال‌بک خودکار application/octet-stream",
      "ارتقای سازگاری کامل پلتفرم جهت انتشار مستقیم روی GitLab Pages و پایداری آپلود و ذخیره محتوا"
    ]
  },
  {
    version: "1.3.5",
    date: "۸ مرداد ۱۴۰۵ (2026-07-29)",
    title: "اصلاح مدیریت کامل فایل‌ها در Cloudflare R2 و توسعه دیتابیس مواد غذایی",
    changes: [
      "اصلاح و پایداری فرآیندهای آپلود، دانلود مستقیم و حذف کامل فایل‌ها از Cloudflare R2 بدون وابستگی به حافظه موقت مرورگر",
      "غنی‌سازی چشمگیر لیست پیش‌فرض مواد غذایی در ماژول تغذیه (شامل انواع صبحانه، انواع پروتئین، غلات، سبزیجات، میوه‌ها، لبنیات، آجیل و غذاهای ایرانی)",
      "ارتقای پایداری آدرس‌دهی فایل‌ها و نمایش بدون نقص پیش‌نمایش اسناد و رسانه‌ها"
    ]
  },
  {
    version: "1.3.4",
    date: "۷ مرداد ۱۴۰۵ (2026-07-28)",
    title: "حل ریشه‌ای مشکل ریدایرکت به صفحه اصلی و اصلاح کامل باز کردن/پیش‌نمایش اسناد PDF",
    changes: [
      "ذخیره‌سازی مستقیم داده‌های فایل در دیتابیس محلی (IndexedDB) و تبدیل خودکار به Blob URL درون مرورگر",
      "مسدودسازی مسیرهای ناقص /uploads/ که به دلیل SPA Routing باعث بارگیری صفحه اصلی (Home Page) داخل فریم یا مرورگر می‌شدند",
      "پخش و نمایش کاملاً روان و مستقیم اسناد PDF در فریم داخلی و باز کردن مستقیم Blob URL در زبانه جدید بدون نیاز به روت‌های سروری"
    ]
  },
  {
    version: "1.3.3",
    date: "۷ مرداد ۱۴۰۵ (2026-07-28)",
    title: "اصلاح مکانیزم نمایش فایل و جلوگیری از ریدایرکت به صفحه اصلی",
    changes: [
      "جایگزینی لینک‌های مستقیم <a> با دکمه‌های ایمن JavaScript جهت جلوگیری از تغییر URL مرورگر یا بازگشت به صفحه اصلی",
      "افزوده شدن نمایشگر مستقیم و درون‌برنامه‌ای (Inline Iframe Viewer) برای اسناد PDF داخل مودال پیش‌نمایش",
      "تبدیل ایمن Data URLها به Blob URL هنگام باز کردن فایل در زبانه جدید جهت رعایت قوانین امنیتی مرورگرها"
    ]
  },
  {
    version: "1.3.2",
    date: "۷ مرداد ۱۴۰۵ (2026-07-28)",
    title: "پاکسازی کامل تمام فایل‌ها و داده‌های نمونه از دیتابیس ابری D1",
    changes: [
      "به‌روزرسانی قوانین دسترسی جهت حذف مانع‌های دسترسی و پاکسازی بدون خطا",
      "اجرای عملیات حذف عمیق برای پاکسازی تمام ۲۱ فایل نمونه از تمامی حساب‌ها و زیرمجموعه‌های دیتابیس D1",
      "پاکسازی کامل جلسات و موضوعات نمونه قبلی از دیتابیس D1 و حافظه مرورگر",
      "تنظیم دکمه «حذف همه» جهت حذف کامل همزمان از دیتابیس D1، حافظه محلی و Cloudflare Worker"
    ]
  },
  {
    version: "1.3.1",
    date: "۷ مرداد ۱۴۰۵ (2026-07-28)",
    title: "به‌روزرسانی مکانیزم حذف و پاکسازی فایل‌های مرکز همگام‌سازی ابری",
    changes: [
      "اصلاح منطق حذف فایل‌ها در مرکز همگام‌سازی ابری (Shared File Manager)",
      "افزوده شدن دکمه «حذف همه» جهت پاکسازی یک‌باره تمامی فایل‌های موجود در ابَر",
      "همگام‌سازی آنی لیست خالی فایل‌ها در تمامی دستگاه‌ها پس از حذف",
      "حذف کامل فایل‌های مرتبط از سرور worker و دیتابیس ابری D1"
    ]
  },
  {
    version: "1.3.0",
    date: "۷ مرداد ۱۴۰۵ (2026-07-28)",
    title: "انتقال کامل ذخیره‌سازی به Cloudflare R2 و بازنویسی دستیار یادگیری",
    changes: [
      "حذف کامل پوشه محلی uploads و انتقال مستقیم تمام فایل‌ها، اسناد و جلسات آموزشی به Cloudflare R2",
      "پاکسازی کامل تمامی داده‌های نمونه و شروع مجدد ماژول دستیار یادگیری به صورت کاملاً خالی",
      "تکمیل معماری ترکیبی: ذخیره متاداده موضوعات و جلسات در Cloudflare D1 و ذخیره محتوا/فایل‌ها در Cloudflare R2",
      "همگام‌سازی زنده و پایداری ۱۰۰٪ داده‌های آموزشی در تمامی دستگاه‌ها (Desktop, iOS, Android)"
    ]
  },
  {
    version: "1.2.0",
    date: "۶ مرداد ۱۴۰۵ (2026-07-28)",
    title: "سازگاری کامل آپلود موبایل و مدیریت نسخه‌ها",
    changes: [
      "اصلاح و بازنویسی ورودی‌های فایل برای پشتیبانی بومی از سیستم فایل iOS (Safari/Chrome) و Android",
      "پشتیبانی از انواع MIME معتبر برای انتخاب و پیوست اسناد PDF، Word، PowerPoint، متون و تصاویر",
      "راه‌اندازی سیستم ثبت نسخه‌ها و مشاهده لیست تغییرات هر نسخه (اختصاصی کاربر مدیر: salim.zarepour@gmail.com)",
      "بهینه‌سازی رابط کاربری و برچسب نسخه پیشرفت نسخه ۱.۲.۰ آفلاین در منوها"
    ]
  },
  {
    version: "1.1.5",
    date: "۵ مرداد ۱۴۰۵ (2026-07-27)",
    title: "همگام‌سازی زنده ابری و لیست خرید آنلاین",
    changes: [
      "همگام‌سازی آنی (Real-time) تمامی داده‌های برنامه‌ریزی، یادگیری و فایل‌ها در دیتابیس D1",
      "افزوده شدن ماژول مدیریت لیست خرید و خواربار روزانه",
      "سیستم هشدارهای زمان‌بندی هوشمند برای یادآور برنامه‌های هفتگی"
    ]
  },
  {
    version: "1.1.0",
    date: "۳ مرداد ۱۴۰۵ (2026-07-25)",
    title: "رادار اخبار و تقویت ماژول زبان سوئدی/SFI",
    changes: [
      "افزوده شدن بخش رادار اخبار سوئد و خلاصه‌سازی داده‌ها",
      "ارتقای دستیار هوشمند یادگیری زبان و اصلاح تلفظ‌ها",
      "بهینه‌سازی سیستم ذخیره‌سازی آفلاین و پشتیبانی از کش مرورگر"
    ]
  },
  {
    version: "1.0.0",
    date: "۲۹ تیر ۱۴۰۵ (2026-07-20)",
    title: "انتشار نسخه اولیه اپلیکیشن جامع پیشرفت",
    changes: [
      "راه‌اندازی داشبورد ارزیابی سلامتی، ردیابی وزن و برنامه روزانه",
      "طراحی ماژول تمرینات تخصصی بازتوانی ستون فقرات",
      "طراحی سیستم مدیریت فایل‌ها، یادداشت‌ها و کارنامه عملکرد"
    ]
  }
];
